import { level, program, Step } from '@/interfaces/Workshop';
import { Level, Program } from '@/interfaces/Bootcamp';
import { Extracurricular } from '@/interfaces/Extracurricular';
import { slugify } from '@/functions/Slugify';
import { Article } from '@/interfaces/Article';
import { BubbleTestimony } from '@/interfaces/BubbleTestimony';
import { ProgramScheduleAll } from '@/interfaces/ProgramSchedule';
import { ProgramTypeProps, ProgramTypeV2Properties } from '@/interfaces/ProgramType';
import { SelectOptions } from '@/interfaces/RegistrationForm';
import { Testimony } from '@/interfaces/Testimony';
import { ProgramTrainer } from "@/interfaces/ProgramTrainer";

export const programTypeNew: ProgramTypeV2Properties[] = [
  {
    id: 1,
    typeCourse: 'Free Course',
    typeCourseDescription: 'Introduction to IT Programming: Unleashing your Coding Potential',
    stack: 'Video Game',
    totalPrice: 'FREE!',
    packageDescription: '1 Jam Paham Buat 2D Game via Unity Engine!',
    discountPrice: '1 JUTA!'
  },
  {
    id: 2,
    typeCourse: 'Free Course',
    typeCourseDescription: 'Introduction to IT Programming: Unleashing your Coding Potential',
    stack: 'Front-End Website',
    totalPrice: 'FREE!',
    packageDescription: '1 Jam Paham Buat Front-End Web via Coding!',
    discountPrice: '1 JUTA!'
  },
  {
    id: 3,
    typeCourse: 'Free Course',
    typeCourseDescription: 'Introduction to IT Programming: Unleashing your Coding Potential',
    stack: 'Back-End Website',
    totalPrice: 'FREE!',
    packageDescription: '1 Jam Paham Web API terintegrasi via Coding!',
    discountPrice: '1 JUTA!'
  },
  {
    id: 4,
    typeCourse: 'Free Course',
    typeCourseDescription: 'Introduction to IT Programming: Unleashing your Coding Potential',
    stack: 'Mobile Application',
    totalPrice: 'FREE!',
    packageDescription: '1 Jam Paham Buat Mobile Application via Coding!',
    discountPrice: '1 JUTA!'
  },
  {
    id: 5,
    typeCourse: 'Workshop',
    typeCourseDescription: 'Coding Kickstart: An Interactive Workshop for IT Programmer Beginners',
    stack: 'Video Game',
    totalPrice: 'Rp 560.000',
    packageDescription: '2 Hari Dibimbing Buat 2D Game via Coding Pertamamu!',
    packageSubdescription: 'Belajar coding + project video game? Workshop Murah rasa Bootcamp?!',
    discountPrice: '6 JUTA!'
  },
  {
    id: 6,
    typeCourse: 'Workshop',
    typeCourseDescription: 'Coding Kickstart: An Interactive Workshop for IT Programmer Beginners',
    stack: 'Front-End Website',
    totalPrice: 'Rp 280.000',
    packageDescription: '2 Hari Dibimbing Buat Front-End Web via Coding Pertamamu!',
    packageSubdescription: 'Belajar coding + project front-end website? Workshop Murah rasa Bootcamp?!',
    discountPrice: '2 JUTA!'
  },
  {
    id: 7,
    typeCourse: 'Workshop',
    typeCourseDescription: 'Coding Kickstart: An Interactive Workshop for IT Programmer Beginners',
    stack: 'Back-End Website',
    totalPrice: 'Rp 560.000',
    packageDescription: '2 Hari Dibimbing Buat Web API interaktif Pertamamu!',
    packageSubdescription: 'Belajar coding + project back-end website? Workshop Murah rasa Bootcamp?!',
    discountPrice: '6 JUTA!'
  },
  {
    id: 8,
    typeCourse: 'Workshop',
    typeCourseDescription: 'Coding Kickstart: An Interactive Workshop for IT Programmer Beginners',
    stack: 'Mobile Application',
    totalPrice: 'Rp 560.000',
    packageDescription: '2 Hari Dibimbing Buat Mobile Application (Android & iOS) Pertamamu!',
    packageSubdescription: 'Belajar coding + project mobile app? Workshop Murah rasa Bootcamp?!',
    discountPrice: '7 JUTA!'
  },
  {
    id: 9,
    typeCourse: 'Bootcamp',
    typeCourseDescription: 'From Zero to IT Hero: A Beginner\'s Guide to IT Development',
    stack: 'Full Stack Engineer Website and Mobile Application',
    totalPrice: 'Rp 8.850.000',
    packageDescription: '8 Minggu (320 jam belajar) Jadi Full Stack Engineer',
    packageSubdescription: '',
    discountPrice: '',
  },
]

export const programType: ProgramTypeProps[] = [
  {
    id: 1,
    packageType: 'Standard',
    stack: 'Backend',
    totalPrice: 5200000,
    classDuration: '4 Bulan',
    discountPrice: null,
  },
  {
    id: 2,
    packageType: 'Standard',
    stack: 'Front-End',
    totalPrice: 5200000,
    classDuration: '4 Bulan',
    discountPrice: null,
  },
  {
    id: 3,
    packageType: 'Standard',
    stack: 'Front-End Mobile',
    totalPrice: 5200000,
    classDuration: '4 Bulan',
    discountPrice: null,
  },
  {
    id: 4,
    packageType: 'Hemat',
    stack: 'Fullstack Web',
    totalPrice: 9600000,
    classDuration: '4 Bulan',
    discountPrice: '800 ribu!',
  },
  {
    id: 5,
    packageType: 'Hemat',
    stack: 'Fullstack Mobile',
    totalPrice: 9600000,
    classDuration: '4 Bulan',
    discountPrice: '800 ribu!',
  },
  {
    id: 6,
    packageType: 'Lengkap',
    stack: 'Fullstack Web & Mobile',
    totalPrice: 13600000,
    classDuration: '4 Bulan',
    discountPrice: '2 juta!',
  },
];

export const programSchedule: ProgramScheduleAll = {
  standard: [
    {
      id: 1,
      packageType: 'Standard',
      stack: 'Backend',
      days: 'Senin - Jumat',
      time: '09.00-12.00 WIB',
    },
    {
      id: 2,
      packageType: 'Standard',
      stack: 'Front-End',
      days: 'Senin - Jumat',
      time: '09.00-12.00 WIB',
    },
    {
      id: 3,
      packageType: 'Standard',
      stack: 'Front-End Mobile',
      days: 'Senin - Jumat',
      time: '09.00-12.00 WIB',
    },
  ],
  economic: [
    {
      id: 4,
      packageType: 'Hemat',
      stack: 'Fullstack Web',
      days: 'Senin - Jumat',
      time: '09.00-14.00 WIB',
    },
    {
      id: 5,
      packageType: 'Hemat',
      stack: 'Fullstack Mobile',
      days: 'Senin - Jumat',
      time: '09.00-14.00 WIB',
    },
  ],
  full: [
    {
      id: 6,
      packageType: 'Lengkap',
      stack: 'Fullstack Web & Mobile',
      days: 'Senin - Jumat',
      time: '09.00-17.00 WIB',
    },
  ],
};

export const documentations = [
  {
    src: 'img/home/documentations-2.jpeg',
    description: 'Seleksi Peserta Internship Batch 1 Tahun 2017',
  },
  {
    src: 'img/home/documentations-3.jpg',
    description: 'Acara Closing Internship Batch 3 Tahun 2018',
  },
  {
    src: 'img/home/documentations-1.jpg',
    description: 'Training Offline Batch 3 Tahun 2019',
  },
  {
    src: 'img/home/documentations-6.png',
    description: 'Training Batch 5 Tahun 2021 Pemrograman',
  },
  {
    src: 'img/home/documentations-4.png',
    description: 'Training Batch 5 Tahun 2021 Scaling Traditional SQL',
  },
  {
    src: 'img/home/documentations-5.png',
    description: 'Training Batch 5 Tahun 2021 Performance Test Using JMeter',
  },
  {
    src: 'img/home/documentations-6.png',
    description: 'Accelist Internship 2020-2021',
  },
  {
    src: 'img/home/documentations-8.png',
    description: 'Accelist Internship 2022-2023',
  },
  {
    src: 'img/home/documentations-9.png',
    description: 'Private Workshop Mobile Application 2023-2024',
  },
  {
    src: 'img/home/documentations-10.png',
    description: 'Private Workshop Video Games 2023-2024',
  },
  {
    src: 'img/home/documentations-11.png',
    description: 'Private Workshop Website 2023-2024',
  },
  {
    src: 'img/home/documentations-13.png',
    description: 'Training LMS AEDU x Majelis Pendidikan Kristen 2023',
  },
  {
    src: 'img/home/documentations-14.png',
    description: 'Webinar Back-End 12 September 2023',
  },
  {
    src: 'img/home/documentations-15.png',
    description: 'Webinar Front-End 21 Augustus 2023',
  },
  {
    src: 'img/home/documentations-16.png',
    description: 'Webinar IT AEDU x Majelis Pendidikan Kristen',
  },
  {
    src: 'img/home/documentations-17.png',
    description: 'Webinar Mobile Application 12 Desember 2023',
  },
  {
    src: 'img/home/documentations-18.png',
    description: 'Webinar Mobile Application 13 Desember 2023',
  },
  {
    src: 'img/home/documentations-19.png',
    description: 'Webinar Video Game 11 September 2023',
  },
  {
    src: 'img/home/documentations-7.JPG',
    description: 'Accelist Internship 2024-2025',
  },
];

export const listCurrentStatus: SelectOptions<string>[] = [
  {
    label: 'Mahasiswa',
    value: 'Mahasiswa',
  },
  {
    label: 'Sedang Mencari Kerja',
    value: 'Sedang Mencari Kerja',
  },
  {
    label: 'Sekolah Aktif',
    value: 'Sekolah Aktif',
  },
  {
    label: 'Pelaku Usaha',
    value: 'Pelaku Usaha',
  },
  {
    label: 'Freelancer',
    value: 'Freelancer',
  },
  {
    label: 'Lainnya',
    value: 'Lainnya'
  }
]

export const listReasonToJoinProgram: SelectOptions<string>[] = [
  {
    label: 'Ingin Belajar dan Dapat Kerja',
    value: 'Ingin Belajar dan Dapat Kerja',
  },
  {
    label: 'Ingin Belajar dengan Bimbingan Mentor',
    value: 'Ingin Belajar dengan Bimbingan Mentor',
  },
  {
    label: 'Ingin Mendapatkan Ilmu Baru',
    value: 'Ingin Mendapatkan Ilmu Baru',
  },
  {
    label: 'Ingin Dapat Kerja',
    value: 'Ingin Dapat Kerja',
  },
  {
    label: 'Lainnya',
    value: 'Lainnya'
  }
]

export const hasLaptopOptions: SelectOptions<string>[] = [
  { label: 'Ya', value: 'Ya' },
  { label: 'Tidak', value: 'Tidak' }
]

export const informationSourceList: SelectOptions<string>[] = [
  { label: 'WhatsApp', value: 'WhatsApp' },
  { label: 'Telegram', value: 'Telegram' },
  { label: 'Instagram', value: 'Instagram' },
  { label: 'Facebook', value: 'Facebook' },
  { label: 'Website', value: 'Website' },
  { label: 'LinkedIn', value: 'LinkedIn' },
  { label: 'Referensi Teman', value: 'Referensi Teman' },
  { label: 'Lainnya', value: 'Lainnya' },
]

export const holdingPartnersImageSrc: string[] = [
  'img/home/agit.png',
  'img/home/astra-isuzu.png',
  'img/home/astra-international.png',
  'img/home/baker-mckenzie.png',
  'img/home/bca-life.png',
  'img/home/binus-creates.png',
  'img/home/bmkg.png',
  'img/home/cas-destination.png',
  'img/home/gapura.png',
  'img/home/coca-cola.png',
  'img/home/manulife.png',
  'img/home/sera.png',
  'img/home/trac.png',
  'img/home/pt-surya-madistrindo.png',
  'img/home/sosro.png',
  'img/home/toyota-tsusho.png',
  'img/home/toyota-astra-motor.png',
  'img/home/zurich.png',
  'img/home/mpk.png',
  'img/home/kemnaker.png',
  'img/home/iit-logo.png',
  'img/home/binus-logo.png',
];

export const testimony: Testimony[] = [
  {
    id: 1,
    name: 'Fiona Varencia',
    batch: '7',
    tetimony:
      '“Selama melakukan kegiatan magang di Accelist, saya terlibat dalam proyek menarik dan belajar banyak dari rekan-rekan berpengalaman. Meskipun ada tekanan, tantangan tersebut membantu saya tumbuh dan belajar menghadapi situasi yang menantang. Terima kasih kepada seluruh tim Accelist atas dukungan dan pengalaman yang luar biasa.”',
    imageSrc: 'img/home/testimoni-1.jpeg',
  },
  {
    id: 2,
    name: 'Ryan Frederick',
    batch: '7',
    tetimony:
      '“ Training di Accelist menurutku sangat membantu untuk memahami teknik pemrograman yang digunakan di perusahaan, karena selama kuliah sulit mencari real case untuk diterapkan di dunia kerja dan waktu baru masuk bingung banget apa yang perlu dipelajari, mulai darimana. Tapi dari tim dan atasan Accelist, kami di training dari awal mulai dari hal ter-basic menggunakan Visual Studio, C#, HTML, CSS, sampai ke hal yang cukup advanced seperti metode MVC, validasi, injection, yang akhirnya membuat saya mampu membuat API dan web ketika lepas dari training tersebut.”',
    imageSrc: 'img/home/testimoni-5.jpeg',
  },
  {
    id: 3,
    name: 'Revin Hermawan',
    batch: '7',
    tetimony:
      '"Program Magang di Accelist berkesan sekali, projek - projeknya melatih dan meningkatkan skill saya baik softskill maupun hardskill."',
    imageSrc: 'img/home/testimoni-2.jpeg',
  },
  {
    id: 4,
    name: 'Gabrielle Angelica',
    batch: '7',
    tetimony:
      '“Belajar IT di Accelist recommended banget, dari belum ngerti apa-apa, sampai akhirnya punya skill yang berguna untuk di dunia perkuliahan maupun pekerjaan! Materi dan metode yang diajarkan juga mudah dimengerti.”',
    imageSrc: 'img/home/testimoni-3.jpeg',
  },
  {
    id: 5,
    name: 'Lyvia Cornelia',
    batch: '7',
    tetimony:
      '“Saya sangat senang bisa mendapatkan pengalaman training di Accelist, berkat Accelist saya dapat memahami ilmu-ilmu pemrograman dari awal yang belum pernah saya pelajari sebelumnya di kampus.”',
    imageSrc: 'img/home/testimoni-4.jpeg',
  },
  {
    id: 6,
    name: 'Abbiel Epaphroditus Sariwating',
    batch: '3',
    tetimony:
      '“Magang di Accelist adalah pengalaman pertama saya terjun langsung ke dunia kerja IT. Saya belajar banyak tentang teamwork, coding standar industri, dan cara menyelesaikan masalah secara mandiri. Terima kasih Accelist!”',
    imageSrc: 'img/home/testimony/testimoni-6.jpeg',
  },
  {
    id: 7,
    name: 'Achmad Afifudin',
    batch: '3',
    tetimony:
      '“Awalnya saya merasa kurang percaya diri dengan kemampuan saya, tapi pelatihan dari Accelist sangat membantu. Penjelasan mentornya jelas dan sabar, sekarang saya jauh lebih yakin untuk melangkah ke dunia profesional”',
    imageSrc: 'img/home/testimony/testimoni-7.jpeg',
  },
  {
    id: 8,
    name: 'Ari Miswanti',
    batch: '3',
    tetimony:
      '“Pengalaman training di Accelist membuka wawasan saya tentang alur kerja di dunia nyata. Tidak hanya belajar teknis, saya juga dilatih berpikir kritis dan komunikatif dalam tim.”',
    imageSrc: 'img/home/testimony/testimoni-8.jpg',
  },
  {
    id: 9,
    name: 'Benny',
    batch: '3',
    tetimony:
      '“Accelist memberikan saya pengalaman berharga untuk bekerja dengan teknologi terkini. Bimbingan dari mentor membuat saya lebih paham penerapan coding yang baik dan benar.”',
    imageSrc: 'img/home/testimony/testimoni-9.jpg',
  },
  {
    id: 10,
    name: 'Bryand',
    batch: '2',
    tetimony:
      '“Selama program magang, saya merasa sangat didukung. Setiap kesalahan dijadikan bahan pembelajaran, bukan sekadar koreksi. Saya jadi lebih berkembang dari hari ke hari.”',
    imageSrc: 'img/home/testimony/testimoni-10.jpg',
  },
  {
    id: 11,
    name: 'Callysta Nadia Putri Prasetya',
    batch: '3',
    tetimony:
      '“Training yang diberikan sangat sistematis, mulai dari pengenalan tools hingga ke praktik langsung. Bahkan saya yang dulunya belum tahu apa itu API, sekarang sudah bisa membuatnya!”',
    imageSrc: 'img/home/testimony/testimoni-11.jpg',
  },
  {
    id: 12,
    name: 'Cornelio Abdimash Christiono',
    batch: '2',
    tetimony:
      '“Accelist bukan hanya tempat belajar teknikal skill, tapi juga soft skill seperti komunikasi dan manajemen waktu. Semua ini sangat berguna dalam kehidupan profesional saya.”',
    imageSrc: 'img/home/testimony/testimoni-12.jpg',
  },
  {
    id: 13,
    name: 'Devindre Michael Widelyne',
    batch: '3',
    tetimony:
      '“Program magang ini sangat membuka mata saya tentang pentingnya dokumentasi dan testing dalam pengembangan software. Sesuatu yang jarang saya temui di perkuliahan.”',
    imageSrc: 'img/home/testimony/testimoni-13.jpg',
  },
  {
    id: 14,
    name: 'Dormauli Feronika R.G',
    batch: '3',
    tetimony:
      '“Dari tidak tahu sama sekali soal MVC dan C#, kini saya bisa membuat aplikasi CRUD dengan baik. Semua itu berkat training terstruktur di Accelist.”',
    imageSrc: 'img/home/testimony/testimoni-14.jpg',
  },
  {
    id: 15,
    name: 'Eka Magdalena',
    batch: '3',
    tetimony:
      '“Mentor-mentor di Accelist sangat membantu, selalu siap memberikan feedback dan arahan. Budayanya juga suportif, membuat saya nyaman untuk terus belajar.”',
    imageSrc: 'img/home/testimony/testimoni-15.jpg',
  },
  {
    id: 16,
    name: 'Elpafras Dri Handoko',
    batch: '3',
    tetimony:
      '“Program magang di Accelist bikin saya lebih disiplin dan bertanggung jawab. Saya belajar mengelola waktu antara tugas dan pembelajaran teknis yang diberikan.”',
    imageSrc: 'img/home/testimony/testimoni-16.jpg',
  },
  {
    id: 17,
    name: 'Fransiskus Derren Livio',
    batch: '3',
    tetimony:
      '“Awalnya saya bingung dengan workflow project, tapi setelah beberapa minggu di Accelist, saya mulai terbiasa dan akhirnya paham bagaimana mengelola repository dengan Git.”',
    imageSrc: 'img/home/testimony/testimoni-17.jpeg',
  },
  {
    id: 18,
    name: 'Hairani Kaban',
    batch: '3',
    tetimony:
      '“Training Accelist sangat hands-on. Kita langsung praktik bikin aplikasi nyata, bukan cuma teori doang. Itu sangat membantu pemahaman saya.”',
    imageSrc: 'img/home/testimony/testimoni-18.jpeg',
  },
  {
    id: 19,
    name: 'Herdemei Saerang',
    batch: '3',
    tetimony:
      '“Selama magang, saya belajar banyak tentang komunikasi tim, terutama saat daily stand-up. Pengalaman ini nggak saya dapatkan di bangku kuliah.”',
    imageSrc: 'img/home/testimony/testimoni-19.jpg',
  },
  {
    id: 20,
    name: 'Hillarius Yuan Ivo Kurniawan',
    batch: '2',
    tetimony:
      '“Bersama Accelist, saya jadi paham bahwa debugging bukan sekadar cari error, tapi juga soal logika dan ketelitian. Ini jadi skill penting buat saya sekarang.”',
    imageSrc: 'img/home/testimony/testimoni-20.jpg',
  },
  {
    id: 21,
    name: 'Iqbal Baihaqi Abdulah',
    batch: '3',
    tetimony:
      '“Mentornya sabar dan selalu terbuka untuk ditanya. Walaupun pertanyaan saya kadang dasar banget, tetap dijelaskan dengan baik dan nggak bikin malu.”',
    imageSrc: 'img/home/testimony/testimoni-21.jpg',
  },
  {
    id: 22,
    name: 'Janssen Ivan',
    batch: '3',
    tetimony:
      '“Saya dulu gak suka front-end, tapi di Accelist malah ketemu passion di situ. Dikasih tantangan bikin UI dari figma ke HTML/CSS dan ternyata saya suka.”',
    imageSrc: 'img/home/testimony/testimoni-22.jpg',
  },
  {
    id: 23,
    name: 'Johanes Yoga Restu Kristiaji',
    batch: '2',
    tetimony:
      '“Accelist ngajarin saya pentingnya clean code dan code review. Hal ini sangat berguna setelah saya mulai kerja di tempat lain.”',
    imageSrc: 'img/home/testimony/testimoni-23.jpg',
  },
  {
    id: 24,
    name: 'Julianita Trinawati',
    batch: '3',
    tetimony:
      '“Yang saya suka dari Accelist adalah suasananya yang profesional tapi tetap nyaman. Saya merasa dihargai dan dilibatkan dalam tim.”',
    imageSrc: 'img/home/testimony/testimoni-24.jpg',
  },
  {
    id: 25,
    name: 'Louise Tamariska Utami',
    batch: '3',
    tetimony:
      '“Selama training, saya dibimbing membuat REST API dengan C# dan database SQL Server. Sebelumnya saya gak kebayang bisa bikin backend sendiri.”',
    imageSrc: 'img/home/testimony/testimoni-25.jpg',
  },
  {
    id: 26,
    name: 'Mega Sukma Dewi',
    batch: '3',
    tetimony:
      '“Accelist memberikan pembelajaran bertahap, dari yang paling dasar hingga ke advanced. Ini sangat membantu bagi pemula seperti saya.”',
    imageSrc: 'img/home/testimony/testimoni-26.jpeg',
  },
  {
    id: 27,
    name: 'Muh.Rusli',
    batch: '3',
    tetimony:
      '“Magang di Accelist membuat saya lebih percaya diri menghadapi wawancara kerja karena sudah punya pengalaman langsung bikin aplikasi.”',
    imageSrc: 'img/home/testimony/testimoni-27.jpg',
  },
  {
    id: 28,
    name: 'Muhammad abdurrafi',
    batch: '3',
    tetimony:
      '“Selain materi teknis, saya juga belajar membuat dokumentasi teknikal yang baik dan rapi. Ini penting banget di dunia kerja.”',
    imageSrc: 'img/home/testimony/testimoni-28.jpg',
  },
  {
    id: 29,
    name: 'Nabilah Ananda Putri',
    batch: '3',
    tetimony:
      '“Trainingnya runut dan terstruktur. Saya gak pernah merasa ketinggalan karena selalu ada mentor yang membimbing”',
    imageSrc: 'img/home/testimony/testimoni-29.jpg',
  },
  {
    id: 30,
    name: 'Natalia Fajar Kusuma Astuti',
    batch: '3',
    tetimony:
      '“Magang di Accelist jadi turning point buat saya yang semula ragu masuk dunia IT. Sekarang saya mantap lanjut di bidang ini.”',
    imageSrc: 'img/home/testimony/testimoni-30.jpg',
  },
  {
    id: 31,
    name: 'Nehemia Meirardfeldin K.',
    batch: '3',
    tetimony:
      '“Accelist mengajarkan saya pentingnya kolaborasi. Saya belajar kerja dalam tim dan saling mereview pekerjaan rekan satu kelompok.”',
    imageSrc: 'img/home/testimony/testimoni-31.jpg',
  },
  {
    id: 32,
    name: 'Oscar Tjahjadi ',
    batch: '3',
    tetimony:
      '“Di sini saya nggak cuma disuruh belajar, tapi juga diberi proyek nyata untuk dikerjakan. Itu sangat meningkatkan kemampuan saya.”',
    imageSrc: 'img/home/testimony/testimoni-32.jpg',
  },
  {
    id: 33,
    name: 'Otavia Ulandari',
    batch: '3',
    tetimony:
      '“Atmosfer di Accelist membuat saya nyaman bertanya dan berdiskusi. Saya nggak takut salah karena selalu dibimbing.”',
    imageSrc: 'img/home/testimony/testimoni-33.jpg',
  },
  {
    id: 34,
    name: 'Otniel Owen H',
    batch: '3',
    tetimony:
      '“Dari training di Accelist, saya belajar best practice dalam membuat aplikasi web. Saya jadi lebih rapi dan profesional dalam menulis kode.”',
    imageSrc: 'img/home/testimony/testimoni-34.jpg',
  },
  {
    id: 35,
    name: 'Paulinus Eko Purwanto',
    batch: '3',
    tetimony:
      '“Accelist memperkenalkan saya pada teknologi yang selama ini cuma saya dengar namanya saja. Sekarang saya sudah bisa pakai dengan percaya diri.”',
    imageSrc: 'img/home/testimony/testimoni-35.jpg',
  },
  {
    id: 36,
    name: 'Ridho Gilang Bening',
    batch: '3',
    tetimony:
      '“Program training di Accelist sangat berorientasi pada praktik langsung. Saya tidak hanya paham teori, tapi juga tahu implementasinya.”',
    imageSrc: 'img/home/testimony/testimoni-36.jpg',
  },
  {
    id: 37,
    name: 'Rizky Setya Raga',
    batch: '3',
    tetimony:
      '“Mentornya sangat ramah dan mendampingi tiap langkah saya. Saya merasa diperhatikan dan tidak dibiarkan bingung sendiri.”',
    imageSrc: 'img/home/testimony/testimoni-37.jpeg',
  },
  {
    id: 38,
    name: 'Samuel Joseph Wijaya',
    batch: '3',
    tetimony:
      '“Materi training Accelist membahas banyak aspek dari software development, termasuk testing dan deployment. Ilmu yang sangat berguna.”',
    imageSrc: 'img/home/testimony/testimoni-38.jpeg',
  },
  {
    id: 39,
    name: 'Septianah',
    batch: '3',
    tetimony:
      '“Selama magang, saya belajar membuat aplikasi berbasis MVC dari nol sampai selesai. Itu pencapaian besar buat saya.”',
    imageSrc: 'img/home/testimony/testimoni-39.jpg',
  },
  {
    id: 40,
    name: 'Souw, Leonardo Eric Hadiyanto',
    batch: '3',
    tetimony:
      '“Training-nya membuat saya lebih siap menghadapi dunia kerja. Bahkan sekarang saya bisa membantu teman kuliah memahami hal-hal teknis.”',
    imageSrc: 'img/home/testimony/testimoni-40.jpg',
  },
  {
    id: 41,
    name: 'Susianti',
    batch: '3',
    tetimony:
      '“Accelist benar-benar memperhatikan perkembangan peserta magangnya. Setiap progres saya dievaluasi dan diberi masukan membangun.”',
    imageSrc: 'img/home/testimony/testimoni-41.jpg',
  },
  {
    id: 42,
    name: 'Suwandi',
    batch: '3',
    tetimony:
      '“Saya sangat menghargai kesempatan belajar di Accelist. Tidak hanya teknikal, tapi juga attitude profesional yang dibentuk.”',
    imageSrc: 'img/home/testimony/testimoni-42.jpg',
  },
  {
    id: 43,
    name: 'Viki Bagus Satria Aji',
    batch: '3',
    tetimony:
      '“Magang di Accelist memperluas jaringan saya. Saya bertemu banyak teman seangkatan yang juga semangat belajar.”',
    imageSrc: 'img/home/testimony/testimoni-43.jpg',
  },
  {
    id: 44,
    name: 'Wahyu Raffli Adikusuma',
    batch: '3',
    tetimony:
      '“Terima kasih Accelist, karena sudah membekali saya dengan skill dan pengalaman nyata. Sekarang saya lebih siap masuk dunia kerja.”',
    imageSrc: 'img/home/testimony/testimoni-44.jpg',
  },
  {
    id: 45,
    name: 'Widio Harsono',
    batch: '3',
    tetimony:
      '“Program training ini membuat saya berani apply kerja ke startup dan alhamdulillah keterima karena sudah punya pengalaman dari Accelist.”',
    imageSrc: 'img/home/testimony/testimoni-45.jpg',
  },
  // {
  //     id: 46,
  //     name: '',
  //     batch: '3',
  //     tetimony:
  //         '“”',
  //     imageSrc: 'img/home/testimony/testimoni-46.jpg',
  // },
  // {
  //     id: 47,
  //     name: '',
  //     batch: '3',
  //     tetimony:
  //         '“”',
  //     imageSrc: 'img/home/testimony/testimoni-47.jpg',
  // },
  // {
  //     id: 48,
  //     name: '',
  //     batch: '3',
  //     tetimony:
  //         '“”',
  //     imageSrc: 'img/home/testimony/testimoni-48.jpg',
  // },
  // {
  //     id: 49,
  //     name: '',
  //     batch: '3',
  //     tetimony:
  //         '“”',
  //     imageSrc: 'img/home/testimony/testimoni-49.jpg',
  // },
  // {
  //     id: 50,
  //     name: '',
  //     batch: '3',
  //     tetimony:
  //         '“”',
  //     imageSrc: 'img/home/testimony/testimoni-50.jpg',
  // },
];

export const bubbleTestimony: BubbleTestimony[] = [
  { id: 1, testimony: "Magang di Accelist seru banget! Aku jadi lebih paham dunia kerja nyata, mentor-mentornya juga sabar banget ngajarin." },
  { id: 2, testimony: "Pengalaman magang di sini tuh priceless. Banyak dapet ilmu praktis yang nggak diajarin di kampus." },
  { id: 3, testimony: "Awalnya takut, tapi setelah jalanin magang di Accelist, rasanya kayak keluarga sendiri. Supportive semua orangnya." },
  { id: 4, testimony: "Di Accelist aku belajar teamwork, leadership, dan coding beneran di project real. Recommended banget buat mahasiswa IT!" },
  { id: 5, testimony: "Magang di sini bener-bener ngelatih problem solving. Setiap hari ada tantangan baru, tapi itu justru seru!" },
  { id: 6, testimony: "Kantor nyaman, budaya kerja asik, mentor nggak pelit ilmu. Gak nyesel magang di Accelist." },
  { id: 7, testimony: "Magang di Accelist itu beyond expectation! Ilmu yang aku dapat jauh lebih banyak dari yang aku kira." },
  { id: 8, testimony: "Pastiin kamu aktif tanya kalau magang di Accelist, karena mereka sangat open buat diskusi apa pun!" },
  { id: 9, testimony: "Dari awal onboarding sampai selesai magang, aku merasa di-guidance banget. Sistematis dan care." },
  { id: 10, testimony: "Magang di Accelist ngebuka mataku soal pentingnya komunikasi di dunia kerja. Gak cuma coding!" },
  { id: 11, testimony: "Accelist ngajarin aku tentang agile, scrum, dan kolaborasi tim yang sebenarnya. Pengalaman berharga!" },
  { id: 12, testimony: "Bisa hands-on langsung ke project client itu pengalaman luar biasa. Magang di Accelist tuh beda!" },
  { id: 13, testimony: "Seru sih, banyak event internal juga. Jadi selain kerja, networking antar intern juga jalan!" },
  { id: 14, testimony: "Budaya perusahaan di Accelist bikin aku betah magang. Ada semangat kerja tapi tetap santai." },
  { id: 15, testimony: "Mentornya keren, beneran mau bantu intern buat berkembang. Terasa dihargai walaupun masih belajar." },
  { id: 16, testimony: "Magang pertama aku dan langsung jatuh cinta sama dunia kerja IT. Thanks Accelist!" },
  { id: 17, testimony: "Deadline project tight, tapi teamwork yang solid bikin semuanya lebih manageable." },
  { id: 18, testimony: "Aku belajar banyak tentang version control, clean code, dan best practice coding di sini." },
  { id: 19, testimony: "Internship di Accelist ngajarin aku tentang pentingnya feedback dan continuous improvement." },
  { id: 20, testimony: "Buat yang mau belajar dunia kerja IT beneran, Accelist jawabannya. Bukan sekadar magang biasa." },
  { id: 21, testimony: "Yang paling aku suka, setiap intern itu dianggap penting. Ada kesempatan buat speak up." },
  { id: 22, testimony: "Berkat magang di Accelist, aku lebih siap buat masuk ke dunia kerja setelah lulus." },
  { id: 23, testimony: "Suka banget suasana hybrid working-nya. Fleksibel tapi tetap produktif." },
  { id: 24, testimony: "Dikasih kepercayaan untuk pegang tugas-tugas penting, bikin aku merasa berkembang." },
  { id: 25, testimony: "Magang di Accelist bikin aku sadar, soft skill itu sama pentingnya dengan hard skill." },
  { id: 26, testimony: "Gak cuma disuruh ngerjain, tapi juga dikasih coaching buat ngembangin karir kedepannya." },
  { id: 27, testimony: "Magang terbaik sejauh ini. Temen-temen intern lain juga asik, banyak kolaborasi seru." },
  { id: 28, testimony: "Setiap minggu ada catch up bareng mentor. Bisa sharing progress dan diskusi kendala." },
  { id: 29, testimony: "Accelist beneran peduli sama growth intern. Gak cuma disuruh kerja doang." },
  { id: 30, testimony: "Paling berkesan: kesempatan buat presentasi project intern ke manajemen. Jadi tambah pede!" },
];

export const ColorPalette = {
  primaryBlack100: '#1E293B',
  primaryBlack80: '#4B5462',
  primaryBlack60: '#787F89',
  primaryBlack30: '#BCBFC5',
  primaryBlack10: '#E9EAEC',
  primaryGreen100: '#0D9488',
  primaryGreen80: '#3DA9A0',
  primaryGreen60: '#6EBFB8',
  primaryGreen30: '#B7DFDC',
  primaryGreen10: '#E7F5F4',
  primaryWhite: '#F8FAFC',
  alertPrimary: '#1D93FF',
  alertDanger: '#CE3636',
  alertSuccess: '#0D9488',
  alertWarning: '#F5B307',
};

export const indonesiaRegion = [
  {
    provinsi: "Aceh",
    kota: [
      "Kota Banda Aceh",
      "Kota Sabang",
      "Kota Lhokseumawe",
      "Kota Langsa",
      "Kota Subulussalam",
      "Kab. Aceh Selatan",
      "Kab. Aceh Tenggara",
      "Kab. Aceh Timur",
      "Kab. Aceh Tengah",
      "Kab. Aceh Barat",
      "Kab. Aceh Besar",
      "Kab. Pidie",
      "Kab. Aceh Utara",
      "Kab. Simeulue",
      "Kab. Aceh Singkil",
      "Kab. Bireun",
      "Kab. Aceh Barat Daya",
      "Kab. Gayo Lues",
      "Kab. Aceh Jaya",
      "Kab. Nagan Raya",
      "Kab. Aceh Tamiang",
      "Kab. Bener Meriah",
      "Kab. Pidie Jaya"
    ]
  },
  {
    provinsi: "Sumatera Utara",
    kota: [
      "Kota Medan",
      "Kota Pematang Siantar",
      "Kota Sibolga",
      "Kota Tanjung Balai",
      "Kota Binjai",
      "Kota Tebing Tinggi",
      "Kota Padang Sidempuan",
      "Kota Gunung Sitoli",
      "Kab. Serdang Bedagai",
      "Kab. Samosir ",
      "Kab. Humbang Hasundutan",
      "Kab. Pakpak Bharat",
      "Kab. Nias Selatan",
      "Kab. Mandailing Natal",
      "Kab. Toba Samosir",
      "Kab. Dairi",
      "Kab. Labuhan Batu",
      "Kab. Asahan",
      "Kab. Simalungun",
      "Kab. Deli Serdang",
      "Kab. Karo",
      "Kab. Langkat",
      "Kab. Nias",
      "Kab. Tapanuli Selatan",
      "Kab. Tapanuli Utara",
      "Kab. Tapanuli Tengah",
      "Kab. Batu Bara",
      "Kab. Padang Lawas Utara",
      "Kab. Padang Lawas",
      "Kab. Labuhanbatu Selatan",
      "Kab. Labuhanbatu Utara",
      "Kab. Nias Utara",
      "Kab. Nias Barat"
    ]
  },
  {
    provinsi: "Sumatera Barat",
    kota: [
      "Kota Padang",
      "Kota Solok",
      "Kota Sawhlunto",
      "Kota Padang Panjang",
      "Kota Bukittinggi",
      "Kota Payakumbuh",
      "Kota Pariaman",
      "Kab. Pasaman Barat",
      "Kab. Solok Selatan",
      "Kab. Dharmasraya",
      "Kab. Kepulauan Mentawai",
      "Kab. Pasaman",
      "Kab. Lima Puluh Kota",
      "Kab. Agam",
      "Kab. Padang Pariaman",
      "Kab. Tanah Datar",
      "Kab. Sijunjung",
      "Kab. Solok",
      "Kab. Pesisir Selatan"
    ]
  },
  {
    provinsi: "Riau",
    kota: [
      "Kota Pekan Baru",
      "Kota Dumai",
      "Kab. Kepulauan Meranti",
      "Kab. Kuantan Singingi",
      "Kab. Siak",
      "Kab. Rokan Hilir",
      "Kab. Rokan Hulu",
      "Kab. Pelalawan",
      "Kab. Indragiri Hilir",
      "Kab. Bengkalis",
      "Kab. Indragiri Hulu",
      "Kab. Kampar"
    ]
  },
  {
    provinsi: "Jambi",
    kota: [
      "Kota Jambi",
      "Kota Sungai Penuh",
      "Kab. Tebo",
      "Kab. Bungo",
      "Kab. Tanjung Jabung Timur",
      "Kab. Tanjung Jabung Barat",
      "Kab. Muaro Jambi",
      "Kab. Batanghari",
      "Kab. Sarolangun",
      "Kab. Merangin",
      "Kab. Kerinci"
    ]
  },

  {
    provinsi: "Sumatera Selatan",
    kota: [
      "Kota Palembang",
      "Kota Pagar Alam",
      "Kota Lubuk Linggau",
      "Kota Prabumulih",
      "Kab. Musi Rawas Utara",
      "Kab. Penukal Abab Lematang Ilir",
      "Kab. Empat Lawang",
      "Kab. Ogan Ilir ",
      "Kab. Ogan Komering Ulu Selatan ",
      "Kab. Ogan Komering Ulu Timur ",
      "Kab. Banyuasin",
      "Kab. Musi Banyuasin",
      "Kab. Musi Rawas",
      "Kab. Lahat",
      "Kab. Muara Enim",
      "Kab. Ogan Komering Ilir",
      "Kab. Ogan Komering Ulu"
    ]
  },
  {
    provinsi: "Bengkulu",
    kota: [
      "Kota Bengkulu",
      "Kab. Bengkulu Tengah",
      "Kab. Kepahiang ",
      "Kab. Lebong",
      "Kab. Muko Muko",
      "Kab. Seluma",
      "Kab. Kaur",
      "Kab. Bengkulu Utara",
      "Kab. Rejang Lebong",
      "Kab. Bengkulu Selatan"
    ]
  },
  {
    provinsi: "Lampung",
    kota: [
      "Kota Bandar Lampung",
      "Kota Metro",
      "Kab. Pesisir Barat",
      "Kab. Tulangbawang Barat",
      "Kab. Mesuji",
      "Kab. Pringsewu",
      "Kab. Pesawaran",
      "Kab. Way Kanan",
      "Kab. Lampung Timur",
      "Kab. Tanggamus",
      "Kab. Tulang Bawang",
      "Kab. Lampung Barat",
      "Kab. Lampung Utara",
      "Kab. Lampung Tengah",
      "Kab. Lampung Selatan"
    ]
  },
  {
    provinsi: "Kepulauan Bangka Belitung",
    kota: [
      "Kota Pangkal Pinang",
      "Kab. Belitung Timur",
      "Kab. Bangka Barat",
      "Kab. Bangka Tengah",
      "Kab. Bangka Selatan",
      "Kab. Belitung",
      "Kab. Bangka"
    ]
  },
  {
    provinsi: "Kepulauan Riau",
    kota: [
      "Kota Batam",
      "Kota Tanjung Pinang",
      "Kab. Kepulauan Anambas",
      "Kab. Lingga ",
      "Kab. Natuna",
      "Kab. Karimun",
      "Kab. Bintan"
    ]
  },

  {
    provinsi: "DKI Jakarta",
    kota: [
      "Kota Jakarta Timur",
      "Kota Jakarta Selatan",
      "Kota Jakarta Barat",
      "Kota Jakarta Utara",
      "Kota Jakarta Pusat",
      "Kab. Kepulauan Seribu"
    ]
  },
  {
    provinsi: "Jawa Barat",
    kota: [
      "Kota Bandung",
      "Kota Banjar",
      "Kota Tasikmalaya",
      "Kota Cimahi",
      "Kota Depok",
      "Kota Bekasi",
      "Kota Cirebon",
      "Kota Sukabumi",
      "Kota Bogor",
      "Kab. Pangandaran",
      "Kab. Bandung Barat",
      "Kab. Bekasi",
      "Kab. Karawang",
      "Kab. Purwakarta",
      "Kab. Subang",
      "Kab. Indramayu",
      "Kab. Sumedang",
      "Kab. Majalengka",
      "Kab. Cirebon",
      "Kab. Kuningan",
      "Kab. Ciamis",
      "Kab. Tasikmalaya",
      "Kab. Garut",
      "Kab. Bandung",
      "Kab. Cianjur",
      "Kab. Sukabumi",
      "Kab. Bogor"
    ]
  },
  {
    provinsi: "Jawa Tengah",
    kota: [
      "Kota Semarang",
      "Kota Tegal",
      "Kota Pekalongan",
      "Kota Salatiga",
      "Kota Surakarta",
      "Kota Magelang",
      "Kab. Brebes",
      "Kab. Tegal",
      "Kab. Pemalang",
      "Kab. Pekalongan",
      "Kab. Batang",
      "Kab. Kendal",
      "Kab. Temanggung",
      "Kab. Semarang",
      "Kab. Demak",
      "Kab. Jepara",
      "Kab. Kudus",
      "Kab. Pati",
      "Kab. Rembang",
      "Kab. Blora",
      "Kab. Grobogan",
      "Kab. Sragen",
      "Kab. Karanganyar",
      "Kab. Wonogiri",
      "Kab. Sukoharjo",
      "Kab. Klaten",
      "Kab. Boyolali",
      "Kab. Magelang",
      "Kab. Wonosobo",
      "Kab. Purworejo",
      "Kab. Kebumen",
      "Kab. Banjarnegara",
      "Kab. Purbalingga",
      "Kab. Banyumas",
      "Kab. Cilacap"
    ]
  },
  {
    provinsi: "DI Yogyakarta",
    kota: [
      "Kota Yogyakarta",
      "Kab. Sleman",
      "Kab. Gunung Kidul",
      "Kab. Bantul",
      "Kab. Kulon Progo"
    ]
  },
  {
    provinsi: "Jawa Timur",
    kota: [
      "Kota Surabaya",
      "Kota Batu",
      "Kota Madiun",
      "Kota Mojokerto",
      "Kota Pasuruan",
      "Kota Probolinggo",
      "Kota Malang",
      "Kota Blitar",
      "Kota Kediri",
      "Kab. Sumenep",
      "Kab. Pamekasan",
      "Kab. Sampang",
      "Kab. Bangkalan",
      "Kab. Gresik",
      "Kab. Lamongan",
      "Kab. Tuban",
      "Kab. Bojonegoro",
      "Kab. Ngawi",
      "Kab. Magetan",
      "Kab. Madiun",
      "Kab. Nganjuk",
      "Kab. Jombang",
      "Kab. Mojokerto",
      "Kab. Sidoarjo",
      "Kab. Pasuruan",
      "Kab. Probolinggo",
      "Kab. Situbondo",
      "Kab. Bondowoso",
      "Kab. Banyuwangi",
      "Kab. Jember",
      "Kab. Lumajang",
      "Kab. Malang",
      "Kab. Kediri",
      "Kab. Blitar",
      "Kab. Tulungagung",
      "Kab. Trenggalek",
      "Kab. Ponorogo",
      "Kab. Pacitan"
    ]
  },
  {
    provinsi: "Banten",
    kota: [
      "Kota Serang",
      "Kota Cilegon",
      "Kota Tangerang",
      "Kota Tangerang Selatan",
      "Kab. Serang",
      "Kab. Tangerang",
      "Kab. Lebak",
      "Kab. Pandeglang"
    ]
  },
  {
    provinsi: "Bali",
    kota: [
      "Kota Denpasar",
      "Kab. Buleleng",
      "Kab. Karangasem",
      "Kab. Bangli",
      "Kab. Klungkung",
      "Kab. Gianyar",
      "Kab. Badung",
      "Kab. Tabanan",
      "Kab. Jembrana"
    ]
  },
  {
    provinsi: "Nusa Tenggara Barat",
    kota: [
      "Kota Mataram",
      "Kota Bima",
      "Kab. Lombok Utara",
      "Kab. Sumbawa Barat",
      "Kab. Bima",
      "Kab. Dompu",
      "Kab. Sumbawa ",
      "Kab. Lombok Timur",
      "Kab. Lombok Tengah",
      "Kab. Lombok Barat"
    ]
  },
  {
    provinsi: "Nusa Tenggara Timur",
    kota: [
      "Kota Kupang",
      "Kab. Malaka",
      "Kab. Sabu Raijua",
      "Kab. Manggarai Timur",
      "Kab. Sumba Barat Daya",
      "Kab. Sumba Tengah",
      "Kab. Nagekeo",
      "Kab. Manggarai Barat",
      "Kab. Rote Ndao",
      "Kab. Lembata",
      "Kab. Sumba Barat",
      "Kab. Sumba Timur",
      "Kab. Manggarai",
      "Kab. Ngada",
      "Kab. Ende",
      "Kab. Sikka",
      "Kab. Flores Timur",
      "Kab. Alor",
      "Kab. Belu",
      "Kab. Timor Tengah Utara",
      "Kab. Timor Tengah Selatan",
      "Kab. Kupang"
    ]
  },
  {
    provinsi: "Kalimantan Barat",
    kota: [
      "Kota Pontianak",
      "Kota Singkawang",
      "Kab. Kubu Raya",
      "Kab. Kayong Utara",
      "Kab. Sekadau",
      "Kab. Melawi",
      "Kab. Landak",
      "Kab. Bengkayang",
      "Kab. Kapuas Hulu",
      "Kab. Sintang ",
      "Kab. Ketapang",
      "Kab. Sanggau ",
      "Kab. Mempawah",
      "Kab. Sambas"
    ]
  },
  {
    provinsi: "Kalimantan Tengah",
    kota: [
      "Kota Palangkaraya",
      "Kab. Barito Timur",
      "Kab. Murung Raya",
      "Kab. Pulang Pisau",
      "Kab. Gunung Mas",
      "Kab. Lamandau",
      "Kab. Sukamara",
      "Kab. Seruyan",
      "Kab. Katingan",
      "Kab. Barito Utara",
      "Kab. Barito Selatan",
      "Kab. Kapuas",
      "Kab. Kotawaringin Timur",
      "Kab. Kotawaringin Barat"
    ]
  },
  {
    provinsi: "Kalimantan Selatan",
    kota: [
      "Kota Banjarmasin",
      "Kota Banjarbaru",
      "Kab. Balangan",
      "Kab. Tanah Bambu",
      "Kab. Tabalong",
      "Kab. Hulu Sungai Utara",
      "Kab. Hulu Sungai Tengah",
      "Kab. Hulu Sungai Selatan",
      "Kab. Tapin",
      "Kab. Barito Kuala",
      "Kab. Banjar",
      "Kab. Kotabaru",
      "Kab. Tanah Laut"
    ]
  },

  {
    provinsi: "Kalimantan Timur",
    kota: [
      "Kota Samarinda",
      "Kota Bontang",
      "Kota Balikpapan",
      "Kab. Mahakam Ulu",
      "Kab. Penajam Paser Utara",
      "Kab. Kutai Timur",
      "Kab. Kutai Barat",
      "Kab. Berau",
      "Kab. Kutai Kertanegara",
      "Kab. Paser"
    ]
  },

  {
    provinsi: "Kalimantan Utara",
    kota: [
      "Kota Tarakan",
      "Kab. Tana Tidung",
      "Kab. Nunukan",
      "Kab. Malinau",
      "Kab. Bulungan"
    ]
  },
  {
    provinsi: "Sulawesi Utara",
    kota: [
      "Kota Manado",
      "Kota Tomohon",
      "Kota Bitung",
      "Kota Kotamobagu",
      "Kab. Bolaang Mangondow Selatan",
      "Kab. Bolaang Mangondow Timur",
      "Kab. Kepulauan Siau Tagulandang Biaro",
      "Kab. Bolaang Mangondow Utara",
      "Kab. Minahasa Tenggara",
      "Kab. Minahasa Utara",
      "Kab. Minahasa Selatan",
      "Kab. Kepulauan Talaud",
      "Kab. Kepulauan Sangihe",
      "Kab. Minahasa",
      "Kab. Bolaang Mangondow"
    ]
  },
  {
    provinsi: "Sulawesi Tengah",
    kota: [
      "Kota Palu",
      "Kab. Morowali Utara",
      "Kab. Banggai Laut",
      "Kab. Sigi",
      "Kab. Tojo Una-Una",
      "Kab. Parigi Moutong",
      "Kab. Banggai Kepulauan",
      "Kab. Morowali",
      "Kab. Buol",
      "Kab. Toli-Toli",
      "Kab. Donggala",
      "Kab. Poso",
      "Kab. Banggai"
    ]
  },
  {
    provinsi: "Sulawesi Selatan",
    kota: [
      "Kota Makasar",
      "Kota Palopo",
      "Kota Pare Pare",
      "Kab. Toraja Utara",
      "Kab. Luwu Timur",
      "Kab. Luwu Utara",
      "Kab. Tana Toraja",
      "Kab. Luwu",
      "Kab. Enrekang",
      "Kab. Pinrang",
      "Kab. Sidenreng Rappang",
      "Kab. Wajo",
      "Kab. Soppeng",
      "Kab. Barru",
      "Kab. Pangkajene Kepulauan",
      "Kab. Maros",
      "Kab. Bone",
      "Kab. Sinjai",
      "Kab. Gowa",
      "Kab. Takalar",
      "Kab. Jeneponto",
      "Kab. Bantaeng",
      "Kab. Bulukumba",
      "Kab. Kepulauan Selayar"
    ]
  },
  {
    provinsi: "Sulawesi Tenggara",
    kota: [
      "Kota Kendari",
      "Kota Bau Bau",
      "Kab. Buton Selatan",
      "Kab. Buton Tengah",
      "Kab. Muna Barat",
      "Kab. Konawe Kepulauan",
      "Kab. Kolaka Timur",
      "Kab. Buton Utara",
      "Kab. Konawe Utara",
      "Kab. Kolaka Utara",
      "Kab. Wakatobi",
      "Kab. Bombana",
      "Kab. Konawe Selatan",
      "Kab. Buton",
      "Kab. Muna",
      "Kab. Konawe",
      "Kab. Kolaka"
    ]
  },
  {
    provinsi: "Gorontalo",
    kota: [
      "Kota Gorontalo",
      "Kab. Pohuwato",
      "Kab. Bone Bolango",
      "Kab. Boalemo",
      "Kab. Gorontalo",
      "Kab. Gorontalo Utara"
    ]
  },
  {
    provinsi: "Sulawesi Barat",
    kota: [
      "Kab. Majene",
      "Kab. Polowali Mandar",
      "Kab. Mamasa",
      "Kab. Mamuju",
      "Kab. Mamuju Utara",
      "Kab. Mamuju Tengah"
    ]
  },

  {
    provinsi: "Maluku",
    kota: [
      "Kota Ambon",
      "Kota Tual",
      "Kab. Buru Selatan",
      "Kab. Maluku Barat Daya",
      "Kab. Kepulauan Aru",
      "Kab. Seram Bagian Barat ",
      "Kab. Seram Bagian Timur",
      "Kab. Buru",
      "Kab. Maluku Tenggara Barat",
      "Kab. Maluku Tenggara",
      "Kab. Maluku Tengah"
    ]
  },
  {
    provinsi: "Maluku Utara",
    kota: [
      "Kota Ternate",
      "Kota Tidore Kepulauan",
      "Kab. Pulau Taliabu",
      "Kab. Pulau Morotai",
      "Kab. Halmahera Timur",
      "Kab. Kepulauan Sula",
      "Kab. Halmahera Selatan",
      "Kab. Halmahera Utara",
      "Kab. Halmahera Tengah",
      "Kab. Halmahera Barat"
    ]
  },
  {
    provinsi: "Papua",
    kota: [
      "Kota Jayapura",
      "Kab. Deiyai",
      "Kab. Intan Jaya",
      "Kab. Dogiyai",
      "Kab. Puncak",
      "Kab. Nduga",
      "Kab. Lanny Jaya",
      "Kab. Yalimo",
      "Kab. Mamberamo Tengah",
      "Kab. Mamberamo Raya",
      "Kab. Supiori",
      "Kab. Asmat",
      "Kab. Mappi",
      "Kab. Boven Digoel",
      "Kab. Waropen",
      "Kab. Tolikara",
      "Kab. Yahukimo",
      "Kab. Pegunungan Bintang",
      "Kab. Keerom",
      "Kab. Sarmi",
      "Kab. Mimika",
      "Kab. Paniai",
      "Kab. Puncak Jaya",
      "Kab. Biak Numfor",
      "Kab. Kepulauan Yapen",
      "Kab. Nabire",
      "Kab. Jayapura",
      "Kab. Jayawijaya",
      "Kab. Merauke"
    ]
  },
  {
    provinsi: "Papua Barat",
    kota: [
      "Kota Sorong",
      "Kab. Pegunungan Arfak",
      "Kab. Manokwari Selatan",
      "Kab. Maybrat",
      "Kab. Tambrauw",
      "Kab. Kaimana",
      "Kab. Teluk Wondama",
      "Kab. Teluk Bintuni",
      "Kab. Raja Ampat",
      "Kab. Sorong Selatan",
      "Kab. Fak Fak",
      "Kab. Manokwari",
      "Kab. Sorong"
    ]
  }
]

export const courseClassList = [
  {
    label: 'Free Course: Introduction to IT Programming',
    value: 1,
  },
  {
    label: 'Workshop: Coding Kickstart',
    value: 2,
  },
  {
    label: 'Bootcamp',
    value: 3,
  }
]

export const freeCourseList = [
  // Commented for hiding the option.
  // {
  //     label: 'Video Game',
  //     value: 1,
  // },
  {
    label: 'Front-End Website',
    value: 2,
  },
  {
    label: 'Back-End Website',
    value: 3,
  },
  // Commented for hiding the option.
  // {
  //     label: 'Mobile Application',
  //     value: 4
  // }
]

export const workshopCourseList = [
  // Commented for hiding the option.
  // {
  //     label: 'Video Game',
  //     value: 5,
  // },
  {
    label: 'Front-End Website',
    value: 6,
  },
  {
    label: 'Back-End Website',
    value: 7,
  },
  // Commented for hiding the option.
  // {
  //     label: 'Mobile Application',
  //     value: 8
  // }
]

export const bootcampCourseList = [
  {
    label: 'Full Stack Engineer',
    value: 9
  }
]

export const freeVideoGameScheduleList = [
  {
    label: '8 Desember 2023 pukul 19.00 - selesai',
    value: 43
  },
  {
    label: '14 Desember 2023 pukul 19.00 - selesai',
    value: 44
  },
  {
    label: '21 Desember 2023 pukul 19.00 - selesai',
    value: 45
  },
]

export const freeFrontEndWebsiteScheduleList = [
  {
    label: '1 Maret 2024 pukul 19.00 - selesai',
    value: 68
  },
]

export const freeBackEndWebsiteScheduleList = [
  {
    label: '22 Februari 2024 pukul 19.00 - selesai',
    value: 69
  },
  {
    label: '26 Februari 2024 pukul 19.00 - selesai',
    value: 70
  },
]

export const freeMobileApplicationScheduleList = [
  {
    label: '12 Desember 2023 pukul 19.00 - selesai',
    value: 52
  },
  {
    label: '13 Desember 2023 pukul 19.00 - selesai',
    value: 53
  },
  {
    label: '19 Desember 2023 pukul 19.00 - selesai',
    value: 54
  },
]

export const workshopVideoGameScheduleList = [
  {
    label: '11 dan 12 Januari 2024 pukul 18.30 - 21.30',
    value: 55
  },
  {
    label: '18 dan 19 Januari 2024 pukul 18.30 - 21.30',
    value: 56
  },
  {
    label: '25 dan 26 Januari 2024 November pukul 18.30 - 21.30',
    value: 57
  },
]

export const workshopFrontEndWebsiteScheduleList = [
  {
    label: '22 dan 23 April 2024 pukul 18.30 - selesai',
    value: 71
  },
]

export const workshopBackEndWebsiteScheduleList = [
  {
    label: '13 dan 14 Maret 2024 pukul 18.30 - 21.30',
    value: 72
  },
  {
    label: '20 dan 21 Maret 2024 pukul 18.30 - 21.30',
    value: 73
  },
]

export const workshopMobileApplicationScheduleList = [
  {
    label: '3 dan 4 Januari 2024 pukul 18.30 - 21.30',
    value: 64
  },
  {
    label: '10 dan 17 Januari 2024 pukul  18.30 - 21.30',
    value: 65
  },
  {
    label: '30 dan 31 Januari 2024 pukul 18.30 - 21.30',
    value: 66
  },
]

export const bootcampFullStackEngineerScheduleList = [
  {
    label: 'Mulai Maret 2024',
    value: 67
  }
]

export const bootcamp_levels: Level[] = [
  {
    number: "1.0",
    text: "Menemukan Potensi Diri",
    icon: "/img/course/bootcamp/icon-1.png",
    subtitle: "Awal Perjalanan",
  },
  {
    number: "2.0",
    text: "Menguasai Skill Dasar",
    icon: "/img/course/bootcamp/icon-2.png",
    subtitle: "Fondasi Kuat",
  },
  {
    number: "3.0",
    text: "Membangun Proyek Nyata",
    icon: "/img/course/bootcamp/icon-3.png",
    subtitle: "Dunia Praktis",
  },
  {
    number: "4.0",
    text: "Talenta Siap Kerja",
    icon: "/img/course/bootcamp/icon-4.png",
  },
];

export const bootcamp_benefits: string[] = [
  "Real Project Perusahaan",
  "Sertifikat Penyelesaian Course",
  "Sesi Interaktif Expert via Online Meets",
  "Sertifikat Keahlian Terverifikasi DISNAKER",
  "Sertifikat Kompetensi Internasional bahasa Jepang",
];

export const bootcamp_programData: Record<string, Program[]> = {
  "Pemograman IT": [
    {
      kategori: "Full Stack",
      title: "Full Stack Developer",
      duration: "2 bulan",
      price: "Start From Rp. 8.850.000",
      image: "/img/course/bootcamp/fullstackdev.jpg",
      tags: [".NET", "SQL", "Front End", "Mobile App", "Website", "Final Project"],
      description:
        "Program pembekalan ilmu pembuatan aplikasi website dan mobile mulai dari front-end hingga back-end. Program ini mencakup proyek akhir sebagai bahan penilaian ujian sertifikasi kelulusan dan hasil portofolio sebagai seorang Full Stack Developer.",
      curriculum: [
        {
          title: ".NET: Basics",
          subtopics: ["C#"],
        },
        {
          title: ".NET: Intermediate",
          subtopics: [
            "Visual Studio",
            "Command Line Application + Debugging",
            "Penggunaan Git + GitLab + GitHub",
            "Asynchronous Programming",
          ],
        },
        {
          title: "ASP.NET Core Web API",
          subtopics: [
            "Error Logging",
            "App Settings",
            "Entity Framework Core Code First to SQLite",
            "Web API (CRUD) + HTTP Methods",
            "Services & Dependency Injection",
            "Swagger & Postman",
            "Unit Testing with Nunit",
          ],
        },
        {
          title: "Front-End Programming: Basics",
          subtopics: ["HTML", "CSS", "TypeScript", "JavaScript", "React"],
        },
        {
          title: "Front-End Web Programming: Intermediate",
          subtopics: ["Next.js", "Components Styling using Tailwind CSS"],
        },
        {
          title: "Front-End Mobile Programming: Intermediate",
          subtopics: [
            "React Native",
            "Expo Dev Client & EAS build",
            "Developing CRUD and forms",
            "Advanced UI Components OpenID Connect",
            "Jotai, AsyncStorage, Realm",
            "Data Fetching with Fetch API",
          ],
        },
        {
          title: "SQL Programming",
          subtopics: [
            "Pembelajaran SQL",
            "PostgreSQL + pgAdmin",
            "Database Design",
            "Entity Framework Core",
            "ASP.NET Core + Next.js + Expo + EF Core",
          ],
        },
      ],
      tugasDanUjian: [
        "Ujian dan tugas setiap step pembelajaran",
        "Ujian final project secara utuh",
      ],
      learningMethod: "Online / Offline menyesuaikan kebutuhan dan kuota pelajar",
    },
  ],
  // "Bahasa Jepang": [
  // {
  //   kategori : "Specified Skilled Workers",
  //   title: "SSW (Specified Skilled Workers)",
  //   duration: "Program berlangsung selama 1 bulan",
  //   price: "Rp 8.850.000",
  //   image: "/img/course/bootcamp/SSW.jpg",
  //   tags:["SSW", "Ujian SSW"],
  //   description:
  //     "Program 1 bulan yang fokus pada persiapan ujian SSW (Caregiver, Pertanian, Perhotelan, Restoran, atau Pengolahan Makanan) lengkap dengan materi, ujian, dan bimbingan interview kerja.",
  //   curriculum: [
  //     "Kelas persiapan kerja (SSW)",
  //     "Bimbingan interview",
  //   ],
  //   fasilitas : [
  //     "Buku persiapan ujian SSW Caregiver / SSW Pertanian / SSW Perhotelan / SSW Pengolahan Makanan",
  //     "Biaya ujian SSW untuk 1 kali ujian",
  //     "Bimbingan interview kerja",
  //   ],
  //   ujiSertifikasi : "Ujian SSW",
  //   learningMethod: "Online / Offline menyesuaikan kuota pelajar",
  // },
  // {
  //   kategori : "Japanese Language",
  //   title: "Level N4",
  //   duration: "4.5 bulan dengan pembelajaran setiap hari 4 jam dari Senin-Jumat",
  //   price: "Rp. 13.500.000",
  //   image: "/img/course/bootcamp/N4+SSW.png",
  //   tags:["N5", "N4", "SSW", "Kaiwa", "Ujian JFT"],
  //   description:
  //     "Program gabungan level N5, N4, dan SSW ",
  //   curriculum: [
  //     "Pembelajaran bahasa Jepang level N5",
  //     "Pembelajaran bahasa Jepang level N4",
  //     "Kelas persiapan kerja (SSW)",
  //     "Bimbingan interview",
  //   ],
  //   fasilitas:[
  //     "Buku pelajaran bahasa Jepang Daichi Tingkat Dasar I & II",
  //     "Biaya ujian JFT Japan Foundation Test 1 kali ujian",
  //     "Termasuk bimbingan kelas Kaiwa atau Percakapan ",
  //   ],
  //   ujiSertifikasi : "Ujian Japan Foundation",
  //   learningMethod: "Online / Offline menyesuaikan kuota pelajar",
  // },
  // {
  //   kategori : "Japanese Language",
  //   title: "Level N3",
  //   duration: "6 bulan dengan pembelajaran setiap hari 4 jam dari Senin-Jumat",
  //   price: "Rp 18.500.000",
  //   image: "/img/course/bootcamp/N3+SSW.png",
  //   tags:["N5", "N4", "N3", "SSW", "Kaiwa", "Ujian JFT"],
  //   description:
  //     "Program gabungan level N5, N4, N3, dan SSW ",
  //   curriculum: [
  //     "Pembelajaran bahasa Jepang level N5",
  //     "Pembelajaran bahasa Jepang level N4",
  //     "Pembelajaran bahasa Jepang level N3",
  //     "Kelas persiapan kerja (SSW)",
  //     "Bimbingan interview",
  //   ],
  //   fasilitas : [
  //     "Buku pelajaran bahasa Jepang Daichi Tingkat Dasar I & II",
  //     "Biaya ujian JFT Japan Foundation Test 1 kali ujian",
  //     "Termasuk bimbingan kelas Kaiwa atau Percakapan" 
  //   ],
  //   ujiSertifikasi: "Ujian Japan Foundation",
  //   learningMethod: "Online / Offline menyesuaikan kuota pelajar",
  // },
  // ],
  // "IT & Bahasa Jepang Bundling Package": [
  //   {
  //     kategori : "Japanese Language",
  //     title: "Level N3",
  //     duration: "6 bulan dengan pembelajaran setiap hari 4 jam dari Senin-Jumat",
  //     price: "Rp 18.500.000",
  //     image: "/img/course/bootcamp/N3+SSW.png",
  //     tags:["N5", "N4", "N3", "SSW", "Kaiwa", "Ujian JFT"],
  //     description:
  //       "Program gabungan level N5, N4, N3, dan SSW ",
  //     curriculum: [
  //       "Pembelajaran bahasa Jepang level N5",
  //       "Pembelajaran bahasa Jepang level N4",
  //       "Pembelajaran bahasa Jepang level N3",
  //       "Kelas persiapan kerja (SSW)",
  //       "Bimbingan interview",
  //     ],
  //     fasilitas : [
  //       "Buku pelajaran bahasa Jepang Daichi Tingkat Dasar I & II",
  //       "Biaya ujian JFT Japan Foundation Test 1 kali ujian",
  //       "Termasuk bimbingan kelas Kaiwa atau Percakapan" 
  //     ],
  //     ujiSertifikasi: "Ujian Japan Foundation",
  //     learningMethod: "Online / Offline menyesuaikan kuota pelajar",
  //   },
  // ],
};

export const tabs = Object.keys(bootcamp_programData);

export const extracurricularList: Extracurricular[] = [
  {
    image: 'img/ekskul/img-card-customize.png',
    section: 'Sekolah Dasar (SD)',
    category: 'Customize',
    app: 'Customize',
    objective: 'Customize',
    programmingLanguage: 'Customize',
    detail: [
    ],
    tags: [],
  },
  {
    image: 'img/ekskul/Game.png',
    section: 'Sekolah Dasar (SD)',
    category: 'Game',
    app: 'Scratch',
    objective: 'Pemahaman murid pada keterampilan logika, kreativitas, dan dasar pemrograman Javascript melalui Word Blocks platform Scratch. Murid akan membuat karya digital berupa game.',
    programmingLanguage: '-',
    detail: [
      'Pemahaman Aplikasi dan Perangkat',
      'Pengenalan dasar coding JavaScript melalui Word Blocks',
      'Pembuatan proyek dengan konsep scaffolding',
      'Pembuatan proyek inovasi',
      'Presentasi hasil proyek'
    ],
    tags: ["JavaScript", "Scaffolding", "Inovasi", "Presentasi",],
  },
  {
    image: 'img/ekskul/Logic.png',
    section: 'Sekolah Dasar (SD)',
    category: 'Logic & Algorithm',
    app: 'Visual Studio Code',
    objective: 'Pemahaman pemrograman bahasa Python untuk mamahami cara berpikir logis, konsep algoritma, sintaks dasar, struktur data, dan pemrograman berorientasi objek. Murid akan membuat proyek praktis untuk mendukung pemecahan masalah dan logika berpikir',
    programmingLanguage: 'Python',
    detail: [
      'Pengenalan Integrated Development Environment',
      'Pengenalan Pemrograman dan Sintaks Dasar',
      'Pembuatan proyek konsep scaffolding',
      'Pemrograman berorientasi objek',
      'Pembuatan proyek inovasi',
      'Presentasi hasil proyek'
    ],
    tags: ["IDE", "Sintaks", "Scaffolding", "OOP", "Inovasi", "Presentasi",],
  },
  {
    image: 'img/ekskul/Game-IoT.png',
    section: 'Sekolah Dasar (SD)',
    category: 'Game & IoT',
    app: 'Microbit',
    objective: 'Pemahaman pemrograman dan Internet of Things (IoT) melalui pembuatan proyek berbasis Microbit (teknologi, sensor, dan interaktivitas)',
    programmingLanguage: 'Python / Javascript / Typescript',
    detail: [
      'Pengenalan App dan Perangkat',
      'Pengenalan pemrograman dan logika dasar',
      'Pembuatan proyek inovasi',
      'Presentasi hasil proyek'
    ],
    tags: ["Pemrograman", "Inovasi", "Presentasi"],
  },
  {
    image: 'img/ekskul/robotika.png',
    section: 'Sekolah Dasar (SD)',
    category: 'Robotika, IoT & 3D Design',
    app: '-',
    programmingLanguage: '-',
    tags: ["Konstruksi", "Mekanik", "Elektronik", "Sensor", "Pemrograman", "Kreativitas", "Simulasi",],
    levels: [
      {
        kelas: 1,
        category: 'Basic Construction and Mechanical Movement I',
        app: '-',
        objective: 'Pemahaman dasar robotika, perakitan berbagai jenis konstruksi robot sesuai buku panduan maupun secara kreatif, pengenalan komponen robot seperti I-Robo, J-Robo, dan NXT, serta wawasan tentang bentuk, fungsi, sejarah, dan konsep dari robot Animaloid, Humanoid, kendaraan, hewan, dan elemen budaya lainnya',
        programmingLanguage: '-',
        detail:
          [
            'Introduction to Basic of Robotics and Iam Brick parts.Construction of Iam Brick Duck and Crab',
            'Construction of Iam Brick Sun Flower and Butterfly',
            'Construction of Iam Brick Horse and Giraffe',
            'Introduction to Basic of Robotics and I-Robo ES1 Non Electronic Parts',
            'Construct of I-Robo Little Bird',
            'Construct of I-robo Observation Wheel (carousel)',
            'Construct of I-Robo Bowgun',
            'Construct of I-robo Little Knight',
            'Construct of J-Robo Animaloid (Scorpion & Crocodile)',
            'Construct of J-Brick Adventure Motorcycle + Modification',
            'Construct of I-Robo Pegasus',
            'Construct of I-Robo Mini Airplane',
            'Construct of I-Robo Spectree',
            'Construct of I-Robo Mini Bicycle',
            'Construct of I-Robo Gladiator',
            'Construct of I-Robo Centaur',
            'Construct of I-Robo Bird',
            'Introduction to Mechanict NXT',
            'Construct of NXT Hand Generator Windmill',
            'Construct of NXT Hand Generator Car',
            'Construct of NXT Bird',
            'Construct of NXT Bicycle',
            'Construct of NXT Human Bot',
            'Construct of NXT Swing Children',
          ],
        images: [
          { src: 'img/ekskul/robotika-sd-level1-1.png', caption: 'Brick Duck and Crab' },
          { src: 'img/ekskul/robotika-sd-level1-2.png', caption: 'Brick SunFlower and Butterfly' },
          { src: 'img/ekskul/robotika-sd-level1-3.png', caption: 'Brick Horse and Giraffe' },
          { src: 'img/ekskul/robotika-sd-level1-4.png', caption: 'Irobo Observation Wheel' },
          { src: 'img/ekskul/robotika-sd-level1-5.png', caption: 'Irobo Bowgun' },
          { src: 'img/ekskul/robotika-sd-level1-6.png', caption: 'J-Brick Motorcycle' },
          { src: 'img/ekskul/robotika-sd-level1-7.png', caption: 'Irobo Mini Airplane' },
          { src: 'img/ekskul/robotika-sd-level1-8.png', caption: 'Irobo Gladiator' },
          { src: 'img/ekskul/robotika-sd-level1-9.png', caption: 'NXT Bicycle' },
          { src: 'img/ekskul/robotika-sd-level1-10.png', caption: 'NXT Swing Children' },
        ],
      },
      {
        kelas: 2,
        category: 'Basic Construction and Mechanical Movement II',
        app: '-',
        programmingLanguage: '-',
        objective: 'Mampu memahami dan merakit berbagai jenis robot dan konstruksi kreatif berdasarkan buku panduan, mengenal fungsi serta simulasi dari setiap model, mengatur komponen elektronik, dan mengembangkan kreativitas serta kerja sama dalam mengontrol robot secara otomatis dan manual',
        detail:
          ['Review All about Robotics, and Construct the Simple Project',
            'Construct of J-Brick Rocket Car',
            'Construct of I-Robo Bungalow',
            'Construct of I-Robo SpaceShip',
            'Construct of J-Robo Humanoid ',
            'Construct of J-Brick Rubber Band Gun',
            'Construct of J-Brick Adventure Shuttle',
            'Introduction to J-Brick Electronic Parts dan Merakit Robot Sederhana',
            'Construct of J-Brick Space Power Adventure',
            'Construct of J-Brick Space Power Tractor',
            'Construct of J-Brick Space Power Shooter',
            'Construct of I-Robo Bulldozer',
            'Construct of J-Brick Space Robot Soccer + Games',
            'Construct of I-Robo Windmill',
            'Construct of J-Robo Airplane',
            'Construct of Galapagos - Turtle',
            'Construct of I-Robo Tricycle',
            'Construct of I-Robo Pteranodon',
            'Construct of I-Robo Caterpillar Robot',
            'Construct of I-Robo Dragon',
            'Construct of J-Brick Space Power Keeper',
            'Construct of I-Robo Ricksaw Bot',
            'Construct of I-Robo WaterMill',
            'Construct of J-Robo Transfomer',
          ],
        images: [
          { src: 'img/ekskul/robotika-sd-level2-1.png', caption: 'J-Brick Space Power Adventure' },
          { src: 'img/ekskul/robotika-sd-level2-2.png', caption: 'J-Brick Space Power Tractor' },
          { src: 'img/ekskul/robotika-sd-level2-3.png', caption: 'J-Brick Space Power Shooter' },
          { src: 'img/ekskul/robotika-sd-level2-4.png', caption: 'I-Robo Bulldozer' },
          { src: 'img/ekskul/robotika-sd-level2-5.png', caption: 'I-Robo Windmill' },
          { src: 'img/ekskul/robotika-sd-level2-6.png', caption: 'Galapagos - Turtle' },
          { src: 'img/ekskul/robotika-sd-level2-7.png', caption: 'I-Robo Tricycle' },
          { src: 'img/ekskul/robotika-sd-level2-8.png', caption: 'I-Robo Caterpillar Robot' },
          { src: 'img/ekskul/robotika-sd-level2-9.png', caption: 'I-Robo Dragon' },
          { src: 'img/ekskul/robotika-sd-level2-10.png', caption: 'I-Robo Ricksaw Bot' },
        ],
      },
      {
        kelas: 3,
        category: 'Simple Robots ( construction, mechanics, electronics ) I',
        app: '-',
        programmingLanguage: '-',
        objective: 'Mampu memahami dan menerapkan berbagai konsep perakitan robot berdasarkan buku panduan, mengenal fungsi komponen elektronik seperti sensor dan remote control, membuat serta memprogram berbagai jenis robot tematik, serta mengembangkan kreativitas melalui modifikasi dan simulasi proyek seperti robot security, scorpion, racing car, hingga robot sumo, baik secara individu maupun kolaboratif di dalam kelas.',
        detail:
          ['Review All about Robotics, and I-Robo ES2 Electronic Parts Construct the Simple Project',
            'Construct of J-Robo Security Robot',
            'Construct of I-Robo Scale',
            'Construct of I-Robo Scorpion',
            'Introduction Basic of Robotics and I-Robo ES1 Eletronic Part',
            'Construct of  Cart (small racing car) and do the Racing Games',
            'Construct of I-Robo Remote Controller',
            'Theory of Gears, Construct Crane Robot',
            'Theory of IR Sensor, Construct of Line Tracer Robot',
            'Construct of I-Robo Motor Tricycle',
            'Construct of I-Robo Soccer Robot',
            'Construct of Delman',
            'Construct of  Single Rider',
            'Construct of Top + IR Sensor',
            'Construct of Rocket Car',
            'Construct Wrestling Robot',
            'Construction of I-Robo Bicycle',
            'Construct I-Robo Harley Davidson',
            'Theory CDS Sensor of Construct of CDS Robot',
            'Construct of I-Robo Crocodile',
            'Construct Sumo Robot (IR Sensor)',
            'Construct of  Racing Car',
            'Construct of Cora - Cora',
            'Construct of Carapan Airplane',
          ],
        images: [
          { src: 'img/ekskul/robotika-sd-level3-1.png', caption: 'J-Robo Security Robot' },
          { src: 'img/ekskul/robotika-sd-level3-2.png', caption: 'I-Robo Scale' },
          { src: 'img/ekskul/robotika-sd-level3-3.png', caption: 'Cart (small racing car)' },
          { src: 'img/ekskul/robotika-sd-level3-4.png', caption: 'Crane Robot' },
          { src: 'img/ekskul/robotika-sd-level3-5.png', caption: 'I-Robo Motor Tricycle' },
          { src: 'img/ekskul/robotika-sd-level3-6.png', caption: 'Delman' },
          { src: 'img/ekskul/robotika-sd-level3-7.png', caption: 'Top + IR Sensor' },
          { src: 'img/ekskul/robotika-sd-level3-8.png', caption: 'Rocket Car' },
          { src: 'img/ekskul/robotika-sd-level3-9.png', caption: 'CDS Robot' },
          { src: 'img/ekskul/robotika-sd-level3-10.png', caption: 'Cora-cora' },
        ],
      },
      {
        kelas: 4,
        category: 'Simple Robots ( construction, mechanics, electronics ) II',
        app: '-',
        programmingLanguage: '-',
        objective: 'Mampu memahami cara perakitan robot berdasarkan buku panduan, mengenal berbagai komponen seperti Mainboard ES2, servo, sensor IR, touch sensor, dan gear box, serta mampu memprogram dan mengendalikan berbagai jenis robot sesuai fungsinya. Selain itu, peserta menunjukkan kreativitas dalam membuat dan memodifikasi robot, serta mampu menggunakan platform I-Robo maupun Lego NXT untuk menyelesaikan proyek dan simulasi robotik secara mandiri maupun kolaboratif di kelas',
        detail:
          [
            'Introduction to ES2 & J-Robo',
            'Study About Programming RC Robot; Construct simple Robot',
            'Construction of J-Robo Motorcycle',
            'Construction of I-Robo IR Sensor',
            'Simulation of Line Tracer',
            'Construction of I-Robo Hovercraft',
            'Study About Sensors and Construction of Spinning Top robot',
            'Construction of I-Robot Batle Robot',
            'Construction of I-Robo Mantis',
            'Construction of I-Robo IR Rabbit',
            'Construction of I-Robo Helicopter',
            'Construction of I-Robo Autowagon',
            'Construction of I-Robo Tamiya',
            'Construction of J-Robo Soccer Robot',
            'Construction of I-Robo Dual Purpose Drone',
            'Construction of I-Robo Tandem Roller',
            'Construction of J-Robo Circus',
            'Construction of I-Robo Sumo Bot',
            'Construction of I-Robo Smart House',
            'Introduction to LEGO Mindstrom NXT and Creative Project',
            'Construction of NXT Mini Golf',
            'Construction of NXT Steering Rover',
            'Construction of NXT Inch Worm',
            'Construction of NXT Spider',
          ],
        images: [
          { src: 'img/ekskul/robotika-sd-level4-1.png', caption: 'Programming RC Robot' },
          { src: 'img/ekskul/robotika-sd-level4-2.png', caption: 'I-Robo Hovercraft' },
          { src: 'img/ekskul/robotika-sd-level4-3.png', caption: 'Spinning Top robot' },
          { src: 'img/ekskul/robotika-sd-level4-4.png', caption: 'I-Robot Batle Robot' },
          { src: 'img/ekskul/robotika-sd-level4-5.png', caption: 'I-Robo Mantis' },
          { src: 'img/ekskul/robotika-sd-level4-6.png', caption: 'I-Robo IR Rabbit' },
          { src: 'img/ekskul/robotika-sd-level4-7.png', caption: 'I-Robo Autowagon' },
          { src: 'img/ekskul/robotika-sd-level4-8.png', caption: 'J-Robo Soccer Robot' },
          { src: 'img/ekskul/robotika-sd-level4-9.png', caption: 'I-Robo Sumo Bot' },
          { src: 'img/ekskul/robotika-sd-level4-10.png', caption: 'I-Robo Smart House' },
        ],
      },
      {
        kelas: 5,
        category: 'Robot and Programming I',
        app: '-',
        programmingLanguage: '-',
        objective: 'Mampu merakit berbagai robot Lego NXT sesuai building step, memahami dasar-dasar pemrograman menggunakan Move Block, Switch, Sensor (Touch, Ultrasonik, NXT Button), serta menyelesaikan tantangan seperti Maze Solving dan kompetisi robotik. Peserta juga menunjukkan kemampuan berkreasi tanpa panduan, memahami fungsi mekanik dan elektronik pada tiap robot, serta mampu memprogram robot sesuai fungsinya dengan baik dan benar',
        detail:
          [
            'Introduction of NXT Robot and Lego Mindstorms NXT Software',
            'Construct of Five Minute',
            'Basic Program (move) with Five Minutes',
            'Construct Mini Rover with 3 Remotte Control',
            'Five Minute Program NXT Button and Sound Program',
            'Construct of NXT Baseball Batter',
            'Construct of NXT 4x4 Car',
            'Construct of NXT Top Spinner',
            'Construct of Five Minute 2 Touch Sensor',
            'Construct of Basic NXT Robot; Maze Competition',
            'Construct of NXT Power Saw',
            'Construct of Line Follower',
            'Construct of NXT Castor Bot',
            'Construct of Mouse Trap',
            'Construct of NXT Bumper Car',
            'Creative Sumo with Light Sensor',
            'Construct of NXT Robot Arm',
            'Construct of NXT Ball Roller Coaster',
            'Construct of NXT Flipping Gymanst',
            'Construct of NXT Dragster',
            'Construct of NXT 3 Motor Chassis',
            'Construct of NXT Claw Striker',
            'Construct of NXT Ball Kicker',
            'Program Maze Solving',
          ],
        images: [
          { src: 'img/ekskul/robotika-sma-1.png', caption: 'Construct of Five minutes' },
          { src: 'img/ekskul/robotika-sd-level5-1.png', caption: 'Basic program of Five minutes' },
          { src: 'img/ekskul/robotika-sd-level5-2.png', caption: 'Mini rover with 3 remote control' },
          { src: 'img/ekskul/robotika-sd-level5-3.png', caption: 'Button and sound program' },
          { src: 'img/ekskul/robotika-smp-6.png', caption: 'NXT Baseball Batter' },
          { src: 'img/ekskul/robotika-sd-level5-4.png', caption: 'NXT Top Spinner' },
          { src: 'img/ekskul/robotika-sd-level5-5.png', caption: 'Five minutes 2 Touch Sensor' },
          { src: 'img/ekskul/robotika-sd-level5-6.png', caption: 'NXT Power Saw' },
          { src: 'img/ekskul/robotika-smp-5.png', caption: 'Mouse Trap' },
          { src: 'img/ekskul/robotika-sd-level5-7.png', caption: 'NXT Ball Roller Coaster' },
        ],
      },
      {
        kelas: 6,
        category: 'Robot and Programming II',
        app: '-',
        programmingLanguage: '-',
        objective: 'Mampu merakit berbagai jenis robot menggunakan Lego Mindstorms EV3, memahami fungsi dan cara kerja sensor seperti Touch, Color, Infrared, Gyro, dan EV3 Button, serta mampu membuat program dari tingkat dasar hingga advance. Selain itu, peserta menunjukkan kemampuan dalam berpikir kritis, kreatif, dan logis, serta mampu menerapkan algoritma dalam pemrograman untuk menyelesaikan berbagai tantangan, termasuk simulasi robot animaloid dan logika line follower',
        detail:
          [
            'Introduction of Lego Mindstroms EV3',
            'Construct robot Educator EV3',
            'Construct robot Rov3r with Color Sensor',
            'Construct robot Rov3r with Touch Sensor',
            'Construct robot Rov3r with Infrared Sensor',
            'Construction robot Explorer Ev3',
            'Learning program Advance with simple robot',
            'Construct of Gorila EV3',
            'Construct of TankBot EV3',
            'Construct of Insect EV3',
            'Construction of Robot Arm EV3',
            'Line Follower 2 sensor',
          ],
        images: [
          { src: 'img/ekskul/robotika-sd-level6-1.png', caption: 'Lego Mindstorms EV3' },
          { src: 'img/ekskul/robotika-sd-level6-2.png', caption: 'Robot Educator EV3' },
          { src: 'img/ekskul/robotika-sd-level6-3.png', caption: 'Robot Rov3r with Color Sensor' },
          { src: 'img/ekskul/robotika-sd-level6-4.png', caption: 'Robot Rov3r with Touch Sensor' },
          { src: 'img/ekskul/robotika-sd-level6-5.png', caption: 'Robot Rov3r with Infrared Sensor' },
          { src: 'img/ekskul/robotika-sd-level6-6.png', caption: 'Robot Explorer EV3' },
          { src: 'img/ekskul/robotika-sd-level6-7.png', caption: 'Program Advance with simple robot' },
          { src: 'img/ekskul/robotika-sd-level6-8.png', caption: 'Gorila EV3' },
          { src: 'img/ekskul/robotika-sd-level6-9.png', caption: 'Tankbot EV3' },
          { src: 'img/ekskul/robotika-sd-level6-10.png', caption: 'Robot Arm EV3' },
        ],
      }
    ]
  },
  {
    image: 'img/ekskul/img-card-customize.png',
    section: 'Sekolah Menengah Pertama (SMP)',
    category: 'Customize',
    app: 'Customize',
    objective: 'Customize',
    programmingLanguage: 'Customize',
    detail: [
    ],
    tags: [],
  },
  {
    image: 'img/ekskul/Game-IoT.png',
    section: 'Sekolah Menengah Pertama (SMP)',
    category: 'Game & IoT',
    app: 'Microbit',
    objective: 'Pemahaman pemrograman dan Internet of Things (IoT) melalui pembuatan proyek berbasis Microbit (teknologi, sensor, dan interaktivitas)',
    programmingLanguage: 'Python / Javascript / Typescript',
    detail: [
      'Pengenalan App dan Perangkat',
      'Pengenalan pemrograman dan logika dasar',
      'Pembuatan proyek inovasi',
      'Presentasi hasil proyek'
    ],
    tags: ["Pemrograman", "Inovasi", "Presentasi"],
  },
  {
    image: 'img/ekskul/Front-end.png',
    section: 'Sekolah Menengah Pertama (SMP)',
    category: 'Front-end Web Development',
    app: 'Visual Studio Code',
    objective: 'Pemahaman murid membuat UI website menarik, interaktif, dan dapat diakses di internet menggunakan coding',
    programmingLanguage: 'HTML / CSS / Javascript',
    detail: [
      'Pengenalan App dan Perangkat',
      'Pengenalan bahasa pemrogramman untuk front-end development',
      'Mempelajari pembuatan logic pada front-end ',
      'Mempelajari styling pada front-end',
      'Mempelajari cara integrasi antara front-end dengan back-end',
      'Pembuatan proyek inovasi',
      'Presentasi hasil proyek'
    ],
    tags: ["Pemrograman", "Front-end", "Logika", "styling", "Integrasi dengan backend", "Presentasi"],
  },
  {
    image: 'img/ekskul/Back-end.png',
    section: 'Sekolah Menengah Pertama (SMP)',
    category: 'Back-end Web Development',
    app: 'Visual Studio Code',
    objective: 'Pemahaman murid membangun dan mengelola server, database, dan aplikasi web yang mendukung fungsionalitas situs web.',
    programmingLanguage: 'PHP / C#',
    detail: [
      'Pengenalan App dan Perangkat',
      'Pengenalan bahasa pemrogramman untuk back-end development',
      'Mempelajari pembuatan logic pada back-end ',
      'Mempelajari konsep API pada back-end',
      'Mempelajari tools untuk melakukan testing API (Postman, etc)',
      'Pembuatan proyek inovasi',
      'Presentasi hasil proyek'
    ],
    tags: ["Pemrograman", "Back-end", "Logika", "API", "Testing API", "Presentasi"],
  },
  {
    image: 'img/ekskul/Mobile.png',
    section: 'Sekolah Menengah Pertama (SMP)',
    category: 'Mobile Development',
    app: 'Appinventor',
    objective: 'Pembuatan aplikasi mobile yang interaktif dan fungsionalitas menggunakan MIT AppInventor.',
    programmingLanguage: '-',
    detail: [
      'Pengenalan aplikasi dan software MT Appinventor',
      'Pengenalan Flowchart Figma',
      'Komponen dasar aplikasi Mobile',
      'Pembuatan proyek scaffolding konsep',
      'Pembuatan proyek inovasi',
      'Presentasi hasil proyek'
    ],
    tags: ["Flowchart", "Komponen Aplikasi", "Scaffolding", "Inovasi", "Presentasi"],
  },
  {
    image: 'img/ekskul/img-card-customize.png',
    section: 'Sekolah Menengah Atas (SMA)',
    category: 'Customize',
    app: 'Customize',
    objective: 'Customize',
    programmingLanguage: 'Customize',
    detail: [
    ],
    tags: [],
  },
  {
    image: 'img/ekskul/AI.png',
    section: 'Sekolah Menengah Pertama (SMP)',
    category: 'Artificial Intelligence (AI)',
    app: 'Visual Studio Code',
    objective: 'Memahami proses pembuatan artificial intelligence yang sering ditemukan di kehidupan sehari-hari.',
    programmingLanguage: 'Python',
    detail: [
      'Pengenalan App dan Perangkat',
      'Pengenalan pemrograman dan logika dasar menggunakan Python',
      'Mempelajari Machine Learning',
      'Mempelajari pembuatan Chatbot',
      'Mempelajari pembuatan Computer Vision (Object recognition, face recognition, etc)',
      'Pembuatan proyek inovasi',
      'Presentasi hasil proyek'
    ],
    tags: ["Pemrograman", "Logika", "Machine Learning", "Chatbot", "Computer Vision", "Inovasi", "Presentasi"],
  },
  {
    image: 'img/ekskul/robotika.png',
    section: 'Sekolah Menengah Pertama (SMP)',
    category: 'Robotika, IoT & 3D Design',
    app: 'Megarobotech, Lego Mindstorms NXT, TinkerCad',
    objective: 'Pemahaman robotika dan Internet of Things (IoT), pemrograman dasar, serta desain 3D melalui proyek seperti Line Follower, Smart Home, Mouse Trap, dan 3D printing (gantungan kunci, rumah, pesawat)',
    programmingLanguage: '-',
    images: [
      { src: 'img/ekskul/robotika-smp-1.png', caption: 'Robot Mobile' },
      { src: 'img/ekskul/robotika-smp-2.png', caption: 'Line Tracer' },
      { src: 'img/ekskul/robotika-smp-3.png', caption: 'Smart Home J-Robo' },
      { src: 'img/ekskul/robotika-smp-4.png', caption: 'Five minutes bot' },
      { src: 'img/ekskul/robotika-smp-5.png', caption: 'NXT Mouse Trap' },
      { src: 'img/ekskul/robotika-smp-6.png', caption: 'NXT Baseball batter' },
      { src: 'img/ekskul/robotika-smp-7.png', caption: 'Robot 3D Design' },
      { src: 'img/ekskul/robotika-smp-8.png', caption: 'Gantungan kunci' },
    ],
    detail: [
      'Pengenalan Robotika, Materi Robot pembelajaran (J-Robo)',
      'Merakit konstruksi Robot Line Tracer dan Program IR sensor',
      'Merakit konstruksi Robot Smart Home',
      'Pengenalan Materi Pembelajaran (Lego Mindstroms NXT)',
      'Merakit konstruksi robot Five Minutes Bot',
      'Merakit konstuksi robot Mouse trap dengan touch sensor',
      'Merakit konstuksi robot Baseball Batter dengan Ultrasonik sensor',
      'Merakit konstuksi robot Line Follower dengan Light sensor',
      'Mempelajari Robot 3D Design - Pengenalan dan mempelajari aplikasi design untuk 3D Design dengan TinkerCad',
      'Mempelajari Robot 3D Design - Desain figuran dengan mesin 3D printer',
      'Pada akhir semester, siswa/i diharapkan mampu menciptakan robot dengan pemrograman dasar, mengembangkan kreativitas melalui desain 3D, memamerkan hasil karyanya saat open house/expo, serta berwirausaha dengan menjual desain mereka, seperti gantungan kunci yang dipersonalisasi'
    ],
    tags: ["Robotika", "IoT", "Pemrograman", "Desain 3D", "Line Follower", "Smart Home", "Mouse Trap", "3D Printing", "Gantungan Kunci"],
  },
  {
    image: 'img/ekskul/Game-IoT.png',
    section: 'Sekolah Menengah Atas (SMA)',
    category: 'Game',
    app: 'Unity',
    objective: 'Memberikan pemahaman dasar tentang konsep dan proses pembuatan game, mulai dari desain hingga implementasi. Siswa akan belajar pemrograman dan logika yang diterapkan dalam game. Selain itu, siswa akan mengembangkan keterampilan dalam desain pengalaman pengguna (UX), kreativitas dalam merancang game yang menarik, dan kemampuan untuk bekerja secara kolaboratif dalam tim.',
    programmingLanguage: 'C#',
    detail: [
      'Pengenalan App dan Perangkat',
      'Pengenalan bahasa pemrograman untuk game development',
      'Mempelajari proses game design',
      'Mempelajari proses pembuatan game dari kerangka hingga game jadi',
      'Pembuatan proyek inovasi',
      'Presentasi hasil proyek'
    ],
    tags: ["Game Development", "Unity", "C#", "Desain Game", "Inovasi", "Presentasi"],
  },
  {
    image: 'img/ekskul/Front-end.png',
    section: 'Sekolah Menengah Atas (SMA)',
    category: 'Front-end Web Development',
    app: 'Visual Studio Code',
    objective: 'Pemahaman murid membuat UI website menarik, interaktif, dan dapat diakses di internet menggunakan coding',
    programmingLanguage: 'HTML / CSS / Javascript',
    detail: [
      'Pengenalan App dan Perangkat',
      'Pengenalan bahasa pemrogramman untuk front-end development',
      'Mempelajari pembuatan logic pada front-end ',
      'Mempelajari styling pada front-end',
      'Mempelajari cara integrasi antara front-end dengan back-end',
      'Pembuatan proyek inovasi',
      'Presentasi hasil proyek'
    ],
    tags: ["Pemrograman", "Front-end", "Logika", "Styling", "Integrasi dengan Backend", "Inovasi", "Presentasi"],
  },
  {
    image: 'img/ekskul/Back-end.png',
    section: 'Sekolah Menengah Atas (SMA)',
    category: 'Back-end Web Development',
    app: 'Visual Studio Code',
    objective: 'Pemahaman murid membangun dan mengelola server, database, dan aplikasi web yang mendukung fungsionalitas situs web.',
    programmingLanguage: 'PHP / C#',
    detail: [
      'Pengenalan App dan Perangkat',
      'Pengenalan bahasa pemrogramman untuk back-end development',
      'Mempelajari pembuatan logic pada back-end ',
      'Mempelajari konsep API pada back-end',
      'Mempelajari tools untuk melakukan testing API (Postman, etc)',
      'Pembuatan proyek inovasi',
      'Presentasi hasil proyek'
    ],
    tags: ["Pemrograman", "Back-end", "Logika", "API", "Testing API", "Inovasi", "Presentasi"],
  },
  {
    image: 'img/ekskul/Mobile.png',
    section: 'Sekolah Menengah Atas (SMA)',
    category: 'Mobile Development',
    app: 'Visual Studio Code',
    objective: 'Pembuatan aplikasi mobile yang interaktif dan fungsionalitas menggunakan MIT AppInventor.',
    programmingLanguage: 'Javascript(React)',
    detail: [
      'Pengenalan App dan Perangkat',
      'Pengenalan bahasa pemrogramman untuk back-end development',
      'Mempelajari pembuatan logic pada back-end ',
      'Mempelajari konsep API pada back-end',
      'Mempelajari tools untuk melakukan testing API (Postman, etc)',
      'Pembuatan proyek inovasi',
      'Presentasi hasil proyek'
    ],
    tags: ["Pemrograman", "Mobile Development", "API", "Testing API", "Inovasi", "Presentasi"],
  },
  {
    image: 'img/ekskul/Competitive.png',
    section: 'Sekolah Menengah Atas (SMA)',
    category: 'Competitive Programming',
    app: 'Visual Studio Code',
    objective: 'Mengembangkan keterampilan problem-solving dan pemrograman melalui latihan-latihan yang menantang, dengan fokus pada algoritma, struktur data, dan teknik pemrograman efisien. Siswa akan belajar cara menganalisis masalah, merancang solusi yang optimal, dan mengimplementasikan kode dengan waktu dan ruang yang terbatas.',
    programmingLanguage: 'C++',
    detail: [
      'Melatih problem solving melalui case-case yang diberikan',
      'Mempelajari cara optimisasi code',
      'Mempelajari strategi dalam menghadapi competitive programming',
      'Mempelajari cara optimal dalam melakukan debugging'
    ],
    tags: ["Problem Solving", "Optimisasi Code", "Strategi Competitive Programming", "Debugging"],
  },
  {
    image: 'img/ekskul/AI.png',
    section: 'Sekolah Menengah Atas (SMA)',
    category: 'Artificial Intelligence (AI)',
    app: 'Visual Studio Code',
    objective: 'Memahami proses pembuatan artificial intelligence yang sering ditemukan di kehidupan sehari-hari.',
    programmingLanguage: 'Python',
    detail: [
      'Pengenalan App dan Perangkat',
      'Pengenalan pemrograman dan logika dasar menggunakan Python',
      'Mempelajari Machine Learning',
      'Mempelajari pembuatan Chatbot',
      'Mempelajari pembuatan Computer Vision (Object recognition, face recognition, etc)',
      'Pembuatan proyek inovasi',
      'Presentasi hasil proyek'
    ],
    tags: ["Pemrograman", "Logika", "Machine Learning", "Chatbot", "Computer Vision", "Inovasi", "Presentasi"],
  },
  {
    image: 'img/ekskul/robotika.png',
    section: 'Sekolah Menengah Atas (SMA)',
    category: 'Robotika, IoT & 3D Design',
    app: 'Lego Mindstorms NXT, Arduino, TinkerCad',
    objective: 'Pemahaman mendalam tentang robotika, pemrograman, dan simulasi elektronik. Siswa merancang, merakit, dan memprogram robot berbasis Lego NXT, Arduino, dan 3D Printing hingga mampu membuat robot berbasis sensor',
    programmingLanguage: '-',
    detail: [
      'Pengenalan robotika, Materi robot pembelajaran (Lego Mindstroms NXT)',
      'Merakit konstruksi robot Castor Bot',
      'Merakit konstuksi robot Bumper Car dengan Touch sensor',
      'Merakit konstuksi robot Claw Striker dengan Ultrasonik sensor',
      'Merakit konstuksi robot Line Follower dengan Light sensor',
      'Merakit konstuksi robot Robot Arm',
      'Pengenalan robot pembelajaran (Arduino)',
      'Pengenalan simulasi program Arduino (TinkerCad)',
      'Merakit Robot Mouse Bot (3D Design) - design dan printing',
      'Merakit Robot Mouse Bot (3D Design) - merakit dan memprogram',
      'Pada akhir semester, siswa/i diharapkan mampu menciptakan robot dengan pemrograman dasar, mengembangkan produk melalui desain 3D, memamerkan hasil karya di open house/expo, serta menjual robot Mouse Bot kepada teman-temannya'
    ],
    images: [
      { src: 'img/ekskul/robotika-sma-1.png', caption: 'Castor Bot' },
      { src: 'img/ekskul/robotika-sma-2.png', caption: 'NXT Bumper Car' },
      { src: 'img/ekskul/robotika-sma-3.png', caption: 'NXT Claw Striker' },
      { src: 'img/ekskul/robotika-sma-4.png', caption: 'Line Follower' },
      { src: 'img/ekskul/robotika-sma-5.png', caption: 'NXT Robot Arm' },
      { src: 'img/ekskul/robotika-sma-6.png', caption: 'Arduino Uno' },
      { src: 'img/ekskul/robotika-sma-7.png', caption: 'Desain Mouse Bot' },
      { src: 'img/ekskul/robotika-sma-8.png', caption: 'Sensor Ultrasonik' },
      { src: 'img/ekskul/robotika-sma-9.png', caption: 'Mouse Bot' },
    ],
    tags: ["Robotika", "IoT", "Pemrograman", "Simulasi Elektronik", "Lego Mindstorms NXT", "Arduino", "3D Design", "Mouse Bot"],
  },
]

export const educationPhases = [
  {
    id: "1.0",
    title: "Berburu dan bertani",
    subtitle: "Masyarakat Industri",
    img: "/img/ekskul/Gambar-1.0.png",
  },
  {
    id: "2.0",
    title: "Membaca dan menulis",
    subtitle: "Masyarakat Informasi",
    img: "/img/ekskul/Gambar-2.0.png",
  },
  {
    id: "3.0",
    title: "Subyek Spesialisasi",
    subtitle: "Masyarakat Cerdas",
    img: "/img/ekskul/Gambar-3.0.png",
  },
  {
    id: "4.0",
    title: "Pendidikan abad ke-21",
    subtitle: null,
    img: "/img/ekskul/Gambar-4.0.png",
  },
];

export const categories = ['Coding', 'Robotic', 'Artificial Intelligence (AI)', 'Digital Marketing', 'Bahasa Jepang', 'Competitive Programming'];

const rawArticles: Omit<Article, 'slug'>[] = [
  {
    id: 1,
    title: "Mengenal Dasar-Dasar Coding untuk Anak Sekolah",
    desc: "Coding menjadi keterampilan penting di era digital, bahkan untuk anak sekolah. Dalam artikel ini, kita membahas bagaimana memperkenalkan konsep dasar pemrograman secara menyenangkan kepada anak-anak. Mulai dari penggunaan bahasa visual seperti Scratch hingga pengenalan Python dengan cara yang ramah anak. Tujuannya adalah membuat anak-anak tidak hanya menjadi konsumen teknologi, tetapi juga pencipta. Selain itu, artikel ini memberikan panduan bagi guru dan orang tua untuk memulai kegiatan coding di sekolah atau rumah. Dengan metode pembelajaran yang tepat, anak-anak bisa belajar logika, pemecahan masalah, dan berpikir sistematis sejak dini. Ini bukan hanya tentang mencetak programmer masa depan, tapi juga mengembangkan soft skill yang akan berguna di berbagai bidang. Kita juga akan membahas tools terbaik dan kegiatan interaktif yang bisa dilakukan anak-anak agar coding menjadi aktivitas yang seru dan produktif.",
    category: "Coding",
    imageSrc: "/img/blog/coding/coding5.jpg",
    createdAt: "2025-01-07T09:15:00",
    content: [
      {
        description: "Di era serba digital ini, coding tidak lagi hanya milik para profesional IT. Anak-anak yang belajar coding sejak dini cenderung lebih mudah memahami konsep teknologi, lebih kreatif, dan mampu berpikir kritis. Coding juga mengajarkan cara berpikir komputasional kemampuan untuk memecah masalah besar menjadi bagian-bagian kecil yang lebih mudah diselesaikan. Lebih dari itu, coding mendorong anak untuk aktif menciptakan, bukan hanya mengonsumsi teknologi. Daripada sekadar bermain game, mereka bisa belajar membuat game sendiri.",
      },
    ],
  },
  {
    id: 2,
    title: "Pengenalan Kecerdasan Buatan untuk Pemula",
    desc: "Apa itu AI dan bagaimana cara kerjanya? Artikel ini menjelaskan konsep dasar kecerdasan buatan dengan bahasa yang mudah dipahami, cocok untuk pelajar dan pemula. Kami membahas perbedaan antara machine learning, deep learning, dan AI tradisional, serta contoh aplikasinya dalam kehidupan sehari-hari seperti rekomendasi video, asisten virtual, dan pengenalan wajah.",
    category: "Artificial Intelligence (AI)",
    imageSrc: "/img/blog/AI/ai5.jpg",
    createdAt: "2025-01-14T14:30:00",
    content: [
      {
        description: "Kecerdasan Buatan (Artificial Intelligence/AI) adalah cabang ilmu komputer yang membuat mesin dapat berpikir dan belajar seperti manusia. Tujuannya adalah agar komputer bisa melakukan tugas seperti mengenali wajah, memahami bahasa, membuat keputusan, atau bermain game. Salah satu cabangnya adalah Machine Learning (ML), yang memungkinkan komputer belajar dari data tanpa diprogram secara langsung, contohnya mengenali gambar kucing dari ribuan contoh. Deep Learning adalah bagian dari ML yang menggunakan jaringan saraf tiruan, meniru cara kerja otak, dan biasa digunakan dalam pengenalan suara atau wajah. AI bekerja dengan mengumpulkan data, melatih model dari pola data tersebut, lalu membuat prediksi atau keputusan—seperti rekomendasi video berdasarkan riwayat tontonan.",
      },
    ],
  },
  {
    id: 3,
    title: "Dasar-Dasar Digital Marketing untuk Pemula",
    desc: "Digital marketing menjadi keterampilan penting di era internet. Artikel ini memperkenalkan 5 pilar utama: SEO, content marketing, media sosial, email marketing, dan PPC. Cocok untuk pemula yang ingin memahami landscape digital marketing secara menyeluruh. Kami juga memberikan rekomendasi tools gratis dan sumber belajar untuk memulai perjalanan di dunia pemasaran digital.",
    category: "Digital Marketing",
    imageSrc: "/img/blog/dm/dm5.jpg",
    createdAt: "2025-01-21T11:45:00",
    content: [
      {
        description: "Digital marketing adalah keterampilan penting di era internet, yang mencakup lima pilar utama: SEO (Search Engine Optimization) untuk meningkatkan visibilitas di mesin pencari, content marketing untuk menarik audiens melalui konten bernilai seperti artikel, video, atau infografis, media sosial sebagai sarana membangun interaksi dan brand awareness di platform seperti Instagram atau LinkedIn, email marketing untuk menjalin hubungan langsung dengan pelanggan melalui kampanye berkala; serta PPC (Pay-Per-Click) seperti Google Ads untuk menjangkau audiens secara cepat melalui iklan berbayar. Pemula bisa memulai dengan tools gratis seperti Google Keyword Planner, Canva, Mailchimp, dan Google Analytics, serta belajar melalui platform seperti Google Digital Garage atau HubSpot Academy. Dengan konsistensi dan keinginan belajar, siapa pun bisa memulai perjalanan di dunia digital marketing secara efektif.",
      },
    ],
  },
  {
    id: 4,
    title: "Persiapan JLPT N5: Panduan Lengkap untuk Pemula",
    desc: "JLPT N5 adalah level dasar ujian kemampuan bahasa Jepang. Artikel ini memberikan panduan lengkap mulai dari materi yang diujikan (kosakata, tata bahasa, kanji), contoh soal, strategi belajar, hingga rekomendasi buku persiapan. Kami juga membagikan tips mengatur waktu belajar dan cara efektif menghafal kosakata dan kanji dasar untuk pemula.",
    category: "Bahasa Jepang",
    imageSrc: "/img/blog/japan/jp5.jpg",
    createdAt: "2025-01-28T16:20:00",
    content: [
      {
        description: "Untuk mempersiapkan JLPT N5, pemula perlu fokus pada tiga aspek utama: kosakata dasar, tata bahasa sederhana, dan sekitar 100 kanji umum yang sering digunakan dalam kehidupan sehari-hari. Latihan soal-soal latihan sangat penting untuk memahami format ujian, termasuk bagian mendengarkan (listening) yang menguji kemampuan memahami percakapan pendek. Strategi belajar yang efektif meliputi membagi waktu belajar setiap hari, menggunakan flashcard untuk menghafal kosakata dan kanji, serta berlatih membaca teks pendek dalam bahasa Jepang. Buku rekomendasi seperti Minna no Nihongo I, TRY! JLPT N5, dan Nihongo Sou Matome N5 sangat membantu dalam memahami pola kalimat dan latihan soal. Konsistensi, review berkala, dan penggunaan aplikasi belajar seperti Anki atau LingoDeer juga dapat mempercepat pemahaman dan retensi materi.",
      },
    ],
  },
  {
    id: 5,
    title: "Pengenalan Robotika untuk Siswa SD",
    desc: "Robotika bisa menjadi subjek yang menyenangkan untuk diperkenalkan kepada anak-anak sekolah dasar. Artikel ini menjelaskan dasar-dasar robotika menggunakan kit sederhana seperti LEGO Mindstorms atau mBot. Anak-anak akan belajar tentang sensor, aktuator, dan logika pemrograman dasar sambil bermain. Kami juga memberikan ide proyek sederhana seperti membuat robot penghindar rintangan atau robot penari.",
    category: "Robotic",
    imageSrc: "/img/blog/robotic/robot5.jpg",
    createdAt: "2025-01-04T10:10:00",
    content: [
      {
        description: "Robotika untuk siswa SD adalah cara yang menyenangkan untuk mengenalkan teknologi melalui bermain sambil belajar. Dengan menggunakan kit sederhana seperti LEGO Mindstorms, mBot, atau Bee-Bot, anak-anak dapat memahami komponen dasar robot seperti sensor (untuk mendeteksi cahaya, suara, atau gerakan), aktuator (yang menggerakkan roda atau lengan), serta logika pemrograman visual berbasis blok seperti Scratch. Melalui pendekatan praktis dan interaktif, anak-anak bisa membuat proyek menarik seperti robot penghindar rintangan, robot penari, atau robot yang mengikuti garis. Aktivitas ini tidak hanya mengasah kreativitas, tapi juga melatih keterampilan berpikir logis, pemecahan masalah, dan kerja tim sejak usia dini.",
      },
    ],
  },
  {
    id: 6,
    title: "Belajar Frontend Development untuk Pemula",
    desc: "Frontend development adalah proses membangun bagian visual dari sebuah website yang berinteraksi langsung dengan pengguna. Artikel ini membahas dasar-dasar HTML, CSS, dan JavaScript yang menjadi fondasi utama. Bagi pemula, memahami struktur HTML sebagai kerangka, styling dengan CSS, dan logika dengan JavaScript sangatlah penting. Kami juga membahas framework populer seperti React dan bagaimana mengintegrasikannya dalam proyek nyata. Selain itu, pentingnya responsivitas dan pengalaman pengguna dijelaskan secara detail. Artikel ini cocok untuk siapa saja yang ingin memulai karir di bidang web development, dengan tips belajar yang efisien, sumber daya gratis, dan proyek mini yang bisa dicoba. Frontend bukan hanya soal tampilan, tapi juga performa dan aksesibilitas. Dengan pendekatan yang terstruktur dan konsisten, siapa pun bisa menguasai keterampilan ini dan membangun web yang menarik serta fungsional.",
    category: "Coding",
    imageSrc: "/img/blog/coding/coding4.jpg",
    createdAt: "2025-02-11T13:25:00",
    content: [
      {
        description: "Belajar frontend development adalah langkah awal yang tepat bagi siapa pun yang ingin terjun ke dunia web. Pemula perlu memahami tiga pilar utama: HTML untuk membangun struktur halaman, CSS untuk mempercantik tampilan, dan JavaScript untuk menambahkan interaktivitas. Setelah dasar dikuasai, belajar framework seperti React akan membantu dalam membangun antarmuka yang lebih kompleks dan efisien. Selain itu, konsep responsivitas agar website tampil baik di berbagai perangkat, serta user experience (UX) dan aksesibilitas menjadi aspek penting dalam pengembangan web modern. Dengan memanfaatkan sumber daya gratis seperti freeCodeCamp, MDN Web Docs, dan channel YouTube edukatif, serta mencoba proyek mini seperti landing page atau to-do list, pemula bisa belajar dengan lebih menyenangkan dan terarah. Frontend bukan hanya soal tampilan menarik, tapi juga bagaimana memastikan performa, kecepatan, dan kemudahan akses bagi semua pengguna.",
      },
    ],
  },
  {
    id: 7,
    title: "Belajar Machine Learning untuk Siswa SMA",
    desc: "Machine learning tidak harus rumit! Artikel ini memperkenalkan dasar-dasar ML menggunakan tools seperti Teachable Machine dari Google yang memungkinkan siswa membuat model AI tanpa menulis kode. Kami juga membahas platform seperti Kaggle untuk belajar melalui kompetisi dan proyek-proyek sederhana yang bisa dilakukan dengan Python dan library seperti scikit-learn.",
    category: "Artificial Intelligence (AI)",
    imageSrc: "/img/blog/AI/ai4.jpg",
    createdAt: "2025-02-18T15:40:00",
    content: [
      {
        description: "Belajar machine learning untuk siswa SMA bisa menjadi pengalaman yang menyenangkan dan membangun rasa ingin tahu terhadap teknologi. Dengan tools visual seperti **Teachable Machine dari Google**, siswa dapat membuat model AI sederhana hanya dengan mengunggah gambar, suara, atau gerakan tanpa perlu menulis kode. Ini membantu mereka memahami konsep dasar seperti pelatihan model, klasifikasi, dan data input/output secara intuitif. Bagi yang ingin melangkah lebih jauh, platform seperti **Kaggle** menyediakan tantangan dan dataset yang cocok untuk pemula, lengkap dengan notebook Python interaktif. Di tahap ini, siswa bisa mulai mengenal coding menggunakan **Python** dan library populer seperti **scikit-learn** untuk membuat proyek sederhana, seperti prediksi cuaca atau klasifikasi jenis bunga. Melalui pendekatan bertahap dan berbasis proyek nyata, siswa tidak hanya belajar teori, tetapi juga melihat langsung bagaimana AI dan machine learning digunakan dalam kehidupan sehari-hari.",
      },
    ],
  },
  {
    id: 8,
    title: "Cara Membangun Personal Branding untuk Pelajar",
    desc: "Personal branding penting bahkan untuk pelajar! Artikel ini memberikan tips bagaimana siswa bisa membangun citra online yang positif melalui LinkedIn, portofolio digital, dan media sosial. Kami membahas strategi konten, networking, dan bagaimana memanfaatkan platform digital untuk menunjukkan minat dan bakat, yang bisa berguna untuk beasiswa atau peluang magang.",
    category: "Digital Marketing",
    imageSrc: "/img/blog/dm/dm4.jpg",
    createdAt: "2025-02-25T09:50:00",
    content: [
      {
        description: "Membangun personal branding sejak masa pelajar dapat membuka banyak peluang, mulai dari beasiswa, program pertukaran, hingga magang. Pelajar bisa memulainya dengan membuat akun **LinkedIn** yang profesional untuk menampilkan prestasi, proyek sekolah, dan minat akademik. Selain itu, **portofolio digital** seperti blog, situs pribadi, atau akun GitHub (untuk siswa teknologi) dapat menjadi wadah menampilkan hasil karya dan pencapaian. Gunakan media sosial secara positif—misalnya membagikan pengalaman belajar, opini tentang topik yang diminati, atau dokumentasi kegiatan produktif. Strategi konten sederhana bisa meningkatkan citra diri secara konsisten. Tak kalah penting, aktiflah dalam networking melalui komunitas online, webinar, atau organisasi siswa. Dengan konsistensi, sikap positif, dan keaslian, personal branding bisa menjadi aset penting dalam perjalanan pendidikan dan karier pelajar ke depan.",
      },
    ],
  },
  {
    id: 9,
    title: "Perbedaan JLPT N4 dan N3: Mana yang Harus Diambil?",
    desc: "Memilih level JLPT yang tepat penting untuk efisiensi belajar. Artikel ini membandingkan secara detail perbedaan antara level N4 (dasar menengah) dan N3 (menengah) dalam hal jumlah kanji, kosakata, tata bahasa, dan kemampuan membaca/mendengar yang diujikan. Kami juga memberikan rekomendasi berdasarkan tujuan Anda, apakah untuk kerja, kuliah, atau sekadar menguji kemampuan.",
    category: "Bahasa Jepang",
    imageSrc: "/img/blog/japan/jp3.jpg",
    createdAt: "2025-03-04T14:15:00",
    content: [
      {
        description: "JLPT N4 dan N3 memiliki perbedaan signifikan dalam tingkat kesulitan dan cakupan materi. N4 merupakan level dasar-menengah yang menuntut penguasaan sekitar 300-400 kanji dan 1.500 kosakata, serta kemampuan memahami percakapan sehari-hari yang sederhana dan membaca kalimat pendek. Sebaliknya, N3 adalah level menengah yang menguji sekitar 650-700 kanji dan 3.500-4.000 kosakata, dengan tuntutan pemahaman teks yang lebih kompleks dan percakapan dengan kecepatan mendekati penutur asli. Jika Anda masih memperkuat dasar bahasa Jepang dan belum percaya diri membaca artikel atau berita pendek, N4 adalah pilihan yang lebih realistis. Namun, jika Anda ingin mulai bekerja di Jepang, atau mendaftar beasiswa dan program kuliah, N3 lebih disarankan karena sudah mulai diakui dalam dunia profesional dan akademik. Pilih level berdasarkan tujuan akhir dan kesiapan Anda secara materi dan waktu belajar, agar proses persiapan menjadi lebih fokus dan efektif",
      },
    ],
  },
  {
    id: 10,
    title: "Membuat Robot Sederhana dengan Arduino",
    desc: "Arduino adalah platform yang sempurna untuk memulai belajar robotika. Artikel ini memandu siswa SMP/SMA dalam membuat robot sederhana menggunakan Arduino Uno. Dari pemasangan komponen dasar seperti motor dan sensor hingga pemrograman menggunakan bahasa C++ yang disederhanakan. Proyek ini tidak hanya mengajarkan teknik robotika tetapi juga pemecahan masalah dan pemikiran sistematis.",
    category: "Robotic",
    imageSrc: "/img/blog/robotic/robot4.jpg",
    createdAt: "2025-02-11T11:30:00",
    content: [
      {
        description: "Membuat robot sederhana dengan Arduino adalah langkah awal yang ideal bagi siswa SMP dan SMA untuk mengenal dunia robotika secara praktis. Dengan menggunakan Arduino Uno sebagai otak robot, siswa dapat mulai dari merakit komponen dasar seperti motor DC, sensor ultrasonik, LED, dan breadboard, lalu menghubungkannya sesuai skema rangkaian. Setelah perangkat keras siap, mereka akan belajar menulis kode sederhana menggunakan bahasa pemrograman berbasis C++, seperti mengatur gerakan motor, membaca data dari sensor, dan merespons lingkungan sekitar misalnya membuat robot yang bisa menghindari rintangan atau mengikuti cahaya. Proyek ini mengajarkan konsep dasar seperti input-output, logika IF, dan penggunaan loop, sekaligus mendorong siswa berpikir secara sistematis dan kreatif dalam menyelesaikan masalah nyata. Dengan pendekatan belajar sambil praktik, siswa tidak hanya memahami teori, tetapi juga mendapat pengalaman langsung membangun teknologi.",
      },
    ],
  },
  {
    id: 11,
    title: "Dasar-Dasar Backend Development dengan Node.js",
    desc: "Backend development adalah bagian dari pengembangan web yang berfokus pada logika server, database, dan integrasi sistem. Dalam artikel ini, kita akan membahas Node.js sebagai salah satu platform populer untuk backend. Node.js memungkinkan developer membangun server menggunakan JavaScript, sehingga cocok bagi yang telah mengenal frontend. Kita juga akan mempelajari Express.js sebagai framework untuk membuat RESTful API dengan cepat. Artikel ini mencakup konsep dasar seperti routing, middleware, dan pengelolaan data menggunakan database seperti MongoDB. Selain itu, dibahas juga praktik keamanan dasar seperti validasi input dan autentikasi. Bagi pemula, artikel ini menyediakan langkah-langkah praktis, contoh kode, dan referensi proyek sederhana. Dengan menguasai backend, Anda bisa membuat aplikasi yang tidak hanya menarik dari sisi tampilan, tapi juga kuat dari sisi fungsionalitas dan performa. Ini adalah fondasi penting untuk menjadi fullstack developer yang kompeten.",
    category: "Coding",
    imageSrc: "/img/blog/coding/coding3.jpg",
    createdAt: "2025-03-18T16:45:00",
    content: [
      {
        description: "Node.js membuka pintu bagi para pengembang frontend untuk masuk ke dunia backend tanpa harus mempelajari bahasa baru, karena semuanya bisa dilakukan dengan JavaScript. Dalam backend development, Anda akan belajar bagaimana server menerima permintaan dari pengguna, memprosesnya, berinteraksi dengan database seperti MongoDB, dan mengirimkan respons kembali ke frontend. Dengan bantuan Express.js, pembuatan server dan API menjadi lebih mudah melalui konsep-konsep seperti routing (menentukan jalur akses data), middleware (fungsi yang menangani logika tambahan seperti autentikasi atau logging), serta pengelolaan data melalui operasi CRUD (Create, Read, Update, Delete). Anda juga akan belajar aspek penting lainnya seperti validasi input, mencegah serangan injection, dan menerapkan sistem login dengan token (JWT). Artikel ini juga menyarankan proyek kecil seperti aplikasi catatan atau to-do list yang terhubung ke database sebagai latihan. Menguasai dasar backend dengan Node.js memberi Anda kendali penuh atas data dan alur aplikasi, menjadikan Anda selangkah lebih dekat untuk menjadi fullstack developer yang andal.",
      },
    ],
  },
  {
    id: 12,
    title: "Etika dalam Pengembangan AI",
    desc: "Seiring perkembangan AI, isu etika menjadi semakin penting. Artikel ini membahas tantangan seperti bias algoritma, privasi data, dan dampak AI terhadap lapangan kerja. Cocok untuk profesional dan pelajar yang ingin memahami tanggung jawab dalam pengembangan teknologi AI. Kami juga memberikan contoh kasus nyata dan bagaimana perusahaan terkemuka menangani isu etika ini.",
    category: "Artificial Intelligence (AI)",
    imageSrc: "/img/blog/AI/ai3.jpg",
    createdAt: "2025-03-25T10:20:00",
    content: [
      {
        description: "Etika dalam pengembangan AI menjadi isu krusial seiring meningkatnya penggunaan teknologi ini di berbagai sektor. Salah satu tantangan utamanya adalah bias algoritma, di mana AI dapat menghasilkan keputusan yang tidak adil akibat data latih yang tidak representatif atau diskriminatif. Selain itu, privasi data menjadi perhatian besar karena AI sering memproses informasi pribadi dalam skala besar, sehingga memerlukan perlindungan dan transparansi yang ketat. Dampak terhadap lapangan kerja juga tidak bisa diabaikan, karena otomatisasi berbasis AI dapat menggantikan peran manusia di beberapa bidang, meskipun juga menciptakan jenis pekerjaan baru. Beberapa kasus nyata seperti kesalahan pengenalan wajah oleh sistem keamanan atau diskriminasi dalam rekrutmen otomatis menjadi pengingat pentingnya pengawasan dan regulasi. Perusahaan teknologi terkemuka seperti Google dan Microsoft telah membentuk komite etika internal dan menerapkan prinsip seperti AI yang adil, transparan, dan bertanggung jawab. Dengan memahami dan menerapkan etika dalam pengembangan AI, kita dapat memastikan bahwa teknologi ini memberi manfaat luas tanpa mengorbankan nilai-nilai kemanusiaan.",
      },
    ],
  },
  {
    id: 13,
    title: "Strategi Konten Viral di Media Sosial",
    desc: "Apa rahasia di balik konten yang viral? Artikel ini menganalisis pola dan strategi yang membuat konten tersebar luas, dari pemilihan topik, format konten, timing posting, hingga teknik engagement. Cocok untuk content creator pemula maupun profesional yang ingin meningkatkan jangkauan organik. Kami juga membahas studi kasus dari kampanye viral terbaru.",
    category: "Digital Marketing",
    imageSrc: "/img/blog/dm/dm3.jpg",
    createdAt: "2025-04-01T13:35:00",
    content: [
      {
        description: "Strategi konten viral di media sosial melibatkan pemilihan topik yang relevan, format yang menarik (seperti video pendek atau carousel), waktu posting yang tepat, dan ajakan interaksi yang kuat. Konten yang menyentuh emosi, menghibur, atau memberi nilai cenderung lebih mudah dibagikan. Dengan memahami pola viral dan belajar dari kampanye sukses, baik pemula maupun profesional bisa meningkatkan jangkauan secara organik",
      },
    ],
  },
  {
    id: 14,
    title: "Peluang Kerja untuk Lulusan JLPT N2 ke Atas di Indonesia",
    desc: "Memiliki sertifikat JLPT N2 atau N1 membuka banyak peluang karir. Artikel ini mengulas berbagai profesi yang membutuhkan kemampuan bahasa Jepang level lanjut di Indonesia, dari penerjemah, guide turis, staf perusahaan Jepang, hingga pekerjaan di bidang IT dan engineering. Kami juga membahas kisaran gaji, perusahaan yang merekrut, dan keterampilan pendukung yang perlu dimiliki.",
    category: "Bahasa Jepang",
    imageSrc: "/img/blog/japan/jp4.jpg",
    createdAt: "2025-04-08T15:50:00",
    content: [
      {
        description: "Lulusan JLPT N2 ke atas memiliki peluang kerja luas di Indonesia, terutama di perusahaan Jepang yang bergerak di sektor manufaktur, otomotif, teknologi, dan layanan. Posisi umum meliputi penerjemah/interpreter, staf administrasi bilingual, HR, sales ekspor-impor, hingga engineer dan developer IT yang bekerja sama langsung dengan klien Jepang. Kisaran gaji bervariasi, mulai dari Rp6-15 juta per bulan untuk posisi staf, dan bisa lebih tinggi untuk posisi spesialis atau supervisor, tergantung pengalaman dan keahlian tambahan. Perusahaan seperti Astra Group (yang bermitra dengan Jepang), Panasonic, Yamaha, dan perusahaan logistik Jepang di Cikarang dan Karawang kerap mencari kandidat dengan JLPT N2/N1. Keterampilan tambahan seperti etika kerja Jepang, kemampuan komunikasi bisnis, dan penguasaan tools seperti Excel atau ERP akan menjadi nilai tambah dalam seleksi kerja.",
      },
    ],
  },
  {
    id: 15,
    title: "Kompetisi Robotika untuk Pelajar Indonesia",
    desc: "Indonesia memiliki berbagai kompetisi robotika yang cocok untuk pelajar dari berbagai tingkat. Artikel ini mengulas event seperti Indonesian Robot Olympiad (IRO), Kontes Robot Indonesia (KRI), dan kompetisi sekolah lainnya. Kami memberikan tips bagaimana mempersiapkan diri, membentuk tim, dan memilih kategori yang sesuai. Kompetisi robotika bisa menjadi pengalaman berharga untuk mengasah keterampilan teknis dan soft skill.",
    category: "Robotic",
    imageSrc: "/img/blog/robotic/robot3.jpg",
    createdAt: "2025-03-15T09:05:00",
    content: [
      {
        description: "Kompetisi robotika untuk pelajar di Indonesia menjadi ajang yang tidak hanya menantang kemampuan teknis, tetapi juga mengembangkan kreativitas, kerja tim, dan problem solving. Event seperti Indonesian Robot Olympiad (IRO) cocok untuk pelajar SD hingga SMA, dengan kategori menarik seperti robot penari, robot penyelamat, atau robot garis. Sementara itu, Kontes Robot Indonesia (KRI) lebih ditujukan untuk mahasiswa, namun tetap bisa menjadi inspirasi dan tujuan jangka panjang bagi pelajar yang ingin serius menekuni robotika. Sekolah-sekolah juga sering mengadakan lomba robotik internal atau antar sekolah, yang bisa menjadi tempat awal melatih kemampuan. Untuk mempersiapkan diri, pelajar disarankan membentuk tim dengan peran yang jelas (programmer, perakit, dokumentasi), memilih kategori lomba yang sesuai dengan minat dan kemampuan, serta rutin berlatih dan melakukan simulasi. Selain memahami perangkat keras dan software robotik, peserta juga perlu mengasah soft skill seperti komunikasi, manajemen waktu, dan presentasi proyek. Melalui kompetisi ini, pelajar tidak hanya belajar teknologi, tetapi juga membangun semangat inovasi dan kolaborasi sejak dini.",
      },
    ],
  },
  {
    id: 16,
    title: "Mengapa Anak Sekolah Perlu Belajar Pemrograman Sejak Dini",
    desc: "Belajar pemrograman sejak dini memberikan berbagai manfaat bagi anak sekolah. Artikel ini membahas bagaimana coding melatih logika, kreativitas, dan kemampuan memecahkan masalah. Di era digital, kemampuan teknologi menjadi aset penting dan belajar sejak usia muda akan memberi keunggulan tersendiri. Kami juga membahas berbagai platform ramah anak seperti Code.org dan Scratch yang membantu pembelajaran lebih menyenangkan. Selain aspek teknis, belajar coding juga meningkatkan rasa percaya diri dan kerja tim, apalagi jika dikombinasikan dengan proyek kolaboratif. Artikel ini juga memberikan panduan kepada orang tua dan guru dalam memilih program belajar coding yang sesuai usia dan tingkat pemahaman anak. Dengan pembelajaran yang menyenangkan dan interaktif, coding bisa menjadi kegiatan yang tidak hanya edukatif tapi juga menghibur. Artikel ini bertujuan mendorong sekolah-sekolah untuk mengintegrasikan coding sebagai bagian dari kurikulum wajib.",
    category: "Coding",
    imageSrc: "/img/blog/coding/coding2.jpg",
    createdAt: "2025-04-16T14:25:00",
    content: [
      {
        description: "Belajar pemrograman sejak dini membantu anak mengembangkan logika, kreativitas, dan kemampuan memecahkan masalahketerampilan penting di era digital. Platform seperti Scratch dan Code.org memungkinkan anak belajar coding dengan cara yang menyenangkan dan visual. Selain aspek teknis, coding juga meningkatkan kepercayaan diri, kerja sama tim, dan rasa ingin tahu. Orang tua dan guru dapat memilih program belajar sesuai usia agar materi lebih mudah dipahami. Dengan pendekatan interaktif dan proyek kolaboratif, coding bukan hanya bermanfaat, tapi juga jadi aktivitas seru yang layak dimasukkan ke dalam kurikulum sekolah.",
      },
    ],
  },
  {
    id: 17,
    title: "Membangun Chatbot Sederhana dengan Python",
    desc: "Ingin membuat chatbot sendiri? Artikel ini memandu pembaca langkah demi langkah dalam membangun chatbot sederhana menggunakan Python dan library NLTK atau ChatterBot. Cocok untuk pemula yang sudah memiliki dasar pemrograman Python. Kami membahas dari pemrosesan bahasa alami dasar hingga integrasi dengan platform seperti Telegram atau Discord.",
    category: "Artificial Intelligence (AI)",
    imageSrc: "/img/blog/AI/ai2.jpg",
    createdAt: "2025-04-17T11:40:00",
    content: [
      {
        description: "Membangun chatbot sederhana dengan Python bisa dimulai dengan menggunakan library seperti ChatterBot atau NLTK untuk memahami dan merespons input pengguna. ChatterBot memungkinkan pembuatan chatbot dengan cepat tanpa perlu algoritma rumit, cukup dengan melatih bot menggunakan contoh percakapan. Sedangkan NLTK lebih fleksibel untuk pemrosesan bahasa alami seperti tokenisasi, stemming, dan analisis intent. Setelah chatbot dapat merespons, Anda bisa mengintegrasikannya ke platform seperti Telegram atau Discord menggunakan bot API masing-masing. Proyek ini cocok untuk pemula yang ingin memahami dasar-dasar NLP dan interaksi manusia-komputer secara praktis.",
      },
    ],
  },
  {
    id: 18,
    title: "Google Analytics untuk Pemula",
    desc: "Google Analytics adalah tools wajib bagi digital marketer. Artikel ini memandu pembaca dalam memahami antarmuka GA, metrik kunci seperti bounce rate dan session duration, serta cara membuat laporan sederhana. Kami juga memberikan tips bagaimana menggunakan data untuk meningkatkan website performance dan conversion rate. Dilengkapi dengan screenshot dan penjelasan step-by-step.",
    category: "Digital Marketing",
    imageSrc: "/img/blog/dm/dm2.jpg",
    createdAt: "2025-04-18T16:55:00",
    content: [
      {
        description: "Google Analytics membantu Anda memahami bagaimana pengunjung berinteraksi dengan website. Pemula bisa mulai dengan melihat metrik penting seperti jumlah pengguna, bounce rate (pengunjung yang langsung pergi), dan session duration (lama kunjungan). Gunakan menu Behavior > Site Content > All Pages untuk mengetahui halaman terpopuler. Anda juga bisa membuat laporan sederhana dan mengatur Goals untuk melacak tindakan seperti klik tombol atau isi formulir. Dengan rutin memantau data, Anda dapat meningkatkan performa website dan conversion rate secara efektif.",
      },
    ],
  },
  {
    id: 19,
    title: "Belajar Bahasa Jepang Otodidak: Tips dan Sumber Belajar",
    desc: "Tidak perlu kursus mahal untuk menguasai bahasa Jepang! Artikel ini membagikan strategi belajar mandiri yang efektif, mulai dari aplikasi seperti Duolingo dan Anki, channel YouTube rekomendasi, podcast, hingga metode shadowing untuk melatih pengucapan. Kami juga memberikan jadwal belajar contoh dan cara menciptakan lingkungan berbahasa Jepang meski tidak tinggal di Jepang.",
    category: "Bahasa Jepang",
    imageSrc: "/img/blog/japan/jp2.jpg",
    createdAt: "2025-04-19T10:10:00",
    content: [
      {
        description: "Belajar bahasa Jepang secara otodidak bisa efektif asal konsisten dan menggunakan sumber belajar yang tepat. Mulailah dengan aplikasi seperti Duolingo atau LingoDeer untuk membangun kosakata dasar, lalu gunakan Anki untuk menghafal hiragana, katakana, dan kanji secara bertahap. Tambahkan channel YouTube seperti JapanesePod101 atau Nihongo no Mori untuk memperkuat pemahaman tata bahasa dan listening. Metode shadowing, yaitu meniru pengucapan dari audio native speaker secara langsung, sangat membantu dalam memperbaiki intonasi dan pelafalan. Buatlah jadwal belajar harian, misalnya 15-30 menit membaca, 15 menit mendengarkan, dan 15 menit review kosakata. Untuk menciptakan suasana berbahasa Jepang, ubah pengaturan gadget ke bahasa Jepang, tempelkan label kanji di rumah, dan ikuti akun media sosial berbahasa Jepang. Dengan lingkungan yang mendukung dan rutinitas yang terarah, belajar bahasa Jepang secara mandiri bisa menjadi proses yang menyenangkan dan membuahkan hasil.",
      },
    ],
  },
  {
    id: 20,
    title: "Robotika dalam Kehidupan Sehari-hari",
    desc: "Robot tidak hanya ada di film sci-fi, tapi sudah menjadi bagian kehidupan kita. Artikel ini memperkenalkan berbagai aplikasi robotika di sekitar kita, dari robot pembersih rumah, robot di pabrik, hingga robot untuk eksplorasi luar angkasa. Kami juga membahas bagaimana mempersiapkan karir di bidang robotika dan keterampilan apa yang perlu dikuasai sejak sekolah.",
    category: "Robotic",
    imageSrc: "/img/blog/robotic/robot2.jpg",
    createdAt: "2025-04-20T13:20:00",
    content: [
      {
        description: "Robotika kini hadir dalam banyak aspek kehidupan, mulai dari robot vacuum yang membersihkan lantai secara otomatis, lengan robot di pabrik yang merakit produk dengan presisi tinggi, hingga robot penjelajah seperti di Mars yang membantu penelitian luar angkasa. Untuk mempersiapkan karir di bidang ini, pelajar perlu menguasai dasar matematika, fisika, pemrograman, serta kemampuan berpikir logis dan kreatif. Mengikuti ekstrakurikuler robotika, kursus online, atau membuat proyek sederhana sejak dini bisa menjadi langkah awal menuju dunia teknologi masa depan.",
      },
    ],
  },
  {
    id: 21,
    title: "Menjadi Fullstack Developer: Panduan Lengkap untuk Pemula",
    desc: "Fullstack developer adalah seseorang yang menguasai pengembangan frontend dan backend sekaligus. Artikel ini memberikan panduan lengkap untuk pemula yang ingin menekuni jalur karir ini. Dimulai dari pengenalan teknologi frontend seperti HTML, CSS, JavaScript, hingga framework seperti React. Kemudian dilanjutkan dengan backend menggunakan Node.js, Express, dan pengelolaan database seperti MongoDB atau PostgreSQL. Kami juga membahas pentingnya penguasaan tools seperti Git, Docker, dan sistem version control lainnya. Dengan roadmap belajar yang jelas dan bertahap, pembaca bisa memahami alur kerja fullstack dari awal hingga deployment aplikasi. Artikel ini juga membagikan tips membangun portofolio dan bagaimana mempersiapkan diri untuk wawancara kerja. Menjadi fullstack developer membutuhkan waktu dan dedikasi, namun dengan sumber belajar yang tepat dan praktik berkelanjutan, siapa pun bisa mencapainya. Ini adalah profesi yang menjanjikan di dunia teknologi masa kini.",
    category: "Coding",
    imageSrc: "/img/blog/coding/coding1.jpg",
    createdAt: "2025-05-21T15:35:00",
    content: [
      {
        description: "Untuk menjadi fullstack developer, pemula perlu membangun fondasi kuat di frontend dan backend secara bertahap. Mulailah dengan menguasai HTML, CSS, dan JavaScript, lalu lanjutkan ke framework modern seperti React. Di sisi backend, pelajari Node.js, Express, serta pengelolaan database seperti MongoDB atau PostgreSQL. Penggunaan tools seperti Git untuk version control, serta Docker untuk containerisasi, juga sangat penting dalam workflow pengembangan aplikasi. Buatlah proyek nyata seperti aplikasi to-do list atau blog agar lebih memahami alur kerja end-to-end. Bangun portofolio online di GitHub dan pelajari tips menghadapi wawancara teknikal. Dengan konsistensi, latihan, dan eksplorasi sumber belajar gratis maupun berbayar, jalan menuju karir fullstack developer terbuka lebar bagi siapa pun yang serius menekuninya.",
      },
    ],
  },
  {
    id: 22,
    title: "Masa Depan AI dan Peluang Karir di Indonesia",
    desc: "AI menjadi salah satu bidang dengan pertumbuhan tercepat. Artikel ini mengulas berbagai peluang karir di bidang AI di Indonesia, dari data scientist, AI engineer, hingga AI researcher. Kami juga membahas keterampilan yang dibutuhkan, gaji rata-rata, dan institusi pendidikan yang menawarkan program terkait AI. Cocok untuk siswa SMA yang merencanakan karir atau profesional yang ingin beralih ke bidang AI.",
    category: "Artificial Intelligence (AI)",
    imageSrc: "/img/blog/AI/ai1.png",
    createdAt: "2025-05-12T09:45:00",
    content: [
      {
        description: "Masa depan AI di Indonesia sangat menjanjikan, dengan peluang karir seperti data scientist, AI engineer, dan AI researcher semakin dibutuhkan di berbagai sektor, mulai dari teknologi, keuangan, hingga kesehatan. Untuk masuk ke bidang ini, keterampilan seperti pemrograman (Python), statistika, dan pemahaman machine learning sangat penting. Gaji awal di bidang AI cukup kompetitif, berkisar antara 8-20 juta rupiah per bulan tergantung posisi dan pengalaman. Beberapa kampus seperti UI, ITB, dan BINUS sudah menawarkan program studi atau pelatihan khusus terkait AI. Bidang ini cocok bagi siswa SMA yang tertarik teknologi dan logika, maupun profesional yang ingin meng-upgrade karier ke ranah digital masa depan.",
      },
    ],
  },
  {
    id: 23,
    title: "Freelance Digital Marketing: Memulai dan Mengembangkan Bisnis",
    desc: "Ingin menjadi freelancer di bidang digital marketing? Artikel ini membahas langkah-langkah praktis mulai dari menentukan niche, membangun portofolio, menentukan harga, hingga mendapatkan klien pertama. Kami juga membahas platform freelance seperti Upwork dan Fiverr, serta strategi untuk berkembang dari freelancer ke agensi. Cocok untuk profesional yang ingin memiliki bisnis sendiri.",
    category: "Digital Marketing",
    imageSrc: "/img/blog/dm/dm1.jpg",
    createdAt: "2025-04-23T14:00:00",
    content: [
      {
        description: "Memulai karier sebagai freelancer digital marketing bisa menjadi jalan menuju kemandirian finansial dan fleksibilitas kerja. Langkah pertama adalah menentukan niche yang sesuai minat dan keahlian, seperti social media marketing, SEO, copywriting, atau paid ads. Selanjutnya, bangun portofolio digital dengan studi kasus atau proyek pribadi untuk menunjukkan kemampuan Anda. Saat menentukan harga, mulailah dari tarif kompetitif sambil terus menyesuaikan seiring bertambahnya pengalaman dan hasil kerja. Platform seperti Upwork, Fiverr, dan Freelancer.com bisa menjadi tempat awal mendapatkan klien pertama—pastikan profil Anda menarik dan deskripsi layanan jelas. Untuk mengembangkan bisnis, jalin relasi dengan klien jangka panjang, mintalah testimoni, dan gunakan media sosial serta website pribadi untuk membangun kredibilitas. Seiring waktu, Anda bisa naik level dari freelancer menjadi solopreneur atau bahkan membentuk agen digital marketing kecil dengan tim spesialis. Kunci suksesnya: konsistensi, pembelajaran berkelanjutan, dan pelayanan yang memuaskan.",
      },
    ],
  },
  {
    id: 24,
    title: "Bahasa Jepang Bisnis: Ungkapan Penting untuk Dunia Kerja",
    desc: "Bahasa Jepang bisnis berbeda dengan bahasa sehari-hari. Artikel ini mengajarkan keigo (bahasa hormat), ungkapan formal dalam email dan meeting, serta budaya kerja di perusahaan Jepang. Cocok untuk profesional yang akan bekerja di perusahaan Jepang atau berinteraksi dengan klien Jepang. Kami juga membahas etika bisnis dan kesalahan umum yang harus dihindari.",
    category: "Bahasa Jepang",
    imageSrc: "/img/blog/japan/jp1.jpg",
    createdAt: "2025-04-24T11:15:00",
    content: [
      {
        description: "Bahasa Jepang bisnis atau keigo adalah bentuk komunikasi formal yang digunakan di dunia kerja, dan sangat berbeda dari bahasa Jepang sehari-hari. Dalam situasi profesional, penting untuk memahami tiga jenis keigo: sonkeigo (bahasa hormat untuk lawan bicara), kenjougo (bahasa merendah untuk diri sendiri), dan teineigo (bahasa sopan umum). Contoh ungkapan penting termasuk “お世話になっております” (osewa ni natte orimasu) untuk membuka email profesional, atau “よろしくお願いいたします” saat menutup percakapan atau permintaan. Dalam meeting, ungkapan seperti “ご確認お願いいたします” (mohon dicek) atau “少々お待ちください” (harap tunggu sebentar) sering digunakan. Selain bahasa, memahami etika bisnis Jepang juga krusial, seperti membungkuk saat memberi salam, bertukar kartu nama dengan dua tangan, dan menghindari bersikap terlalu langsung. Kesalahan umum yang perlu dihindari antara lain menggunakan bentuk kasual dalam situasi formal, salah menyebut nama atasan, atau tidak memahami hierarki komunikasi. Dengan menguasai bahasa dan budaya kerja Jepang, Anda dapat membangun hubungan profesional yang lebih baik dan menunjukkan rasa hormat yang sesuai dalam lingkungan bisnis Jepang.",
      },
    ],
  },
  {
    id: 25,
    title: "Belajar Pemrograman Robot dengan Scratch",
    desc: "Scratch bukan hanya untuk membuat animasi, tapi juga bisa digunakan untuk memprogram robot sederhana. Artikel ini mengajarkan dasar-dasar pemrograman robot menggunakan antarmuka blok visual Scratch yang ramah untuk pemula. Dengan proyek seperti robot penari atau robot yang mengikuti garis, siswa akan memahami konsep dasar kontrol robot tanpa perlu mempelajari sintaks pemrograman yang rumit.",
    category: "Robotic",
    imageSrc: "/img/blog/robotic/robot1.png",
    createdAt: "2025-05-25T16:30:00",
    content: [
      {
        description: "Belajar pemrograman robot dengan Scratch memberikan pengalaman seru dan edukatif bagi anak-anak maupun pemula dalam dunia teknologi. Dengan antarmuka blok yang intuitif, pengguna cukup menyusun blok logika seperti puzzle tanpa perlu mengetik kode. Scratch dapat dihubungkan dengan perangkat robotik seperti LEGO WeDo, mBot, atau microbit, memungkinkan robot merespons sensor, bergerak, dan berinteraksi dengan lingkungan sekitar. Proyek seperti robot penari, robot yang mengikuti garis, atau robot penghindar rintangan tidak hanya melatih logika dan kreativitas, tetapi juga mengenalkan konsep dasar sistem input-output, loop, dan pengambilan keputusan. Dengan pendekatan yang menyenangkan ini, siswa belajar coding, robotika, dan pemikiran komputasional tanpa tekanan teknis yang berat.",
      },
    ],
  },
  {
    id: 26,
    title: "Belajar HTML & CSS Dasar untuk Pemula",
    desc: "HTML dan CSS adalah dasar utama dalam pembuatan website. Artikel ini membahas struktur dasar HTML yang digunakan untuk menyusun konten halaman web, serta peran CSS dalam mempercantik tampilan dengan mengatur warna, layout, dan gaya visual lainnya. Topik ini cocok untuk pemula, termasuk pelajar, yang ingin memahami cara kerja halaman web dari nol. Beberapa tools populer seperti CodePen dan VS Code juga akan dibahas sebagai alat bantu dalam proses belajar dan eksperimen secara langsung",
    category: "Coding",
    imageSrc: "/img/blog/coding/coding6.jpg",
    createdAt: "2025-06-26T10:00:00",
    content: [
      {
        description: "Belajar HTML & CSS Dasar untuk Pemula memberikan pengenalan yang kuat tentang dasar-dasar pengembangan web. Artikel ini mencakup konsep-konsep penting seperti struktur HTML, elemen, atribut, dan pengenalan CSS untuk styling. Dengan pendekatan langkah-demi-langkah, pembaca akan diajak untuk membuat halaman web sederhana, memahami cara kerja elemen-elemen HTML, dan menerapkan gaya menggunakan CSS. Proyek praktis seperti membuat halaman profil atau portofolio akan membantu pembaca menerapkan apa yang telah dipelajari dengan cara yang menyenangkan dan interaktif.",
      },
    ],
  },
  {
    id: 27,
    title: "Sensor dan Motor: Jantung dari Robot Pintar",
    desc: "Sensor dan motor adalah dua komponen utama dalam sistem robotik. Artikel ini menjelaskan cara kerja berbagai jenis sensor seperti ultrasonik, cahaya, dan suhu, serta bagaimana motor digunakan untuk pergerakan. Sangat cocok untuk siswa yang ingin memahami mekanisme dasar robot",
    category: "Robotic",
    imageSrc: "/img/blog/robotic/robot6.png",
    createdAt: "2025-06-24T10:00:00",
    content: [
      {
        description: "Robot bisa 'merasakan' lingkungannya berkat sensor, dan bisa 'bertindak' dengan bantuan motor. Memahami cara kerja keduanya membuka wawasan pelajar terhadap sistem otomasi yang digunakan di pabrik, kendaraan, dan rumah pintar.",
      },
    ],
  },
  {
    id: 28,
    title: "Natural Language Processing: Bagaimana AI Memahami Bahasa",
    desc: "Natural Language Processing (NLP) adalah cabang dari kecerdasan buatan (AI) yang memungkinkan komputer memahami, menginterpretasikan, dan menghasilkan bahasa manusia secara alami. Teknologi ini menjadi fondasi utama di balik berbagai aplikasi modern seperti chatbot, asisten digital (seperti Siri atau Google Assistant), hingga mesin pencari seperti Google Search. Dengan NLP, sistem dapat menganalisis teks atau ucapan manusia, mengenali makna di balik kata-kata, dan memberikan respons yang relevan dan masuk akal.",
    category: "Artificial Intelligence (AI)",
    imageSrc: "/img/blog/AI/ai6.jpg",
    createdAt: "2025-06-22T10:30:00",
    content: [
      {
        description: "NLP bekerja dengan memanfaatkan teknik linguistik, statistik, dan machine learning untuk mengenali struktur bahasa, mulai dari kalimat sederhana hingga konteks yang lebih kompleks. Misalnya, saat kita mengetik pertanyaan di Google atau mengobrol dengan chatbot, sistem NLP akan memecah kalimat tersebut menjadi bagian-bagian seperti kata benda, kata kerja, dan frasa kunci, lalu mencocokkannya dengan data yang relevan untuk memberikan jawaban.",
      },
    ],
  },
  {
    id: 29,
    title: "Algoritma dan Flowchart: Pondasi Sebelum Mulai Coding",
    desc: "Sebelum menulis kode, penting untuk memahami cara berpikir algoritmik, yaitu menyusun langkah-langkah logis untuk menyelesaikan masalah secara sistematis. Artikel ini membahas konsep algoritma dan flowchart sebagai fondasi awal dalam belajar pemrograman. Algoritma adalah urutan instruksi yang jelas, sedangkan flowchart membantu menggambarkan alur logika secara visual menggunakan simbol dan panah. Dengan memahami keduanya, siswa dapat merancang solusi yang lebih terstruktur sebelum diterjemahkan ke dalam bahasa pemrograman seperti Python atau JavaScript.Ini tidak hanya membantu menulis kode yang efisien dan minim kesalahan, tetapi juga melatih pola pikir logis dan analitis sejak awal. Pendekatan ini sangat cocok untuk pelajar yang baru mengenal coding, karena memberikan dasar yang kuat sebelum mereka mulai membuat program atau proyek digital.",
    category: "Coding",
    imageSrc: "/img/blog/coding/coding7.jpg",
    createdAt: "2025-07-05T14:30:00",
    content: [
      {
        description: "Algoritma adalah urutan langkah-langkah logis dan sistematis yang dirancang untuk menyelesaikan suatu masalah. Sementara itu, flowchart atau diagram alir merupakan representasi visual dari algoritma tersebut, biasanya menggunakan simbol-simbol standar seperti persegi panjang untuk proses dan belah ketupat untuk keputusan. Dengan mempelajari algoritma dan flowchart, siswa dapat merencanakan alur program secara terstruktur sebelum mulai menulis kode. Hal ini membantu mereka memahami logika program secara keseluruhan dan lebih mudah menemukan serta memperbaiki kesalahan logika yang mungkin terjadi selama proses pengembangan. Selain itu, perencanaan yang baik juga dapat menghemat waktu dan meningkatkan efisiensi dalam pemrograman.",
      },
    ],
  },
  {
    id: 30,
    title: "Mengenal Sensor dalam Dunia Robotika",
    desc: "Sensor adalah indera bagi robot, memungkinkan mereka untuk merasakan dan memahami lingkungan sekitar. Artikel ini membahas berbagai jenis sensor seperti sensor cahaya, sensor ultrasonik, sensor sentuhan, serta sensor suhu dan jarak. Setiap sensor memiliki fungsi spesifik, misalnya sensor cahaya membantu robot mendeteksi terang atau gelap, sedangkan sensor ultrasonik digunakan untuk mengukur jarak dan menghindari tabrakan. Dengan bantuan sensor, robot dapat bergerak secara lebih cerdas, misalnya berhenti saat ada halangan, mengikuti garis di lantai, atau merespons sentuhan pengguna.",
    category: "Robotic",
    imageSrc: "/img/blog/robotic/robot7.jpg",
    createdAt: "2025-07-02T10:00:00",
    content: [
      {
        description: "Ilmu robotika mencakup pemahaman tentang bagaimana robot bisa 'merasakan' dunia sekitar dan mengambil keputusan berdasarkan data. Sensor memberikan input penting berupa data fisik yang diterjemahkan menjadi sinyal digital oleh mikrokontroler. Mikrokontroler kemudian menganalisis data tersebut untuk menentukan tindakan yang tepat, seperti berbelok, memperlambat, atau berhenti. Inilah dasar dari perilaku otonom pada robot. Teknologi ini memungkinkan pembuatan robot yang tidak hanya menjalankan perintah, tetapi juga mampu beradaptasi terhadap perubahan lingkungan — seperti robot penghindar rintangan, robot pendeteksi garis, atau bahkan robot penyelamat yang dapat merespons kondisi darurat di medan berbahaya.",
      },
    ],
  },
  {
    id: 31,
    title: "Mengenal Computer Vision: Ketika Komputer Bisa Melihat",
    desc: "Computer Vision merupakan cabang dari kecerdasan buatan (AI) yang secara khusus fokus pada kemampuan komputer dalam memahami informasi visual dari dunia sekitar. Dengan memanfaatkan algoritma seperti CNN (Convolutional Neural Network), teknologi ini mampu mengenali pola, bentuk, dan warna dalam gambar digital. Penerapannya kini semakin luas, mencakup bidang kesehatan (seperti mendeteksi tumor dari hasil rontgen), sistem keamanan (dengan pemindai wajah dan pengawasan otomatis), hingga transportasi modern yang mengandalkan kamera dan sensor untuk navigasi.",
    category: "Artificial Intelligence (AI)",
    imageSrc: "/img/blog/AI/ai7.jpg",
    createdAt: "2025-07-11T11:30:00",
    content: [
      {
        description: "Pengembangan Computer Vision tidak hanya membuat sistem menjadi lebih pintar, tetapi juga mendorong inovasi besar dalam bidang robotik dan otomasi industri. Robot kini dapat melakukan inspeksi kualitas produk secara visual, atau bahkan bekerja berdampingan dengan manusia dengan kemampuan melihat dan mengenali lingkungan kerjanya. Seiring berkembangnya teknologi ini, peran Computer Vision akan semakin vital dalam menciptakan sistem yang efisien, aman, dan responsif terhadap kondisi di sekitarnya.",
      },
    ],
  },
  {
    id: 32,
    title: "Belajar API untuk Pemula: Jembatan Antar Aplikasi",
    desc: "API (Application Programming Interface) adalah penghubung antar sistem atau aplikasi yang memungkinkan pertukaran data secara terstruktur. Artikel ini membahas konsep dasar API, bagaimana cara kerjanya, serta contoh penggunaannya dalam kehidupan sehari-hari. API berperan sebagai jembatan komunikasi yang membuat satu aplikasi bisa “berbicara” dengan aplikasi lain. Dalam dunia pemrograman, API digunakan untuk mengakses data, menjalankan perintah, atau menyinkronkan informasi antar sistem yang berbeda. Salah satu contoh nyata adalah saat kita menggunakan aplikasi cuaca, di mana aplikasi tersebut mengambil data suhu dan prakiraan dari server pihak ketiga melalui API, lalu menampilkannya dalam bentuk antarmuka yang mudah dipahami pengguna.",
    category: "Coding",
    imageSrc: "/img/blog/coding/coding8.jpg",
    createdAt: "2025-08-07T10:00:00",
    content: [
      {
        description: "API menjadi tulang punggung komunikasi antar aplikasi modern, baik itu aplikasi mobile, website, maupun layanan cloud. Aplikasi besar seperti Gojek, Tokopedia, atau Instagram menggunakan ribuan API untuk bertukar informasi antara client (pengguna) dan server (backend). Misalnya, saat kamu memesan makanan lewat Gojek, aplikasi akan memanggil API untuk menampilkan daftar restoran, mengirim pesanan, dan melacak pengiriman secara real-time. Dengan belajar API, pelajar tidak hanya memahami teori, tetapi juga dapat mencoba membuat API sederhana menggunakan Express.js di Node.js. Mereka bisa membuat endpoint seperti GET /produk untuk menampilkan daftar produk atau POST /login untuk menangani proses masuk pengguna. Dari sini, pelajar akan memahami bagaimana sistem backend bekerja dan bagaimana aplikasi modern saling terhubung melalui teknologi yang tidak terlihat namun sangat penting ini.",
      },
    ],
  },
  {
    id: 33,
    title: "Mikrokontroler: Otak Kecil di Balik Robot",
    desc: "Setiap robot memiliki 'otak' yang disebut mikrokontroler, yaitu sebuah chip kecil yang berfungsi sebagai pusat kendali semua aktivitas robot. Artikel ini membahas peran penting mikrokontroler dalam sistem robotik, terutama pada perangkat populer seperti Arduino dan ESP32. Mikrokontroler inilah yang membaca data dari sensor, memprosesnya sesuai program yang ditulis, dan kemudian mengendalikan komponen lain seperti motor, LED, atau buzzer. Tanpa mikrokontroler, robot hanyalah kumpulan komponen elektronik tanpa kemampuan untuk merespons atau berinteraksi dengan lingkungan sekitarnya. Arduino dan ESP32 sering digunakan dalam proyek-proyek edukasi dan prototipe karena mudah diprogram dan kompatibel dengan berbagai sensor serta modul tambahan.",
    category: "Robotic",
    imageSrc: "/img/blog/robotic/robot8.jpg",
    createdAt: "2025-08-05T07:00:00",
    content: [
      {
        description: "Dalam bidang robotika, mikrokontroler adalah inti dari kecerdasan robot, karena di sanalah semua instruksi dijalankan. Ia menerima input dari berbagai sensor seperti sensor jarak, cahaya, atau suhu—lalu memutuskan aksi apa yang harus dilakukan, seperti menggerakkan roda atau menyalakan lampu. Belajar pemrograman mikrokontroler, terutama melalui platform seperti Arduino IDE, menjadi langkah awal yang penting untuk memahami cara kerja sistem otomatis. Dari sinilah pelajar dapat mulai mengeksplorasi bagaimana robot dapat berpikir , mengambil keputusan, dan bertindak sesuai perintah atau kondisi lingkungan. Dengan penguasaan dasar ini, pelajar akan lebih mudah mengembangkan proyek robotik seperti robot penghindar rintangan, pengikut garis, atau bahkan sistem otomasi rumah sederhana.",
      },
    ],
  },
  {
    id: 34,
    title: "Machine Learning: Dasar Kecerdasan Buatan yang Belajar Sendiri",
    desc: "Machine Learning (ML) adalah teknik dalam kecerdasan buatan yang memungkinkan komputer belajar dari data dan membuat keputusan atau prediksi tanpa diprogram secara eksplisit untuk setiap tugas. Artikel ini menjelaskan bagaimana model dalam ML dilatih untuk mengenali pola dari kumpulan data yang besar, lalu menggunakan pengetahuan tersebut untuk memecahkan masalah di dunia nyata. Misalnya, aplikasi prediksi cuaca menggunakan ML untuk menganalisis data atmosfer dan memperkirakan kondisi beberapa hari ke depan. Di dunia hiburan, sistem seperti Netflix atau Spotify memanfaatkan ML untuk merekomendasikan film atau lagu berdasarkan preferensi pengguna. Di bidang kesehatan, model ML bahkan digunakan untuk membantu mendeteksi penyakit melalui analisis gambar medis atau riwayat pasien, memberikan dukungan penting bagi diagnosis dini.",
    category: "Artificial Intelligence (AI)",
    imageSrc: "/img/blog/AI/ai8.jpg",
    createdAt: "2025-08-09T13:30:00",
    content: [
      {
        description: "Machine Learning bekerja dengan cara memberi komputer kemampuan untuk belajar sendiri dari pengalaman yang direpresentasikan dalam bentuk data. Semakin banyak data yang diproses, semakin akurat model dalam membuat keputusan. Dalam praktiknya, pengembangan ML melibatkan pelatihan model dengan data input-output (supervised learning), menemukan pola tersembunyi tanpa label (unsupervised learning), hingga pengambilan keputusan berbasis umpan balik (reinforcement learning). Ketiga pendekatan ini digunakan dalam berbagai skenario, dari chatbot cerdas, mobil otonom, hingga sistem deteksi penipuan di dunia finansial.",
      },
    ],
  },
  {
    id: 35,
    title: "Dasar-dasar Database: Menyimpan Data Secara Terstruktur",
    desc: "Database seperti PostgreSQL dan MySQL berperan penting dalam menyimpan, mengelola, dan mengakses data yang dibutuhkan oleh aplikasi. Artikel ini membahas konsep dasar database relasional, termasuk struktur tabel, kolom, dan bagaimana data diorganisasi dengan rapi agar mudah dicari dan digunakan. Salah satu keunggulan database relasional adalah kemampuannya menghubungkan data antar tabel melalui relasi. Di dalamnya, kita juga mengenal istilah SQL (Structured Query Language), yaitu bahasa standar yang digunakan untuk membuat, membaca, memperbarui, dan menghapus data (CRUD).",
    category: "Coding",
    imageSrc: "/img/blog/coding/coding9.jpg",
    createdAt: "2025-09-09T11:00:00",
    content: [
      {
        description: "Saat membuat aplikasi seperti toko online, kita biasanya perlu menyimpan informasi produk, pengguna (user), dan pesanan. Semua data ini disimpan dalam tabel-tabel terpisah yang saling terhubung melalui relasi misalnya, satu user bisa memiliki banyak pesanan. Konsep seperti primary key (identitas unik tiap data) dan foreign key (penghubung antar tabel) sangat penting untuk menjaga integritas dan konsistensi data. Dengan memahami dasar-dasar ini, pelajar dan pemula di bidang backend dapat membangun sistem yang lebih terstruktur dan efisien. Selain itu, keterampilan menulis query SQL juga sangat berguna di dunia kerja karena hampir semua aplikasi modern, dari media sosial hingga sistem e-commerce, bergantung pada database untuk berjalan dengan baik.",
      },
    ],
  },
  {
    id: 36,
    title: "Sistem Mekanik dalam Robot: Motor, Gear, dan Struktur",
    desc: "Robot tidak hanya soal kode, tapi juga soal gerak. Artikel ini mengupas pentingnya sistem mekanik dalam robotika, yang menjadi tulang punggung dari setiap pergerakan fisik robot. Komponen seperti motor DC, servo, dan stepper berperan penting dalam mengatur arah, kecepatan, dan presisi gerak robot. Selain itu, desain roda, sambungan, hingga struktur rangka robot juga menentukan seberapa stabil dan efisien robot dapat bergerak di berbagai medan. Tanpa sistem mekanik yang tepat, program terbaik sekalipun tidak akan bisa dijalankan dengan efektif, karena tubuh fisik robot tidak mampu merespons perintah dengan baik.",
    category: "Robotic",
    imageSrc: "/img/blog/robotic/robot9.jpg",
    createdAt: "2025-09-16T11:30:00",
    content: [
      {
        description: "Dalam hal ini, mekatronika menjadi bidang ilmu yang menggabungkan mekanika, elektronika, dan sistem kontrol, menjembatani teori pemrograman dengan kenyataan fisik. Seorang pembuat robot harus memahami bagaimana menghubungkan rangkaian elektronik ke aktuator (motor dan sensor), serta bagaimana struktur fisik harus dirancang agar tidak hanya kuat tetapi juga ringan dan responsif. Misalnya, penggunaan servo motor sangat ideal untuk gerakan presisi seperti pada lengan robot, sementara motor DC lebih cocok untuk mobil robot yang bergerak lurus cepat. Pemahaman akan hubungan antara rangka, motor, dan kontrol ini menjadi dasar penting untuk menciptakan robot yang cerdas sekaligus bisa bergerak sesuai perintah. Inilah bentuk nyata dari kecerdasan buatan yang tidak hanya berpikir, tetapi juga bertindak di dunia nyata.",
      },
    ],
  },
  {
    id: 37,
    title: "AI dalam Dunia Pendidikan: Membantu Belajar Lebih Cerdas",
    desc: "Artificial Intelligence (AI) telah merambah dunia pendidikan dan menghadirkan berbagai inovasi yang mengubah cara belajar dan mengajar. Artikel ini mengeksplorasi bagaimana AI mampu menciptakan sistem pembelajaran adaptif, pengoreksi otomatis, dan asisten virtual yang membantu siswa belajar sesuai dengan kecepatan, gaya, dan kebutuhan masing-masing. Dengan teknologi ini, pembelajaran tidak lagi bersifat satu arah atau seragam, melainkan bisa menyesuaikan diri dengan kemampuan tiap individu. Misalnya, ketika seorang siswa mengalami kesulitan memahami topik tertentu, sistem berbasis AI dapat menyesuaikan tingkat kesulitan, memberikan penjelasan tambahan, atau mengulang materi dengan pendekatan yang berbeda.",
    category: "Artificial Intelligence (AI)",
    imageSrc: "/img/blog/AI/ai9.jpg",
    createdAt: "2025-09-22T13:30:00",
    content: [
      {
        description: "AI dalam pendidikan menciptakan pengalaman belajar yang lebih personal dan efisien. Platform populer seperti Duolingo, Khan Academy, atau bahkan sistem e-learning di sekolah dan universitas kini mengandalkan algoritma AI untuk menganalisis performa pengguna secara real-time. Dengan cara ini, siswa yang cepat memahami materi dapat langsung melanjutkan ke tahap berikutnya, sementara yang masih kesulitan akan diberikan latihan tambahan. AI juga dapat mendeteksi pola kesalahan atau kebiasaan belajar yang menghambat kemajuan, lalu memberikan saran pembelajaran yang tepat waktu. Di sisi guru, teknologi ini sangat membantu dalam hal koreksi otomatis tugas atau kuis, pembuatan materi belajar yang disesuaikan, dan pemantauan perkembangan siswa melalui analisis data.",
      },
    ],
  },
  {
    id: 38,
    title: "CRUD: Operasi Dasar di Semua Aplikasi",
    desc: "CRUD (Create, Read, Update, Delete) adalah empat operasi dasar yang menjadi fondasi dari hampir semua aplikasi modern. Artikel ini membahas bagaimana konsep CRUD digunakan dalam pengembangan aplikasi web untuk mengelola data secara dinamis. Operasi Create digunakan untuk menambahkan data baru, Read untuk menampilkan data yang sudah ada, Update untuk mengubah data, dan Delete untuk menghapus data. Proses-proses ini membentuk alur interaksi antara pengguna dan sistem yang terjadi hampir di setiap aplikasi. Jika kamu pernah membuat aplikasi catatan, blog, atau daftar tugas, kemungkinan besar kamu sudah menerapkan logika CRUD, bahkan tanpa menyadarinya. Aplikasi besar seperti Instagram, Shopee, dan TikTok pun dibangun dengan prinsip yang sama menampilkan konten, memungkinkan pengguna membuat dan mengedit data, serta menghapusnya bila perlu.",
    category: "Coding",
    imageSrc: "/img/blog/coding/coding10.jpg",
    createdAt: "2025-10-12T11:35:00",
    content: [
      {
        description: "Untuk memahami CRUD secara lebih praktis, artikel ini juga membahas bagaimana cara mengimplementasikannya menggunakan React di sisi frontend dan Express.js di sisi backend. Misalnya, kamu bisa membuat form di React untuk menambah data (Create), menampilkan daftar data (Read), menyediakan fitur edit (Update), dan tombol hapus (Delete). Di sisi backend, Express.js akan menangani permintaan HTTP seperti POST, GET, PUT, dan DELETE melalui endpoint seperti /notes atau /users/:id. Dengan memahami alur CRUD secara utuh dari frontend ke backend, pelajar dan pemula dalam pemrograman akan memiliki fondasi kuat untuk membangun aplikasi web dinamis yang terhubung dengan server dan mampu menyimpan serta mengelola data secara efisien.",
      },
    ],
  },
  {
    id: 39,
    title: "Robot Autonomous: Bagaimana Robot Bisa Bergerak Sendiri?",
    desc: "Robot otonom mampu bergerak dan mengambil keputusan tanpa dikendalikan langsung oleh manusia. Mereka dirancang untuk memahami lingkungan sekitar, mengenali rintangan, serta menentukan jalur atau tindakan selanjutnya secara mandiri. Artikel ini membahas konsep dasar robot autonomous, mulai dari sensor yang digunakan untuk mendeteksi kondisi sekitar, logika pemrograman yang mengatur perilaku robot, hingga penerapannya dalam kehidupan sehari-hari seperti vacuum cleaner otomatis yang dapat membersihkan ruangan tanpa bantuan manusia, serta mobil tanpa sopir yang mampu membaca rambu lalu lintas dan menghindari tabrakan.",
    category: "Robotic",
    imageSrc: "/img/blog/robotic/robot10.jpg",
    createdAt: "2025-10-16T08:35:00",
    content: [
      {
        description: "Di bidang robotika dan kecerdasan buatan, robot otonom merupakan hasil integrasi antara sensor, mikrokontroler, dan algoritma cerdas. Sensor seperti lidar, kamera, dan ultrasonic memberikan data lingkungan secara real-time, yang kemudian diproses oleh mikrokontroler dan algoritma pengambilan keputusan. Proses ini memungkinkan robot untuk beradaptasi dengan situasi yang berubah-ubah, seperti menghindari objek bergerak atau merespons perubahan cahaya dan medan. Perkembangan teknologi ini tidak hanya terbatas pada sektor rumah tangga, tetapi juga merambah ke industri manufaktur, pertanian, militer, dan transportasi, menjadikan robot otonom sebagai elemen penting dalam revolusi industri 4.0.",
      },
    ],
  },
  {
    id: 40,
    title: "Reinforcement Learning: AI Belajar dari Pengalaman",
    desc: "Reinforcement learning adalah pendekatan dalam pembelajaran mesin di mana agen AI belajar dengan cara mencoba berbagai aksi dalam suatu lingkungan dan menerima umpan balik berupa reward (penghargaan) atau punishment (hukuman) berdasarkan tindakannya. Tidak seperti supervised learning yang membutuhkan data berlabel, reinforcement learning memungkinkan agen untuk belajar mandiri melalui pengalaman langsung. Proses pembelajarannya meniru cara manusia dan hewan belajar dengan mencoba, gagal, mendapatkan konsekuensi, dan mencoba lagi dengan strategi yang lebih baik. Tujuan akhirnya adalah memaksimalkan reward kumulatif dalam jangka panjang dengan memilih aksi terbaik dari berbagai kemungkinan berdasarkan kondisi lingkungan.",
    category: "Artificial Intelligence (AI)",
    imageSrc: "/img/blog/AI/ai10.jpg",
    createdAt: "2025-10-26T07:35:00",
    content: [
      {
        description: "Teknik ini telah banyak digunakan dalam berbagai bidang, mulai dari game seperti AlphaGo dan Dota 2 AI, hingga robotik yang membutuhkan pengambilan keputusan secara real-time di dunia fisik. Sistem rekomendasi dan kontrol otomatis seperti self-driving cars juga memanfaatkan reinforcement learning untuk meningkatkan kinerjanya. Dalam artikel ini, kita akan membahas istilah-istilah penting seperti agent (entitas yang mengambil keputusan), environment (lingkungan tempat agent berinteraksi), reward (umpan balik), dan policy (strategi pengambilan keputusan). Selain itu, dibahas pula bagaimana algoritma seperti Q-learning dan Deep Q-Networks (DQN) digunakan untuk membantu agen dalam memilih aksi yang optimal berdasarkan pengalaman yang terus bertambah.",
      },
    ],
  },
  {
    id: 41,
    title: "Mengenal Supabase: Alternatif Firebase Open Source",
    desc: "Supabase menjadi pilihan populer di kalangan developer modern karena menyediakan backend open source dengan fitur lengkap yang dibutuhkan untuk membangun aplikasi secara cepat dan efisien. Dengan menyediakan layanan seperti autentikasi pengguna, penyimpanan database, hingga fitur realtime secara default, Supabase memberikan alternatif yang kuat bagi mereka yang menginginkan kemudahan Firebase namun tetap menginginkan kendali penuh atas infrastruktur dan data. Artikel ini akan membahas cara kerja Supabase secara menyeluruh, mulai dari struktur komponennya, proses integrasi ke aplikasi front-end, hingga perbandingan fitur dan fleksibilitasnya jika dibandingkan dengan Firebase atau backend-as-a-service lainnya.",
    category: "Coding",
    imageSrc: "/img/blog/coding/coding11.jpg",
    createdAt: "2025-11-08T07:20:00",
    content: [
      {
        description: "Salah satu keunggulan utama Supabase adalah penggunaan PostgreSQL sebagai inti database-nya, yang memungkinkan dukungan query kompleks, integritas data yang tinggi, serta fleksibilitas dalam skema. Di samping itu, Supabase menyertakan autentikasi bawaan, API REST dan GraphQL otomatis, serta fitur realtime yang memudahkan pengembangan aplikasi interaktif. Selain menyederhanakan proses pengembangan, Supabase juga cocok untuk proyek skala kecil hingga menengah, termasuk startup atau MVP (Minimum Viable Product), karena developer dapat memulai secara gratis dan kemudian beralih ke skala produksi tanpa harus memigrasi data atau arsitektur. Dengan Supabase, developer dapat membangun aplikasi modern dengan teknologi terbuka sambil mempertahankan privasi, skalabilitas, dan kontrol data sepenuhnya.",
      },
    ],
  },
  {
    id: 42,
    title: "Belajar Robotika dengan Raspberry Pi",
    desc: "Raspberry Pi adalah komputer mini yang bisa digunakan untuk membuat robot pintar dengan kemampuan pemrosesan lebih tinggi dibanding Arduino. Dibekali dengan prosesor, RAM, dan sistem operasi seperti Linux, Raspberry Pi mampu menjalankan berbagai program kompleks, termasuk pengolahan citra, kecerdasan buatan, hingga koneksi jaringan. Hal ini menjadikannya pilihan ideal bagi proyek robotika yang membutuhkan kendali cerdas, antarmuka pengguna grafis, atau pengolahan data secara real-time. Artikel ini menjelaskan perbedaan mendasar antara Raspberry Pi dan Arduino, seperti perbedaan dalam arsitektur, bahasa pemrograman, dan kemampuan multitasking, serta kapan sebaiknya menggunakan salah satunya sesuai kebutuhan proyek.",
    category: "Robotic",
    imageSrc: "/img/blog/robotic/robot11.jpg",
    createdAt: "2025-11-08T09:40:00",
    content: [
      {
        description: "Dengan Raspberry Pi, robot dapat diprogram menggunakan bahasa Python atau bahasa lain seperti C++ dan JavaScript, serta terhubung ke internet melalui WiFi atau Ethernet. Hal ini membuka peluang luas untuk mengembangkan proyek-proyek canggih seperti robot pengintai dengan kamera streaming, sistem kontrol rumah pintar yang bisa diakses dari smartphone, atau kamera pendeteksi gerakan yang mampu mengirim notifikasi saat ada aktivitas mencurigakan. Raspberry Pi juga kompatibel dengan berbagai sensor dan modul tambahan, menjadikannya platform fleksibel untuk eksplorasi dunia robotika modern.",
      },
    ],
  },
  {
    id: 43,
    title: "Speech Recognition: Membuat Mesin Memahami Ucapan",
    desc: "Speech recognition adalah teknologi yang memungkinkan komputer mengenali dan mengubah suara manusia menjadi teks. Teknologi ini bekerja dengan menganalisis gelombang suara yang masuk, memprosesnya menjadi fitur-fitur akustik, lalu mencocokkannya dengan pola-pola dalam basis data untuk menghasilkan teks yang sesuai. Artikel ini membahas cara kerja sistem pengenalan suara, aplikasinya dalam kehidupan sehari-hari, serta teknologi dan algoritma di baliknya yang membuatnya semakin akurat dan responsif.",
    category: "Artificial Intelligence (AI)",
    imageSrc: "/img/blog/AI/ai11.jpg",
    createdAt: "2025-11-20T07:35:00",
    content: [
      {
        description: "Dalam kehidupan sehari-hari, speech recognition digunakan dalam berbagai perangkat dan layanan, seperti asisten suara Siri, Google Assistant, dan Alexa, yang dapat menjawab pertanyaan, mengatur jadwal, hingga mengontrol perangkat pintar di rumah. Selain itu, teknologi ini juga dimanfaatkan dalam aplikasi transkripsi otomatis untuk rapat, kuliah, atau wawancara, serta pada fitur dikte di smartphone dan komputer. Keakuratan sistem ini terus meningkat berkat perkembangan teknik seperti MFCC (Mel-Frequency Cepstral Coefficients) yang mengekstrak ciri-ciri penting dari sinyal suara, model akustik yang memetakan suara ke fonem, serta penggunaan deep learning dan jaringan saraf tiruan yang mampu mengenali pola suara dengan kompleksitas tinggi. Dengan kombinasi teknologi ini, speech recognition menjadi bagian penting dalam interaksi manusia dan mesin di era digital.",
      },
    ],
  },
  {
    id: 44,
    title: "Pengantar Kubernetes: Mengelola Aplikasi Skala Besar",
    desc: "Kubernetes adalah sistem orkestrasi container yang dirancang untuk mengelola deployment, scaling, dan pengelolaan aplikasi berbasis container secara otomatis. Sistem ini memungkinkan developer untuk menjalankan aplikasi di berbagai lingkungan secara konsisten, baik di cloud maupun on-premise. Artikel ini akan membahas berbagai konsep dasar Kubernetes seperti pod, node, cluster, dan service, serta bagaimana komponen-komponen ini bekerja sama untuk menyediakan platform yang andal dan fleksibel. Dengan pendekatan deklaratif, Kubernetes memungkinkan tim pengembang untuk mendefinisikan kebutuhan aplikasi dalam bentuk konfigurasi, yang kemudian dijalankan dan dipantau oleh sistem secara otomatis.",
    category: "Coding",
    imageSrc: "/img/blog/coding/coding12.jpg",
    createdAt: "2025-12-05T09:20:00",
    content: [
      {
        description: "Selain itu, Kubernetes juga mendukung fitur-fitur canggih seperti load balancing, self-healing, rolling updates, dan auto-scaling, yang sangat penting dalam pengembangan aplikasi modern berskala besar. Artikel ini juga akan membahas bagaimana Kubernetes berinteraksi dengan Docker sebagai container runtime, dan bagaimana keduanya berperan dalam menciptakan pipeline DevOps yang efisien. Contoh penerapannya bisa ditemukan di berbagai perusahaan teknologi besar yang mengandalkan Kubernetes untuk menjaga kestabilan aplikasi meskipun traffic pengguna sangat dinamis. Dengan memahami Kubernetes, developer dapat lebih mudah membangun sistem yang scalable, resilient, dan mudah dikelola di berbagai lingkungan produksi.",
      },
    ],
  },
  {
    id: 45,
    title: "Inovasi Robotika Jepang: Robot Asisten Lansia",
    desc: "Jepang sedang mengembangkan robot penyelamat dan asisten lansia untuk mengatasi tantangan sosial seperti bencana alam dan populasi menua. Negara ini memanfaatkan kemajuan teknologi robotika untuk menciptakan solusi nyata yang dapat merespons kebutuhan masyarakat di masa depan. Artikel ini membahas proyek-proyek robotik inovatif seperti humanoid besar untuk penanggulangan bencana serta robot perawat berbasis AI dalam caregiving, yang dirancang untuk memberikan bantuan langsung di situasi darurat maupun dalam keseharian lansia.",
    category: "Robotic",
    imageSrc: "/img/blog/robotic/robot12.jpg",
    createdAt: "2025-12-10T19:40:00",
    content: [
      {
        description: "Sebagai negara yang rawan gempa dan memiliki populasi lansia tertinggi di dunia, Jepang fokus mengembangkan dua jenis robot utama: robot penyelamat dan robot asisten lansia. Misalnya, proyek kolaborasi antara Murata Manufacturing dan Waseda University menghasilkan robot humanoid setinggi hampir 3 meter yang mampu mengangkat beban hingga 100 kg, dan dirancang untuk membantu evakuasi serta membawa logistik di zona bencana. Sementara itu, robot AIREC yang juga dikembangkan oleh Waseda University, dirancang untuk membantu perawatan harian lansia seperti memindahkan posisi tidur, menyiapkan makanan sederhana, hingga melipat pakaian. Meski masih dalam tahap prototipe, AIREC diharapkan siap digunakan secara luas pada tahun 2030. Robot-robot ini bukan hanya representasi kecanggihan teknologi, tetapi juga simbol komitmen Jepang dalam menciptakan hubungan harmonis antara manusia dan mesin demi kesejahteraan sosial.",
      },
    ],
  },
  {
    id: 46,
    title: "Cognitive Computing: Simulasi Proses Berpikir Manusia",
    desc: "Cognitive computing bertujuan menciptakan sistem AI yang meniru cara manusia berpikir, belajar, dan mengambil keputusan, dengan tujuan akhir membantu manusia menyelesaikan masalah yang kompleks secara lebih efisien. Artikel ini mengulas teknologi di balik cognitive computing serta bagaimana AI dapat digunakan untuk analisis tingkat lanjut dalam berbagai bidang seperti kesehatan, keuangan, pendidikan, dan layanan pelanggan.",
    category: "Artificial Intelligence (AI)",
    imageSrc: "/img/blog/AI/ai12.jpg",
    createdAt: "2025-12-16T09:35:00",
    content: [
      {
        description: "Berbeda dengan sistem komputasi tradisional yang hanya menjalankan perintah, cognitive computing mampu memahami data dalam konteks, mengenali pola, dan bahkan menangkap nuansa bahasa serta emosi manusia. Teknologi ini menggabungkan berbagai bidang seperti Natural Language Processing (NLP) untuk memahami bahasa manusia, machine learning untuk belajar dari data dan pengalaman, serta data mining untuk mengekstrak informasi berharga dari kumpulan data besar. IBM Watson adalah salah satu contoh paling terkenal dari sistem cognitive computing, yang digunakan untuk membantu dokter dalam menganalisis diagnosis medis, mendukung analis keuangan dalam memahami tren pasar, hingga membantu perusahaan dalam memberikan layanan pelanggan yang lebih cerdas dan responsif. Dengan pendekatan ini, cognitive computing tidak hanya memperkuat kemampuan manusia, tetapi juga membuka peluang baru dalam pengambilan keputusan berbasis data yang lebih cermat dan kontekstual.",
      },
    ],
  },
  {
    id: 47,
    title: "Apa Itu Competitive Programming? Penjelasan Simpel untuk Pelajar SD-SMA",
    desc: "Pernah dengar tentang competitive programming atau CP? Kedengarannya rumit, ya? Tapi sebenarnya, ini adalah aktivitas seru yang mirip seperti main game teka-teki logika  hanya saja, kamu pakai kode sebagai senjatanya!",
    category: "Competitive Programming",
    imageSrc: "/img/blog/competitive/compe-1.png",
    createdAt: "2025-01-21T09:35:00",
    content: [
      {
        heading: "🎮 Jadi, Apa Itu CP?",
        description: `Competitive Programming adalah lomba menyelesaikan soal-soal logika dan matematika dengan kode program. Kamu akan diberi soal, dan kamu harus membuat program (biasanya dengan bahasa seperti Python, C++, atau Java) untuk menyelesaikan soal itu secepat dan seakurat mungkin.
          Bayangkan kamu main game:
          • Ada misi (soal)
          • Kamu buat strategi (algoritma)
          • Kamu kirim solusi (kode)
          • Dapat skor kalau berhasil!`,
      },
      {
        heading: "🔍 Siapa yang Bisa Ikut?",
        description: `Semua bisa! Mulai dari siswa SD yang suka tantangan logika sederhana, hingga siswa SMA yang siap ikut olimpiade informatika.
          • SD: Mulai dari game coding dan logika dasar
          • SMP: Belajar algoritma dasar, mulai ikut lomba kecil
          • SMA: Siap ikut kompetisi seperti OSN, TOKI, dan lainnya`,
      },
      {
        heading: "🧠 Apa Manfaatnya?",
        description: `• Melatih logika dan berpikir kritis
          • Belajar pemrograman dan teknologi
          • Menjadi lebih cepat dan tepat dalam menyelesaikan masalah
          • Bisa jadi bekal masuk jurusan IT, bahkan karier di dunia teknologi!`,
      },
      {
        heading: "🚀 Kesimpulan",
        description: `Competitive Programming itu bukan cuma buat “anak jenius” atau “ahli matematika”. Ini adalah dunia seru tempat kamu bisa bermain sambil belajar, dan mengasah otak seperti pahlawan digital!
          Tertarik? Yuk, coba ikut ekskul CP di sekolahmu atau mulai latihan lewat situs seperti Code.org atau HackerRank!`,
      },
    ],
  },
  {
    id: 48,
    title: "Proyek Sederhana AI untuk Pemula: Belajar Sambil Praktik!",
    desc: "Belajar AI tidak harus rumit dan membingungkan. Justru, cara terbaik untuk memahami AI adalah langsung mencobanya lewat proyek sederhana. Cocok banget buat kamu yang baru pertama kali terjun ke dunia kecerdasan buatan!",
    category: "Artificial Intelligence (AI)",
    imageSrc: "/img/blog/AI/ai13.jpg",
    createdAt: "2025-01-28T16:00:00",
    content: [
      {
        heading: "1. Chatbot Sederhana",
        description: `Gunakan platform seperti Dialogflow atau Scratch dengan ekstensi AI untuk membuat chatbot yang bisa menjawab pertanyaan dasar, seperti:
          “Apa itu AI?” atau “Berapa 5 + 7?”`
      },
      {
        heading: "2. Klasifikasi Gambar dengan Teachable Machine",
        description: `Coba Teachable Machine, tools gratis dari Google untuk melatih AI mengenali gambar, suara, atau pose. Kamu bisa buat:
            • AI yang bisa bedain ekspresi wajah (senang vs sedih)
            • AI yang bisa mengenali barang-barang di kamar kamu`
      },
      {
        heading: "3. Game AI: Tebak Angka",
        description: `Buat program sederhana di Python atau Scratch di mana AI mencoba menebak angka yang kamu pikirkan, dengan logika if-else dan pembelajaran dari kesalahan.`
      },
      {
        heading: "4. Rekomendasi Musik atau Film",
        description: `Ciptakan program yang bisa merekomendasikan musik atau film berdasarkan preferensi pengguna, mirip seperti Spotify atau Netflix versi mini.`
      },
      {
        heading: "5. Robot Mini dengan Sensor (opsional, jika tersedia)",
        description: `Kalau sekolahmu punya alat seperti micro:bit atau Arduino, kamu bisa buat robot mini yang bisa:
            • Menghindari rintangan
            • Mengikuti garis
            • Merespons suara atau gerakan`,
      },
      {
        heading: "Kenapa Proyek Praktik Itu Penting?",
        description: `• Belajar jadi lebih menyenangkan dan interaktif
            • Langsung melihat hasil kerja kita sendiri
            • Membangun kepercayaan diri dalam memahami konsep AI

          Dengan proyek-proyek sederhana ini, kamu bisa membuktikan bahwa belajar AI tidak harus nunggu kuliah atau jago matematika dulu. Mulai dari sekarang, siapa pun bisa jadi kreator teknologi!`
      },
    ],
  },
  {
    id: 49,
    title: "Mengenal Dunia Robotik: Apa Saja yang Dipelajari di Ekskul Ini?",
    desc: "Ekskul robotik bukan cuma soal merakit robot, tapi juga tentang bagaimana kita belajar menyelesaikan masalah dengan kreativitas dan teknologi.",
    category: "Robotic",
    imageSrc: "/img/blog/robotic/robot13.jpg",
    createdAt: "2025-01-08T11:30:00",
    content: [
      {
        heading: "Ekskul Robotik: Seru-Seruan Belajar Teknologi dari Nol!",
        description: `Di ekskul ini, kamu akan dikenalkan pada komponen dasar robot, seperti sensor, motor, dan mikrokontroler (biasanya Arduino atau sejenisnya). Kamu juga akan belajar dasar-dasar pemrograman, agar robot bisa “berpikir” dan melakukan tugas seperti mengikuti garis, menghindari rintangan, atau mengambil benda.

          Selain itu, ada banyak kegiatan seru seperti:
          • Merancang dan membuat robot dari awal,
          • Menguji dan memperbaiki robot agar bisa berjalan sesuai rencana,
          • Hingga berkompetisi dengan sekolah lain lewat lomba-lomba robotik!

          Menariknya, kamu nggak harus langsung jago teknologi kok. Semua dimulai dari nol, yang penting kamu suka belajar dan gak takut mencoba hal baru!`,
      },
    ],
  },
  {
    id: 50,
    title: "Mengenal Ekskul AI: Langkah Awal Menjadi Inovator Teknologi",
    desc: "Artificial Intelligence (AI) bukan lagi sekadar topik di film fiksi ilmiah, AI menjadi bagian nyata dari kehidupan kita. Dari rekomendasi video di YouTube hingga asisten virtual seperti Siri, semuanya melibatkan AI. Menariknya, kamu bisa mulai mempelajari teknologi ini lewat ekstrakurikuler AI di sekolah!",
    category: "Artificial Intelligence (AI)",
    imageSrc: "/img/blog/AI/ai14.jpg",
    createdAt: "2025-01-12T13:30:00",
    content: [
      {
        heading: "Apa Itu Ekskul AI?",
        description: `Ekskul AI adalah kegiatan tambahan di sekolah yang fokus pada pengenalan konsep dasar kecerdasan buatan. Di sini, kamu akan belajar cara kerja AI, mengenal bahasa pemrograman dasar, dan mencoba langsung membuat proyek sederhana seperti:
            • Chatbot untuk menjawab pertanyaan otomatis
            • Program deteksi wajah atau objek
            • Game yang bisa belajar dari perilaku pemain`,
      },
      {
        heading: "Kenapa Harus Coba Ekskul AI?",
        description: `1.Belajar Skill Masa Depan: AI adalah salah satu bidang paling dicari di dunia kerja saat ini dan di masa depan.
            2.Melatih Logika dan Kreativitas: Kamu tidak hanya belajar kode, tapi juga berpikir bagaimana teknologi bisa menyelesaikan masalah nyata.
            3.Seru dan Menantang: Belajar AI bisa sambil main game, eksplorasi gambar, atau bikin robot mini!`,
      },
      {
        heading: "Siapa Saja yang Bisa Ikut?",
        description: `Tidak perlu jago ngoding dulu kok! Ekskul AI dirancang untuk pemula, bahkan yang belum pernah ngoding sekalipun. Yang penting kamu penasaran, mau belajar, dan suka eksplorasi teknologi.
          Ekskul AI bukan hanya tentang belajar teknologi, tapi tentang membentuk cara berpikir dan menciptakan solusi. Yuk, jadi bagian dari generasi yang tidak hanya menggunakan teknologi, tapi juga menciptakannya!`,
      },
    ],
  },
  {
    id: 51,
    title: "Manfaat Ikut Ekskul Competitive Programming Sejak Dini",
    desc: "Banyak orang mengira competitive programming (CP) hanya untuk siswa SMA atau mahasiswa. Padahal, kalau mulai dari SD atau SMP, kamu bisa punya start yang jauh lebih baik!",
    category: "Competitive Programming",
    imageSrc: "/img/blog/competitive/compe-2.png",
    createdAt: "2025-02-10T13:30:00",
    content: [
      {
        heading: "",
        description: `Yuk, kenalan dengan manfaat ikut ekskul CP sejak dini!`,
      },
      {
        heading: "🧠 1. Melatih Logika dan Pola Pikir Sistematis",
        description: `Saat kamu mengerjakan soal CP, kamu belajar berpikir terstruktur dan rapi. Kamu harus memecah masalah besar jadi bagian kecil yang bisa diselesaikan satu per satu.
          CP bikin otakmu makin terlatih untuk "berpikir seperti komputer" — cepat, efisien, dan akurat!`,
      },
      {
        heading: "🧩 2. Menyenangkan dan Menantang!",
        description: `Soal-soal CP seperti teka-teki atau puzzle yang seru. Makin sering latihan, makin penasaran nyari solusi. Buat anak-anak yang suka tantangan, CP itu game yang penuh kepuasan!`,
      },
      {
        heading: "🎯 3. Mengasah Kemampuan Problem Solving",
        description: `Kamu nggak cuma belajar coding, tapi juga cara berpikir kreatif dan mencari solusi alternatif. Ini berguna banget di kehidupan nyata, sekolah, bahkan nanti saat kerja.`,
      },
      {
        heading: "🏅 4. Punya Peluang Ikut Kompetisi Bergengsi",
        description: `Kalau sudah terbiasa sejak kecil, kamu bisa ikut lomba seperti:
          • OSN Informatika
          • TOKI (Tim Olimpiade Komputer Indonesia)
          • Lomba Coding Nasional/Internasional
          Menang lomba? Bisa jadi prestasi keren untuk CV dan beasiswa!`,
      },
      {
        heading: "💼 5. Bekal Masa Depan di Dunia Teknologi",
        description: `Dunia kerja masa depan sangat butuh orang yang bisa berpikir cepat dan paham teknologi. CP jadi modal penting kalau kamu ingin masuk jurusan teknik, komputer, atau jadi programmer handal.`,
      },
      {
        heading: "🤝 6. Belajar Kolaborasi dan Sportivitas",
        description: `Meski CP sering dikerjakan sendiri, banyak juga lomba tim atau sesi diskusi kelompok. Kamu belajar kerja sama, komunikasi, dan belajar bareng teman-teman.`,
      },
      {
        heading: "🚀 Kesimpulan",
        description: `Ikut ekskul CP sejak dini bukan cuma tentang belajar coding, tapi juga membentuk cara berpikir cerdas dan tahan banting menghadapi tantangan. Dan yang paling penting: menyenangkan!
          Kalau sekolahmu ada ekskul CP, coba deh ikut. Kalau belum ada? Siapa tahu kamu bisa jadi pelopornya 😉`,
      },
    ],
  },
  {
    id: 52,
    title: "Manfaat Ikut Ekskul Robotik: Bukan Cuma Bisa Bikin Robot!",
    desc: "Banyak yang mengira ikut ekskul robotik cuma buat mereka yang hobi teknologi. Padahal, manfaatnya jauh lebih luas dari sekadar bisa merakit robot!",
    category: "Robotic",
    imageSrc: "/img/blog/robotic/robot14.jpg",
    createdAt: "2025-01-15T13:30:00",
    content: [
      {
        heading: "",
        description: `Berikut beberapa manfaat utama yang bisa kamu dapatkan:`,
      },
      {
        heading: "1.  Melatih Cara Berpikir Kritis & Kreatif",
        description: `Saat robot nggak bekerja sesuai harapan, kamu harus cari tahu kenapa dan bagaimana memperbaikinya. Ini melatih logika, analisis, dan kreativitasmu dalam memecahkan masalah.`,
      },
      {
        heading: "2.  Belajar Kerja Sama Tim",
        description: `Proyek robotik sering dikerjakan bareng-bareng. Kamu akan belajar komunikasi, berbagi ide, dan menyatukan keahlian dengan teman satu tim.`,
      },
      {
        heading: "3.  Punya Nilai Tambah untuk Masa Depan",
        description: `Pengalaman robotik bisa jadi nilai plus saat melanjutkan pendidikan atau melamar kerja, terutama di bidang teknologi, teknik, atau sains.`,
      },
      {
        heading: "4.  Mengenal Dunia Teknologi Lebih Dekat",
        description: `Ekskul robotik bikin kamu terbiasa dengan hal-hal seperti sensor, mikrokontroler, hingga pemrograman. Semua itu sangat relevan di era digital sekarang.`,
      },
      {
        heading: "5. Meningkatkan Rasa Percaya Diri",
        description: `Mampu membuat sesuatu yang bisa bergerak dan bereaksi dari hasil kerja sendiri itu memuaskan! Ini bisa meningkatkan kepercayaan dirimu secara alami.
          
          Jadi, ikut ekskul robotik bukan cuma seru, tapi juga bermanfaat banget buat perkembangan dirimu secara menyeluruh. Siap jadi problem solver masa depan?`,
      },
    ],
  },
  {
    id: 53,
    title: "Serunya Belajar CP: Dari Game Logika sampai Tembus Olimpiade",
    desc: "Belajar Competitive Programming (CP) nggak harus langsung serius dan ribet. Banyak anak mulai dari main game logika, lalu tanpa sadar makin jago, dan akhirnya bisa tembus ke olimpiade!",
    category: "Competitive Programming",
    imageSrc: "/img/blog/competitive/compe-3.png",
    createdAt: "2025-02-23T13:30:00",
    content: [
      {
        heading: "",
        description: `Yuk lihat gimana perjalanan seru belajar CP bisa dimulai dari hal sederhana:`,
      },
      {
        heading: "🎮 1. Awal Mula: Game Seru yang Melatih Otak",
        description: `Banyak siswa SD dan SMP mengenal CP lewat game-game edukatif seperti:
          • Lightbot: Belajar logika pemrograman tanpa kode
          • CodeCombat: Petualangan RPG pakai kode Python/JavaScript
          • Scratch: Bikin animasi & game sendiri dengan blok kode
          Game ini bukan cuma asyik, tapi juga secara tidak langsung mengajarkan cara berpikir algoritmis.`,
      },
      {
        heading: "🧠 2. Lanjut ke Tantangan Coding Nyata",
        description: `Setelah terbiasa, kamu bisa lanjut ke soal-soal pemrograman dasar di platform seperti:
          • Code.org
          • HackerRank
          • Kattis

          Di sini kamu mulai mengenal konsep penting seperti:
          • If-else, perulangan
          • Array dan string
          • Algoritma dasar (sorting, searching)`,
      },
      {
        heading: "🏆 3. Ikut Lomba dan Tembus Olimpiade",
        description: `Sudah makin jago? Saatnya uji kemampuan di berbagai kompetisi CP, seperti:
          • Lomba internal sekolah
          • Try Out OSN
          • TOKI Open (untuk semua usia!)
          • OSN Informatika jalan menuju Tim Olimpiade Komputer Indonesia
          Nggak sedikit siswa SMP atau SMA yang berawal dari suka main game coding, lalu sukses menjuarai kompetisi tingkat nasional bahkan internasional!`,
      },
      {
        heading: "🤝 4. Belajar Bareng, Tambah Seru!",
        description: `Belajar CP juga bisa bareng teman-teman. Bikin klub kecil, diskusi soal sulit, atau adain lomba internal bisa bikin belajar CP jadi lebih seru dan nggak membosankan.`,
      },
      {
        heading: "🚀 Kesimpulan",
        description: `Competitive Programming bisa dimulai dari hal kecil seperti game logika, lalu berkembang menjadi hobi yang bermanfaat dan prestasi membanggakan.

          Siapa sangka, main coding bisa jadi jalan menuju medali OSN atau bahkan karier masa depan di dunia teknologi!

          Yuk mulai sekarang — bukan untuk jadi yang paling jago, tapi untuk menikmati proses belajar yang menyenangkan 🔥`,
      },
    ],
  },
  {
    id: 54,
    title: "Skill Apa yang Bisa Kamu Dapatkan dari Ekskul AI?",
    desc: "Ikut ekskul AI bukan cuma tentang belajar teknologi keren. Di balik latihan membuat chatbot, mengenali gambar, atau bikin model prediksi, kamu sebenarnya sedang membangun berbagai skill penting yang berguna untuk masa depan, baik di dunia teknologi maupun di luar itu!",
    category: "Artificial Intelligence (AI)",
    imageSrc: "/img/blog/AI/ai15.jpg",
    createdAt: "2025-02-16T10:30:00",
    content: [
      {
        heading: "",
        description: "Berikut beberapa skill utama yang bisa kamu dapatkan:",
      },
      {
        heading: "1. Berpikir Logis dan Kritis",
        description: `AI bekerja berdasarkan pola dan logika. Saat kamu membuat model AI atau menyusun program, kamu otomatis terlatih untuk berpikir runtut, menganalisis masalah, dan mencari solusi efektif.`
      },
      {
        heading: "2. Kemampuan Problem Solving",
        description: `AI digunakan untuk menyelesaikan berbagai tantangan, mulai dari mengenali sampah hingga memprediksi cuaca. Lewat ekskul, kamu akan belajar bagaimana mengubah masalah jadi solusi yang bisa dijalankan dengan teknologi.`,
      },
      {
        heading: "3. Dasar-dasar Coding dan Algoritma",
        description: `Meski tidak langsung mendalami semua bahasa pemrograman, ekskul AI akan membiasakan kamu dengan logika pemrograman, alur data, dan algoritma sederhana yang menjadi fondasi dunia komputer.`,
      },
      {
        heading: "4. Kolaborasi dan Kerja Tim",
        description: `Banyak proyek AI dilakukan dalam kelompok. Artinya, kamu juga akan belajar komunikasi, kerja sama, pembagian tugas, dan saling bantu memahami konsep.`,
      },
      {
        heading: "5. Kreativitas Teknologi",
        description: `AI bukan cuma tentang rumus, tapi juga tentang cara kreatif menggunakan teknologi untuk membuat sesuatu yang baru dan bermanfaat. Kamu bisa gabungkan AI dengan seni, musik, bahkan game!`,
      },
      {
        heading: "6. Literasi Teknologi",
        description: `Di era digital, penting banget untuk ngerti cara kerja teknologi di balik aplikasi yang kita pakai sehari-hari. Dengan ekskul AI, kamu jadi nggak cuma pengguna, tapi juga pencipta teknologi.`,
      },
      {
        heading: "Bonus: Persiapan Karier Masa Depan",
        description: `AI digunakan di hampir semua bidang, mulai dari kesehatan, pendidikan, bisnis, hingga hiburan. Skill yang kamu pelajari hari ini bisa jadi bekal emas untuk karier di masa depan!

          Ekskul AI bukan sekadar kegiatan tambahan, ini adalah investasi untuk masa depanmu. Siap jadi pelajar yang tech-savvy dan problem solver?`,
      },
    ],
  },
  {
    id: 55,
    title: "Kenalan dengan Komponen Robot: Sensor, Motor, dan Otak Robot",
    desc: "Sebelum robot bisa bergerak, mendeteksi rintangan, atau bahkan mengikuti garis, ada beberapa komponen penting yang bekerja di balik layar. Yuk, kenalan dengan “organ-organ” utama dalam sebuah robot!",
    category: "Robotic",
    imageSrc: "/img/blog/robotic/robot15.jpg",
    createdAt: "2025-03-20T16:00:00",
    content: [
      {
        heading: "1.  Sensor: Mata dan Telinga Robot 👀👂",
        description: `Sensor adalah alat yang membantu robot “merasakan” lingkungan sekitarnya. Ada banyak jenis sensor, misalnya:
          • Sensor cahaya (LDR): untuk mendeteksi terang-gelap.
          • Sensor ultrasonik: untuk mengukur jarak ke objek.
          • Sensor garis (IR): digunakan pada robot line follower.`,
      },
      {
        heading: "2.  Motor: Kaki dan Tangan Robot 🤖",
        description: `Motor berfungsi sebagai penggerak robot.
          • DC motor biasanya dipakai untuk roda.
          • Servo motor dipakai untuk gerakan yang lebih presisi, seperti pada lengan robotik. Tanpa motor, robot nggak akan bisa bergerak!`,
      },
      {
        heading: "3.  Mikrokontroler: Otak Robot 🧠",
        description: `Komponen ini mengatur semua perintah dan respon dari sensor ke motor. Yang paling populer adalah Arduino, karena mudah diprogram dan cocok untuk pemula. Semua logika seperti “jika ada garis, belok kiri” ditulis dalam kode program dan dijalankan di sini.
          
          Semua komponen ini saling bekerja sama, layaknya tubuh manusia. Sensor mengamati, mikrokontroler memutuskan, motor mengeksekusi. Itulah yang membuat robot bisa "hidup".`,
      },
    ],
  },
  {
    id: 56,
    title: "Tips Belajar CP Tanpa Harus Jago Matematika Dulu",
    desc: "Banyak orang bilang, 'Kalau mau jago competitive programming (CP), harus jago matematika dulu.'' Padahal, itu nggak sepenuhnya benar! Kalau kamu masih pemula dan merasa kurang kuat di matematika, jangan khawatir, karena CP bisa dipelajari step by step, bahkan tanpa harus jadi ahli matematika dulu. Yuk simak tipsnya!",
    category: "Competitive Programming",
    imageSrc: "/img/blog/competitive/compe-4.png",
    createdAt: "2025-03-10T12:00:00",
    content: [
      {
        heading: "✅ 1. Mulai dari Logika Sederhana",
        description: `Banyak soal CP di level awal nggak butuh rumus rumit, tapi cuma minta kamu berpikir logis dan terstruktur.
          Misalnya:
          • Menentukan bilangan ganjil/genap
          • Menjumlahkan deret angka
          • Mencari nilai tertinggi atau terendah
          Kamu cukup paham cara kerja if-else, perulangan, dan array — bukan aljabar berat!`,
      },
      {
        heading: "🧱 2. Pahami Konsep Dasar Pemrograman Dulu",
        description: `Fokus dulu ke hal-hal ini:
          • Perulangan (looping)
          • Kondisi (if-else)
          • Fungsi (function)
          • Array/list
S         etelah itu, pelan-pelan kamu akan siap ke materi yang lebih menantang seperti rekursi, sorting, dan sebagainya.`,
      },
      {
        heading: "🎮 3. Belajar Lewat Game dan Simulasi",
        description: `Gunakan tools seperti:
          • Code.org
          • Scratch
          • CodeCombat

          Belajar lewat game coding itu seru dan nggak bikin stres! Cocok banget untuk pemula.`,
      },
      {
        heading: "👥 4. Belajar Bareng Teman",
        description: `Kadang kita lebih semangat belajar kalau ada teman diskusi. Kamu bisa bikin kelompok kecil, ikut ekskul CP di sekolah, atau gabung komunitas online.

          Diskusi soal bareng-bareng bikin konsep lebih mudah dipahami`,
      },
      {
        heading: "🧠 5. Matematika Dasar Bisa Dipelajari Sambil Jalan",
        description: `Tenang, kamu akan tetap belajar matematika sedikit demi sedikit, tapi dengan konteks nyata. Misalnya:
          • Looping bikin kamu paham pola dan perulangan
          • Soal array bikin kamu ngerti indeks dan posisi
          • Sorting dan searching bantu kamu paham efisiensi

          Matematika jadi lebih masuk akal dan menyenangkan saat kamu lihat aplikasinya di dunia nyata.`,
      },
      {
        heading: "✨ Penutup",
        description: `Kamu nggak harus jago matematika dulu untuk mulai belajar CP. Yang penting adalah rasa ingin tahu, semangat mencoba, dan konsisten latihan.

          Siapa tahu, dari yang awalnya takut angka, kamu malah jadi ahli algoritma 💪`,
      },
    ],
  },
  {
    id: 57,
    title: "Perbedaan Ekskul AI dan Ekskul Coding: Mana yang Cocok Buatmu?",
    desc: "Di banyak sekolah, siswa sering bingung memilih antara ekskul AI dan ekskul coding. Keduanya memang sama-sama seru dan berhubungan dengan teknologi, tapi sebenarnya punya fokus dan pendekatan yang berbeda.",
    category: "Artificial Intelligence (AI)",
    imageSrc: "/img/blog/AI/ai16.jpg",
    createdAt: "2025-03-01T14:30:00",
    content: [
      {
        heading: "",
        description: `Yuk, kita bahas perbedaannya supaya kamu bisa memilih yang paling cocok!`,
      },
      {
        heading: "🧠 Ekskul AI (Artificial Intelligence)",
        description: `Fokus utama:
            Mengajarkan bagaimana komputer bisa "belajar" dari data dan membuat keputusan sendiri.            
            Kegiatan umum:
            • Melatih model AI dengan gambar/suara/teks
            • Membuat chatbot
            • Proyek klasifikasi (misalnya deteksi wajah atau emosi)
            • Menggunakan tools seperti Teachable Machine, Dialogflow, atau Google Colab

            Skill yang diasah:
            • Analisis data
            • Logika pemrograman
            • Kreativitas dalam membangun solusi
            • Dasar-dasar machine learning

            Cocok untuk kamu yang:
            ✅ Suka teknologi canggih
            ✅ Ingin bikin sistem “pintar”
            ✅ Tertarik pada otomatisasi, robot, atau data`,
      },
      {
        heading: "💻 Ekskul Coding",
        description: `Fokus utama:
          Mengajarkan cara menulis kode dan membangun aplikasi atau program dari awal.

          Kegiatan umum:
          • Belajar bahasa pemrograman (Python, Java, C++, dll)
          • Membuat game, aplikasi, atau website
          • Menyelesaikan tantangan algoritma
          • Belajar struktur data dan logika pemrograman

          Skill yang diasah:
          • Keterampilan teknis pemrograman
          • Penyusunan algoritma
          • Debugging dan pemecahan masalah

          Cocok untuk kamu yang:
          ✅ Suka ngoding dari nol
          ✅ Ingin jadi programmer atau developer
          ✅ Ingin bikin aplikasi sendiri`,
      },
      {
        heading: "Jadi, Mana yang Harus Kamu Pilih?",
        description: `🔹 Pilih AI kalau kamu tertarik dengan teknologi masa depan seperti machine learning, robotik, dan aplikasi cerdas.
          🔹Pilih Coding kalau kamu mau menguasai dasar pemrograman dan membangun software sendiri.

          Bonus: Kamu bisa mulai dari coding dulu untuk memperkuat dasar logika, lalu lanjut ke AI. Atau sebaliknya, mulai dari AI untuk eksplorasi praktis, lalu perdalam coding!
          Intinya, dua-duanya keren dan saling melengkapi. Pilih yang sesuai minatmu dan jangan takut mencoba keduanya!💡`,
      },
    ],
  },
  {
    id: 58,
    title: "Competitive Programming Itu Seru Kalau Bareng Teman!",
    desc: "Banyak orang mengira competitive programming (CP) itu kegiatan sendirian, duduk di depan laptop, nulis kode berjam-jam. Padahal, CP bisa jadi jauh lebih seru, semangat, dan menyenangkan kalau dikerjakan bareng teman-teman!",
    category: "Competitive Programming",
    imageSrc: "/img/blog/competitive/compe-5.png",
    createdAt: "2025-04-30T14:00:00",
    content: [
      {
        heading: "👯‍♂️ 1. Bisa Saling Bantu dan Diskusi",
        description: `Kalau belajar bareng, kamu bisa:
          • Tukar pendapat soal cara menyelesaikan soal
          • Ngobrol soal bug yang bikin pusing
          • Dapat insight baru dari sudut pandang teman
          Kadang, teman bisa menjelaskan lebih jelas daripada buku atau guru!`,
      },
      {
        heading: "🔥 2. Lebih Termotivasi Belajar",
        description: `Lagi mager ngoding? Tapi pas lihat teman-teman semangat ikut CP club atau ekskul, jadi ikutan semangat juga!
          Belajar bareng itu seperti olahraga bareng lebih ringan, lebih asyik, dan bikin kamu terus berkembang.`,
      },
      {
        heading: "🧩 3. Bisa Ikut Lomba Tim",
        description: `Banyak lomba CP yang berbentuk tim, contohnya:
          • Lomba internal sekolah
          • ICPC (untuk mahasiswa, tapi prinsipnya bisa diterapkan sejak SMA)
          • Lomba kreatif berbasis coding
          Ngoding bareng tim ngajarin kamu komunikasi, bagi tugas, dan kerja sama di bawah tekanan waktu.`,
      },
      {
        heading: "🥳 4. Bikin Coding Jadi Aktivitas Sosial",
        description: `Ngoding bareng bisa dibarengi hal seru lain, seperti:
          • Ngopi atau makan bareng sambil bahas soal
          • Bikin mini turnamen internal di kelas
          • Main game coding kayak CodeCombat bareng-bareng
          CP jadi bukan cuma belajar, tapi juga tempat berkumpul dan bersenang-senang.`,
      },
      {
        heading: "🚀 5. Bertumbuh Bersama",
        description: `Setiap teman punya kekuatan berbeda — ada yang jago logika, ada yang cepat baca soal, ada yang teliti soal bug.
          Dengan belajar bareng, kamu bisa saling mengisi dan tumbuh bersama jadi programmer hebat.`,
      },
      {
        heading: "✨ Penutup",
        description: `Competitive Programming itu bukan cuma soal menang lomba atau nulis kode cepat. Tapi juga tentang proses belajar yang menyenangkan, apalagi kalau dijalani bareng teman-teman yang punya semangat sama.
          Yuk ajak temanmu, bentuk kelompok kecil, dan mulai latihan bareng!
          Karena dalam CP, bersama itu lebih kuat 💪`,
      },
    ],
  },
  {
    id: 59,
    title: "Apa Itu Sertifikasi BNSP AI dan Manfaatnya untuk Karier di Bidang Teknologi",
    desc: "Di era teknologi saat ini, kecerdasan buatan (Artificial Intelligence/AI) jadi salah satu bidang yang paling berkembang dan banyak dibutuhkan. Tapi, gimana caranya menunjukkan kalau kita benar-benar kompeten di bidang ini? Salah satu jawabannya adalah Sertifikasi BNSP AI.",
    category: "Artificial Intelligence (AI)",
    imageSrc: "/img/blog/AI/ai17.jpg",
    createdAt: "2025-03-15T10:00:00",
    content: [
      {
        heading: "Apa Itu Sertifikasi BNSP?",
        description: `BNSP (Badan Nasional Sertifikasi Profesi) adalah lembaga resmi negara yang memberikan sertifikasi kompetensi kerja. Sertifikasi ini bukan hanya pengakuan, tapi juga bukti bahwa kamu memenuhi standar profesi nasional di bidang tertentu, termasuk AI.
          
          Berikut beberapa manfaat nyata sertifikasi ini untuk karier kamu di dunia teknologi:`,
      },
      {
        heading: "1. Bukti Kompetensi yang Diakui Negara",
        description: `Sertifikasi BNSP dikeluarkan oleh lembaga resmi pemerintah, artinya keahlianmu diakui secara nasional. Ini penting saat melamar kerja, naik jabatan, atau terlibat dalam proyek resmi.`,
      },
      {
        heading: "2. Meningkatkan Peluang Kerja",
        description: `Perusahaan teknologi kini mencari tenaga kerja yang bukan hanya bisa, tapi terbukti bisa. Dengan sertifikat ini, kamu bisa menonjol dibanding pelamar lain.`,
      },
      {
        heading: "3. Memperkuat CV dan Portofolio",
        description: `Sertifikasi memberikan kesan profesional dan menunjukkan bahwa kamu serius membangun karier di bidang AI.`,
      },
      {
        heading: "4. Menambah Rasa Percaya Diri",
        description: `Lulus sertifikasi berarti kamu sudah lolos uji kompetensi. Hal ini memberi rasa percaya diri saat menghadapi wawancara atau menangani proyek AI.`,
      },
      {
        heading: "5. Akses ke Jaringan Profesional",
        description: `Melalui pelatihan dan uji kompetensi, kamu akan bertemu dengan pengajar, asesor, dan peserta lain yang bisa menjadi jaringan profesional di masa depan.`,
      },
      {
        heading: "6. Menjadi Modal untuk Freelance atau Bisnis",
        description: `Ingin menjadi freelancer di bidang data science, AI modeling, atau automation? Sertifikasi ini bisa jadi modal kuat untuk membangun kepercayaan klien.`,
      },
      {
        heading: "Kesimpulan",
        description: `Sertifikasi BNSP AI bukan sekadar sertifikat, tapi investasi nyata untuk memperkuat kariermu di era digital. Cocok untuk pemula yang ingin masuk dunia AI maupun profesional yang ingin naik level.`,
      },
    ],
  },
  {
    id: 60,
    title: "Kenapa Profesional Digital Marketing Perlu Sertifikasi BNSP?",
    desc: "Di tengah persaingan dunia digital yang makin ketat, menjadi profesional digital marketing saja tidak cukup. Kini, banyak perusahaan dan klien mencari bukti kompetensi nyata dan di sinilah sertifikasi BNSP berperan penting.",
    category: "Digital Marketing",
    imageSrc: "/img/blog/dm/dm6.jpg",
    createdAt: "2025-01-10T10:00:00",
    content: [
      {
        heading: "1. Pengakuan Resmi dari Negara",
        description: `Sertifikasi BNSP diakui secara nasional karena langsung dikeluarkan oleh lembaga resmi negara. Ini membuktikan bahwa kemampuan kamu sudah sesuai standar industri Indonesia.`,
      },
      {
        heading: "2. Naikkan Kredibilitas di Mata Klien & HRD",
        description: `Dengan sertifikat kompetensi, kamu bukan cuma ngaku bisa, tapi terbukti bisa. Ini menjadi nilai plus saat negosiasi proyek, promosi, atau melamar ke posisi yang lebih tinggi.`,
      },
      {
        heading: "3. Standar Kompetensi yang Terstruktur",
        description: `Uji kompetensinya mengacu pada SKKNI (Standar Kompetensi Kerja Nasional Indonesia), mencakup berbagai aspek penting digital marketing: mulai dari riset pasar, konten, iklan digital, hingga evaluasi performa.`,
      },
      {
        heading: "4. Buka Jalan Jadi Trainer atau Konsultan",
        description: `Sertifikasi BNSP juga menjadi syarat utama jika kamu ingin jadi trainer bersertifikat atau konsultan di lembaga resmi. Cocok untuk kamu yang ingin naik level dari praktisi ke pembimbing.`,
      },
      {
        heading: "🚀 Singkatnya",
        description: `Sertifikasi ini bukan sekadar selembar kertas, tapi investasi jangka panjang untuk karier digital marketing-mu.
          Sudah saatnya naik kelas!`,
      },
    ],
  },
  {
    id: 61,
    title: "Kolaborasi Seru: Ketika Robotik Bertemu Seni dan Desain",
    desc: "Siapa bilang robotik cuma soal kabel, coding, dan logika? Di balik rangka logam dan sensor, ada ruang besar untuk kreativitas dan seni. Yup, dunia robotik ternyata bisa banget dikolaborasikan dengan desain dan estetika!",
    category: "Robotic",
    imageSrc: "/img/blog/robotic/robot16.jpg",
    createdAt: "2025-04-30T16:30:00",
    content: [
      {
        heading: "1.  Desain Body Robot yang Unik",
        description: `Robot nggak harus berbentuk kotak membosankan. Dengan sentuhan desain, kita bisa membuat robot tampil keren, lucu, atau bahkan futuristik! Pemilihan warna, bentuk, dan bahan juga jadi bagian dari kreativitas.`,
      },
      {
        heading: "2.  Robot sebagai Media Seni",
        description: `Beberapa proyek robotik digunakan untuk melukis otomatis, membuat musik interaktif, atau instalasi seni kinetik. Di sinilah teknologi dan ekspresi artistik saling menyatu.`,
      },
      {
        heading: "3.  Kolaborasi Tim yang Beragam",
        description: `Dalam tim robotik, nggak semua orang harus jago teknis. Mereka yang suka gambar, desain 3D, atau bahkan storyboard bisa berkontribusi besar. Ini membuka peluang kolaborasi antarbidang di sekolah.`,
      },
      {
        heading: "4.  Belajar Menyampaikan Ide dengan Visual",
        description: `Saat mempresentasikan proyek robotik, visualisasi dan storytelling penting banget. Dari poster, video demo, sampai pitch ide, semuanya melibatkan elemen desain.
          Robotik bukan cuma untuk anak teknik. Kalau kamu suka menggambar, mendesain, atau berpikir out-of-the-box, robotik juga bisa jadi ruang kamu berkarya!`,
      },
    ],
  },
  {
    id: 62,
    title: "Perbedaan Sertifikasi BNSP vs Sertifikasi Internasional (Meta, Google, HubSpot)",
    desc: "Saat ini ada banyak pilihan sertifikasi digital marketing, baik dari lembaga nasional seperti BNSP, maupun internasional seperti Meta Blueprint, Google Digital Garage, atau HubSpot Academy. Tapi, mana yang paling cocok untuk kamu?",
    category: "Digital Marketing",
    imageSrc: "/img/blog/dm/dm7.jpg",
    createdAt: "2025-02-03T16:30:00",
    content: [
      {
        heading: "",
        description: `Yuk, kita bandingkan!`,
      },
      {
        heading: "🏛️ 1. Lembaga Penerbit",
        description: `• BNSP (Badan Nasional Sertifikasi Profesi):
          Diterbitkan oleh lembaga negara Indonesia. Diakui secara resmi dan legal di dalam negeri.
          • Meta / Google / HubSpot:
          Diterbitkan oleh perusahaan internasional. Diakui secara luas di dunia global dan industri startup.`,
      },
      {
        heading: "🎯 2. Tujuan Sertifikasi",
        description: `• BNSP:
          Menilai kompetensi kerja nyata sesuai dengan SKKNI (Standar Kompetensi Kerja Nasional Indonesia). Fokus pada praktik profesional.
          • Internasional:
          Memberikan pemahaman tentang tools/platform milik mereka. Fokus pada penggunaan produk tertentu, bukan penilaian praktik menyeluruh.`,
      },
      {
        heading: "📝 3. Metode Uji",
        description: `• BNSP:
          Wajib asesmen portofolio, wawancara, praktik langsung, dan penilaian oleh asesor.
          • Internasional:
          Umumnya berupa kuis online / video course dan tes pilihan ganda. Sertifikat langsung keluar jika lulus.`,
      },
      {
        heading: "📜 4. Legalitas Sertifikat",
        description: `• BNSP:
          Resmi diakui negara Indonesia, bisa digunakan untuk keperluan karier formal, promosi, bahkan untuk jadi pengajar.
          • Internasional:
          Diakui perusahaan global, tapi tidak punya kekuatan hukum di Indonesia.`,
      },
      {
        heading: "💼 5. Relevansi di Dunia Kerja",
        description: `• BNSP:
          Cocok untuk melamar kerja formal, naik jabatan, atau jadi trainer bersertifikat.
          • Internasional:
          Cocok untuk menambah skill & portfolio tools yang digunakan sehari-hari di agensi, startup, atau freelance.`,
      },
      {
        heading: "🧩 Jadi Pilih yang Mana?",
        description: `Kalau kamu ingin pengakuan resmi di Indonesia, wajib ambil Sertifikasi BNSP.
          Tapi kalau kamu butuh paham tools dan memperkuat skill praktis, sertifikasi internasional bisa jadi pelengkap yang powerful.
          Idealnya? Ambil dua-duanya. Satu untuk legalitas, satu untuk keahlian teknis global.`,
      },
    ],
  },
  {
    id: 63,
    title: "Tips Lulus Uji Sertifikasi BNSP Digital Marketing untuk Profesional Sibuk",
    desc: "Punya jadwal kerja padat tapi ingin lulus uji sertifikasi BNSP? Tenang, kamu tetap bisa lolos uji kompetensi dengan strategi yang tepat. Berikut tips yang bisa kamu terapkan",
    category: "Digital Marketing",
    imageSrc: "/img/blog/dm/dm8.jpg",
    createdAt: "2025-03-05T16:30:00",
    content: [
      {
        heading: "✅ 1. Pahami Unit Kompetensi yang Diujikan",
        description: `Jangan buang waktu belajar sembarangan. Fokuslah pada unit-unit yang benar-benar diuji, seperti:
          • Strategi digital marketing
          • Pembuatan konten
          • Manajemen kampanye
          • Analisis performa
          Cek detailnya di skema sertifikasi atau tanya ke LSP yang kamu pilih.`,
      },
      {
        heading: "✅ 2. Gunakan Portofolio Nyata dari Pekerjaanmu",
        description: `Sebagai profesional, kamu pasti sudah punya campaign, report, atau konten yang pernah kamu buat. Kumpulkan dan kemas ulang sebagai bukti portofolio — ini akan jadi nilai kuat saat asesmen.`,
      },
      {
        heading: "✅ 3. Latih Cara Menjelaskan Pengalamanmu",
        description: `Asesor akan bertanya seputar proses kerja kamu. Latih cara kamu bercerita, misalnya:
          • Apa masalah yang kamu hadapi?
          • Tools apa yang kamu pakai?
          • Apa hasil akhirnya?
          Pakai pendekatan STAR (Situation Task Action Result) biar jawabanmu terstruktur.`,
      },
      {
        heading: "✅ 4. Jadwalkan Belajar Singkat Tapi Konsisten",
        description: `Daripada belajar semalaman, luangkan 20–30 menit per hari selama 1–2 minggu untuk:
          • Membaca unit kompetensi
          • Menyusun portofolio
          • Menonton video asesmen simulasi (banyak di YouTube)`,
      },
      {
        heading: "✅ 5. Ikuti Pelatihan Pra-Uji (Jika Perlu)",
        description: `Beberapa LSP menawarkan kelas persiapan. Jika kamu merasa kurang yakin, ikuti kelas ini untuk dapat panduan langsung dari asesor atau instruktur.`,
      },
      {
        heading: "✅ 6. Jangan Takut Gagal — Bisa Re-Uji",
        description: `Kalau belum kompeten, kamu bisa re-uji unit tertentu tanpa harus mengulang semuanya. Yang penting, kamu tahu apa yang perlu ditingkatkan.`,
      },
      {
        heading: "🚀 Penutup",
        description: `Dengan persiapan cerdas dan strategi yang efisien, profesional sibuk pun tetap bisa lulus sertifikasi BNSP dengan percaya diri.

          Ingat, sertifikasi ini bukan sekadar lulus ujian, tapi juga bukti nyata kompetensimu di dunia kerja.`,
      },
    ],
  },
  {
    id: 64,
    title: "Masa Depan Dunia Robotik: Dari Sekolah ke Dunia Kerja",
    desc: "Di masa depan, robotik bukan cuma hobi seru di bangku sekolah, kemampuan ini bisa jadi bekal emas untuk karier yang menjanjikan!",
    category: "Robotic",
    imageSrc: "/img/blog/robotic/robot17.jpg",
    createdAt: "2025-04-25T16:30:00",
    content: [
      {
        heading: "1.  Dunia Semakin Otomatis",
        description: `Banyak industri mulai mengandalkan robot: dari pabrik mobil, rumah sakit, pertanian, sampai restoran. Artinya, orang yang paham robotik sangat dibutuhkan untuk merancang, mengatur, dan merawat sistem otomatis ini.`,
      },
      {
        heading: "2. Peluang Karier yang Luas",
        description: `Belajar robotik bisa membuka jalan ke berbagai profesi seperti:
          • Engineer robotika
          • Teknisi otomasi
          • AI programmer
          • Peneliti teknologi
          • Desainer sistem pintar
          Bahkan, banyak startup dan perusahaan teknologi mencari talenta muda yang punya pengalaman robotik sejak dini.`,
      },
      {
        heading: "3. Skill Abad 21",
        description: `Robotik melatih problem-solving, kreativitas, kerja tim, dan logika pemrograman. Semua ini adalah skill penting yang dicari di dunia kerja masa depan.`,
      },
      {
        heading: "4. Langkah Awal Bisa dari Sekolah",
        description: `Ekskul robotik adalah tempat yang tepat untuk mulai. Dari proyek kecil, kamu belajar hal besar yang bisa kamu bawa ke jenjang pendidikan lebih tinggi dan karier profesional.
          
          Jadi, jangan anggap robotik cuma sebagai kegiatan tambahan. Siapa tahu, itu awal dari perjalanan kamu jadi inovator masa depan!`,
      },
    ],
  },
  {
    id: 65,
    title: "Tren Karier Digital Marketing 2025: Apakah Sertifikasi Masih Relevan?",
    desc: "Dunia digital marketing terus berubah — algoritma berganti, tools makin canggih, dan konten makin kompetitif. Tapi di tengah semua itu, satu pertanyaan sering muncul: Apakah sertifikasi digital marketing masih relevan di tahun 2025?",
    category: "Digital Marketing",
    imageSrc: "/img/blog/dm/dm9.jpg",
    createdAt: "2025-04-10T13:30:00",
    content: [
      {
        heading: "",
        description: `Jawabannya adalah masih, dan bahkan semakin penting. Kenapa?`,
      },
      {
        heading: "🚀 1.  Rekrutmen Makin Selektif",
        description: `Perusahaan tidak hanya mencari kandidat yang “bisa”, tapi juga yang terbukti kompeten. Sertifikasi seperti BNSP menjadi filter awal bagi HR dan rekruter untuk memastikan kamu punya standar profesional yang diakui.`,
      },
      {
        heading: "📈 2.  Persaingan Freelancer Meningkat",
        description: `Klien global makin kritis. Mereka ingin tahu apakah kamu hanya jago teori atau benar-benar profesional. Sertifikat menjadi bukti nyata bahwa kamu memiliki keahlian yang terstruktur dan bisa diandalkan.`,
      },
      {
        heading: "📊 3.  Digital Marketing Jadi Posisi Strategis",
        description: `Kini digital marketer bukan cuma eksekutor iklan. Kamu adalah bagian dari strategi bisnis. Sertifikasi membekalimu dengan landasan kuat, sistematis, dan menyeluruh, bukan sekadar skill teknis.`,
      },
      {
        heading: "🛠️ 4.  Tools Bisa Dipelajari, Tapi Kompetensi Harus Diakui",
        description: `Kamu bisa belajar Google Ads atau SEO dari mana saja. Tapi untuk diakui profesional, kamu butuh validasi — dan sertifikasi BNSP adalah bukti resmi bahwa kamu memenuhi standar kerja nasional.`,
      },
      {
        heading: "📚 5.  Belajar Seumur Hidup = Nilai Tambah",
        description: `Punya sertifikasi menunjukkan kamu adalah orang yang aktif belajar dan berkembang, bukan hanya mengandalkan pengalaman lama. Ini nilai tambah penting di tengah era AI dan otomatisasi.`,
      },
      {
        heading: "Kesimpulan",
        description: `Di tahun 2025, sertifikasi bukan hanya relevan — tapi jadi pembeda antara digital marketer biasa dan yang profesional. Kalau kamu ingin naik level, kombinasi pengalaman nyata dan sertifikasi resmi adalah kunci untuk membuka peluang yang lebih besar.`,
      },
    ],
  },
  {
    id: 66,
    title: "Tips Lulus Sertifikasi BNSP AI untuk Pemula Tanpa Latar Belakang IT",
    desc: "Pengen ikut sertifikasi BNSP AI, tapi merasa minder karena nggak punya latar belakang IT? Jangan khawatir, banyak peserta non-IT yang berhasil lulus dengan persiapan yang tepat.",
    category: "Artificial Intelligence (AI)",
    imageSrc: "/img/blog/AI/ai18.jpg",
    createdAt: "2025-04-03T13:30:00",
    content: [
      {
        heading: "",
        description: `Berikut ini beberapa tips yang bisa kamu ikuti:`,
      },
      {
        heading: "1. Pahami Skema dan Unit Kompetensi",
        description: `Sebelum daftar, pelajari dulu skema sertifikasi yang kamu pilih. Setiap skema punya unit-unit kompetensi seperti:
          • Pemahaman dasar AI dan machine learning
          • Penerapan algoritma sederhana
          • Pengolahan data
          Baca dan pahami apa saja yang akan diuji supaya bisa mempersiapkan diri lebih terarah.`,
      },
      {
        heading: "2. Ikut Pelatihan yang Ramah untuk Pemula",
        description: `Pilih lembaga pelatihan yang membimbing dari nol, bukan yang langsung menyuruh coding. Banyak pelatihan sekarang menggunakan pendekatan visual atau project-based yang lebih mudah dipahami.`,
      },
      {
        heading: "3. Latihan dengan Tools No-Code atau Low-Code AI",
        description: `Kamu bisa belajar AI pakai platform seperti:
          • Teachable Machine (Google)
          • Scratch + AI Extension
          • KNIME atau RapidMiner
          Tools ini bisa bantu kamu paham konsep AI tanpa harus menulis ribuan baris kode.`,
      },
      {
        heading: "4. Buat Proyek Kecil untuk Portofolio",
        description: `Contoh: klasifikasi gambar sederhana, chatbot FAQ, atau analisis data survei. Asesor akan lebih mudah menilai jika kamu punya proyek nyata, meskipun sederhana.`,
      },
      {
        heading: "5. Belajar dari Soal atau Studi Kasus Tahun Sebelumnya",
        description: `Kalau memungkinkan, minta contoh soal atau studi kasus dari peserta sebelumnya. Ini bisa bantu kamu tahu bentuk ujian dan cara menjawabnya.`,
      },
      {
        heading: "6. Latih Cara Menjelaskan Pekerjaanmu",
        description: `Karena akan ada wawancara, kamu harus bisa menjelaskan apa yang kamu kerjakan, kenapa kamu memilih cara itu, dan hasilnya apa. Nggak harus pakai istilah teknis yang rumit, yang penting logis dan jelas.`,
      },
      {
        heading: "Kesimpulan",
        description: `Latar belakang bukan penghalang untuk lulus sertifikasi BNSP AI. Dengan strategi belajar yang tepat, pemahaman konsep dasar, dan latihan yang cukup, kamu punya peluang besar untuk dinyatakan kompeten!`,
      },
    ],
  },
  {
    id: 67,
    title: "Tempat Sertifikasi BNSP Digital Marketing yang Terpercaya dan Terakreditasi",
    desc: "Mau ikut sertifikasi BNSP Digital Marketing tapi bingung harus ke mana? Tenang - kamu harus cari LSP (Lembaga Sertifikasi Profesi) yang sudah terlisensi resmi dari BNSP dan punya rekam jejak yang baik.",
    category: "Digital Marketing",
    imageSrc: "/img/blog/dm/dm10.jpg",
    createdAt: "2025-05-25T16:30:00",
    content: [
      {
        heading: "",
        description: `Berikut beberapa tempat terpercaya yang bisa kamu pertimbangkan:`,
      },
      {
        heading: "✅ 1. LSP Digital Indonesia (LSP-DI)",
        description: `• Fokus pada bidang digital dan kreatif
          • Menyediakan skema khusus Digital Marketing sesuai SKKNI
          • Sudah meluluskan ribuan peserta dari berbagai kota
          📍 Tersedia online & offline
          🌐 Website: https://lspdigital.id `,
      },
      {
        heading: "✅ 2. LSP Teknologi Digital (LSP-TD)",
        description: `• Cocok untuk profesional IT dan digital
          • Asesmen bisa dilakukan jarak jauh
          • Banyak digunakan oleh kampus dan korporat
          📍 Lokasi: Jakarta & Online
          🌐 Website: https://lsptd.id`,
      },
      {
        heading: "✅ 3. LSP Komputer",
        description: `• Terkenal karena skema digital yang luas (termasuk content creation dan desain grafis)
          • Telah terakreditasi BNSP dan aktif mengadakan pelatihan + uji kompetensi
          📍 Banyak mitra di kota besar
          🌐 Website: https://lspkomputer.id`,
      },
      {
        heading: "✅ 4. LSP P1 Universitas atau Lembaga Pelatihan",
        description: `Beberapa universitas dan lembaga pelatihan punya LSP internal (LSP-P1) yang terverifikasi, seperti:
          • BINUS University
          • Universitas Indonesia (UI)
          • STMIK atau Politeknik Negeri
          Cocok untuk peserta dari latar akademik atau yang ikut pelatihan bersertifikat.`,
      },
      {
        heading: "💡 Tips Memilih LSP yang Tepat",
        description: `✅ Pastikan terdaftar di website resmi BNSP
          ✅ Cek testimoni alumni atau ulasan Google
          ✅ Tanyakan skema sertifikasi yang ditawarkan
          ✅ Pilih jadwal yang fleksibel, apalagi jika kamu profesional sibuk`,
      },
      {
        heading: "⚠️ Penting!",
        description: `Sertifikat BNSP hanya sah jika dikeluarkan oleh LSP resmi. Jangan tergiur harga murah tanpa kejelasan legalitasnya, ya!`,
      },
    ],
  },
  {
    id: 68,
    title: "Perbedaan Sertifikasi BNSP AI dan Sertifikasi AI Lainnya (Google, IBM, dll)",
    desc: "Saat kamu tertarik mendalami Artificial Intelligence (AI), kamu akan menemukan banyak jenis sertifikasi, baik dari dalam negeri seperti BNSP, maupun dari perusahaan global seperti Google, IBM, dan Microsoft. Tapi, apa sebenarnya perbedaan utama antara sertifikasi-sertifikasi.",
    category: "Artificial Intelligence (AI)",
    imageSrc: "/img/blog/AI/ai19.jpg",
    createdAt: "2025-04-26T16:30:00",
    content: [
      {
        heading: "",
        description: `Yuk, kita bahas!`,
      },
      {
        heading: "1. Lembaga Penerbit",
        description: `BNSP (Indonesia):
          • Diterbitkan oleh Badan Nasional Sertifikasi Profesi. Diakui secara nasional dan berbasis standar kompetensi kerja Indonesia (SKKNI).
          Google, IBM, Microsoft, Coursera, dll (Internasional):
          • Diterbitkan oleh perusahaan atau platform global. Diakui secara internasional, tergantung pada kredibilitas penerbitnya.`,
      },
      {
        heading: "2. Tujuan Sertifikasi",
        description: `BNSP:
          • Fokus pada pembuktian kompetensi kerja. Peserta diuji oleh asesor melalui praktik kerja, portofolio, dan wawancara.
          Google/IBM:
          • Fokus pada pembelajaran mandiri. Peserta menyelesaikan modul dan kuis, biasanya tanpa uji praktik langsung oleh asesor.`,
      },
      {
        heading: "3. Jenis Ujian",
        description: `BNSP:
          • Ujian mencakup observasi, studi kasus, praktik langsung, dan tanya jawab. Hasil akhir: Kompeten / Belum Kompeten.
          Google/IBM:
          • Ujian berupa pilihan ganda, kuis, atau proyek akhir. Hasil akhir: Skor / Sertifikat Kelulusan.`,
      },
      {
        heading: "4. Kekuatan Legalitas",
        description: `BNSP:
          • Memiliki kekuatan legal formal di Indonesia. Berguna untuk melamar kerja, kenaikan jabatan, hingga keperluan regulasi nasional.
          Sertifikasi Internasional:
          • Diakui secara global, cocok untuk portofolio kerja di luar negeri atau untuk perusahaan multinasional.`,
      },
      {
        heading: "5. Harga dan Akses",
        description: `BNSP:
          • Biaya bervariasi tergantung LSP dan pelatihan (rata-rata Rp1-2 juta). Harus mengikuti uji kompetensi langsung.
          Google/IBM:
          • Banyak yang bisa diakses gratis atau berlangganan melalui Coursera, edX, atau SkillUp.`,
      },
      {
        heading: "Kesimpulan",
        description: `Keduanya punya kelebihan masing-masing. Kalau kamu ingin bukti kompetensi formal di Indonesia, pilih BNSP. Tapi kalau ingin belajar dan tampil di pasar global, sertifikasi dari Google atau IBM bisa jadi pilihan tepat.`,
      },
    ],
  },
  {
    id: 69,
    title: "Pengalaman Peserta Sertifikasi BNSP AI: Cerita Nyata dan Pelajaran Berharga",
    desc: "Sertifikasi BNSP AI bisa terdengar menantang, apalagi buat kamu yang baru terjun ke dunia Artificial Intelligence. Tapi, banyak peserta yang berhasil melewati proses ini dengan sukses, bahkan tanpa latar belakang IT. Berikut salah satu cerita nyata dan pelajaran berharga yang bisa kamu ambil",
    category: "Artificial Intelligence (AI)",
    imageSrc: "/img/blog/AI/ai20.jpg",
    createdAt: "2025-05-20T16:00:00",
    content: [
      {
        heading: "🌟 Cerita: Diah, Mahasiswi Non-Teknik Lulus Sertifikasi AI",
        description: `Diah adalah mahasiswi jurusan Komunikasi yang awalnya hanya penasaran dengan AI. Ia ikut pelatihan AI untuk pemula, dan setelah itu, memutuskan untuk mengikuti sertifikasi BNSP dengan skema Junior AI Programmer.
          “Awalnya aku nggak ngerti coding, tapi pelatihannya pakai tools yang gampang dan bantu banget buat pahamin konsep AI. Aku juga bikin mini-proyek klasifikasi emosi dari teks. Waktu uji kompetensi, aku diminta jelasin cara kerja proyekku, itu yang jadi poin plus,” ujar Diah.
          Hasilnya? Diah dinyatakan kompeten. Sekarang, dia lebih percaya diri melamar pekerjaan sebagai data analyst intern di startup teknologi.`,
      },
      {
        heading: "🎓 Pelajaran Berharga dari Para Peserta",
        description: `1. Persiapan Lebih Penting dari Latar Belakang
          Banyak peserta non-IT yang lulus karena belajar serius dan konsisten latihan. Asal tahu apa yang diuji, kamu bisa persiapkan diri dengan baik.
          2. Proyek Sederhana Bisa Jadi Andalan
          Nggak perlu proyek besar. Proyek seperti chatbot sederhana, klasifikasi gambar, atau visualisasi data bisa menunjukkan kompetensimu.
          3. Pentingnya Bisa Menjelaskan Logika Kerja
          Asesor lebih tertarik pada cara kamu menjelaskan proses berpikir dan pengambilan keputusan, bukan sekadar hasil akhir.
          4. Jangan Takut Gagal
          Uji kompetensi bukan ujian seperti di sekolah. Kamu akan dinilai secara objektif dan bisa ikut ulang kalau belum kompeten.`,
      },
      {
        heading: "Kesimpulan",
        description: `Setiap peserta punya cerita unik dalam proses sertifikasi BNSP AI. Yang penting adalah kemauan belajar, keberanian mencoba, dan kesiapan menjelaskan hasil kerjamu. Dengan persiapan matang, kamu juga bisa mengikuti jejak mereka!`,
      },
    ],
  },
  {
    id: 70,
    title: "AEDU Raih Sertifikat Akreditasi, Siap Tingkatkan Pelatihan Berkualitas untuk Tenaga Kerja Profesional",
    desc: "Pada 10 Maret 2025, Pusat Pelatihan Accelist Edukasi Indonesia (AEDU) resmi menerima Sertifikat Akreditasi dari Kementerian Ketenagakerjaan (Kemnaker) dan Dinas Ketenagakerjaan (Disnaker). Sertifikat tersebut diterima langsung oleh Bapak Matius Kelvin dan Bapak Farid Afandy sebagai perwakilan AEDU.Pencapaian ini menandai komitmen AEDU dalam menghadirkan program pelatihan yang berkualitas, berstandar tinggi, dan relevan dengan kebutuhan industri. Dengan akreditasi ini, AEDU dapat lebih optimal dalam mengembangkan kompetensi tenaga kerja profesional yang siap bersaing di pasar kerja.",
    category: "Coding",
    imageSrc: "/img/blog/coding/coding13.jpeg",
    createdAt: "2025-09-19T16:00:00",
    content: [
      {
        description: `Akreditasi ini menjadi langkah strategis bagi AEDU untuk terus meningkatkan kualitas pelatihan dan memastikan lulusan kami memiliki keterampilan yang sesuai dengan standar industri,” ujar perwakilan AEDU. Langkah ini diharapkan tidak hanya memperkuat posisi AEDU sebagai lembaga pelatihan terdepan, tetapi juga mendukung pertumbuhan tenaga kerja kompeten dan siap kerja di berbagai sektor industri.`,
      },
    ],
  },
];

export const articles: Article[] = rawArticles.map(a => ({
  ...a,
  slug: slugify(a.title),
}));

export const workshop_levels: level[] = [
  {
    number: "1.0",
    text: "Pengenalan SKKNI",
    icon: "/img/course/workshop/workshop-icon-1.svg",
    subtitle: "Pelatihan Profesional",
  },
  {
    number: "2.0",
    text: "Materi & Praktik Industri",
    icon: "/img/course/workshop/workshop-icon-2.svg",
    subtitle: "Uji Kompetensi",
  },
  {
    number: "3.0",
    text: "Asesmen LSP BNSP",
    icon: "/img/course/workshop/workshop-icon-3.svg",
    subtitle: "Sertifikasi Nasional	",
  },
  {
    number: "4.0",
    text: "Kompetensi Diakui",
    icon: "/img/course/workshop/workshop-icon-4.svg",
  },
];



export const workshop_benefits: string[] = [
  "Pelatihan profesional sesuai standar industri	",
  "Uji kompetensi dengan asesor resmi LSP Digital Marketing",
  "Sertifikat Kompetensi BNSP yang diakui secara nasiona",
  "Akses materi terstruktur berbasis SKKNI & Big Data",
  "Networking dengan praktisi & peluang kerja lebih luas"
];

export const workshop_programData: Record<string, program[]> = {
  "Artificial Inteligence": [
    {
      shortTitle: "AI For Human Resource",
      title: "AI For Human Resource : Talent Management & Intelligent Workforce",
      description: "Program ini menggabungkan pelatihan AI HR dengan uji sertifikasi BNSP resmi. Peserta akan memperoleh kompetensi praktis sekaligus pengakuan nasional.",
      programduration: "Program berlangsung selama 2 hari ",
      duration: "2 hari",
      jam: "08.30 - 16.30",
      price: "",
      image: "/img/course/workshop/HumanRecource.jpg",
      targetParticipants: [
        "HR Manager",
        "Talent Acquisition",
        "L&D Specialist",
        "HR Generalist",
        "Konsultan SDM"
      ],
      tags: [
        "AI Trends",
        "AI Mindset",
        "AI Recruitment",
        "AI Learning",
        "AI Performance",
        "HR Automation"
      ],
      tujuanProgram: [
        "Memahami konsep AI dalam konteks pekerjaan HR modern.",
        "Mengidentifikasi potensi efisiensi dan automasi dalam proses HR.",
        "Memahami cara memberikan instruksi AI yang efektif",
        "Menggunakan berbagai AI tools untuk proses HR secara langsung",
      ],
      metodePembelajaran: [
        "Lecturing",
        "Case Study",
        "Diskusi Kelompok",
        "Workshop",
      ]
    },
    {
      shortTitle: "AI for Financial Excellence",
      title: "AI for Financial Excellence: Financial Automation & Intelligent Processes",
      description: "Pelatihan ini membantu profesional finance memanfaatkan AI dalam analisis dan pelaporan keuangan. Peserta akan belajar meningkatkan akurasi, efisiensi, dan kecepatan proses keuangan.",
      programduration: "Program berlangsung selama 2 hari ",
      duration: "2 hari",
      jam: "08.30 - 16.30",
      price: "",
      image: "/img/course/workshop/FinancialManager.webp",
      targetParticipants: [
        "Finance Manager",
        "Accounting Staff & Supervisor",
        "Financial Analyst",
        "Budgeting & Planning Specialist",
        "Treasury & Cashflow Officer",
        "Internal Audit / Compliance"
      ],
      tags: [
        "AI Trends",
        "AI Mindset",
        "AI Accounting",
        "AI Reporting",
        "AI FP&A",
        "Finance Automation"
      ],
      tujuanProgram: [
        "Memahami konsep AI dalam konteks pekerjaan finance modern.",
        "Mengidentifikasi potensi efisiensi dan automasi dalam proses finance.",
        "Memahami cara memberikan instruksi AI yang efektif",
        "Menggunakan berbagai AI tools untuk proses finance secara langsung"
      ],
      metodePembelajaran: [
        "Lecturing",
        "Case Study",
        "Diskusi Kelompok",
        "Workshop"
      ]
    },
    {
      shortTitle: "AI for Marketing Excellence",
      title: "AI for Marketing Excellence: Growth, Content & Customer Automation",
      description: "Program ini membekali tim marketing dengan pemanfaatan AI untuk strategi konten dan kampanye. Peserta akan memahami cara meningkatkan engagement dan efektivitas pemasaran berbasis data.",
      programduration: "Program berlangsung selama 2 hari ",
      duration: "2 hari",
      jam: "08.30 - 16.30",
      price: "",
      image: "/img/course/workshop/MarketingManager.jpg",
      targetParticipants: [
        "Marketing Manager",
        "Digital Marketing Specialist",
        "Social Media Specialist",
        "Brand & Communication",
        "Content Creator / Copywriter",
        "CRM & Customer Journey Specialist"
      ],
      tags: [
        "AI Trends",
        "AI Content",
        "AI Digital Ads",
        "AI Campaign",
        "AI Customer Insight",
        "Marketing Automation"
      ],
      tujuanProgram: [
        "Memahami konsep AI dalam konteks pekerjaan marketing.",
        "Mengidentifikasi potensi efisiensi dan automasi dalam proses marketing.",
        "Memahami cara memberikan instruksi AI yang efektif",
        "Menggunakan berbagai AI tools untuk proses marketing secara langsung"
      ],
      metodePembelajaran: [
        "Lecturing",
        "Case Study",
        "Diskusi Kelompok",
        "Workshop"
      ]
    },
    {
      shortTitle: "AI for Operational Excellence",
      title: "AI for Operational Excellence: Manufacturing Automation & Intelligent Industry",
      description: "Pelatihan ini fokus pada penerapan AI dalam operasional dan manufaktur modern. Peserta akan mempelajari cara meningkatkan produktivitas, kualitas, dan efisiensi proses industri.",
      programduration: "Program berlangsung selama 2 hari ",
      duration: "2 hari",
      jam: "08.30 - 16.30",
      price: "",
      image: "/img/course/workshop/OperationalManager.jpg",
      targetParticipants: [
        "Operation Manager",
        "Production Supervisor / Foreman",
        "Plant Manager",
        "Quality Control & QA Specialist",
        "Industrial Engineer",
        "Supply Chain & Inventory Planner",
        "Continuous Improvement / Lean Specialist"
      ],
      tags: [
        "AI Trends",
        "AI Manufacturing",
        "AI Optimization",
        "AI Quality Control",
        "AI Maintenance",
        "Supply Chain Automation"
      ],
      tujuanProgram: [
        "Memahami konsep AI dalam konteks pekerjaan operasional dan manufaktur.",
        "Mengidentifikasi potensi efisiensi dan automasi dalam proses operasional dan manufaktur.",
        "Memahami cara memberikan instruksi AI yang efektif",
        "Menggunakan berbagai AI tools untuk proses operasional dan manufaktur secara langsung"
      ],
      metodePembelajaran: [
        "Lecturing",
        "Case Study",
        "Diskusi Kelompok",
        "Workshop"
      ]
    },
    {
      shortTitle: "AI for Procurement Excellence",
      title: "AI for Procurement Excellence: Sourcing, Spend & Intelligent Assets",
      description: "Program ini membantu tim procurement memanfaatkan AI untuk pengambilan keputusan yang lebih akurat. Peserta akan belajar otomasi pengadaan dan analisis vendor berbasis data.",
      programduration: "Program berlangsung selama 2 hari ",
      duration: "2 hari",
      jam: "08.30 - 16.30",
      price: "",
      image: "/img/course/workshop/ProcurementManager.jpg",
      targetParticipants: [
        "Procurement Manager",
        "Purchasing Officer",
        "Supply Chain Specialist",
        "Asset & Facility Manager",
        "Inventory Controller",
        "Vendor Management Specialist",
        "Konsultan Supply Chain / Procurement"
      ],
      tags: [
        "AI Trends",
        "AI Sourcing",
        "AI Vendor Selection",
        "AI Spend Analytics",
        "AI Contract",
        "Procurement Automation"
      ],
      tujuanProgram: [
        "Memahami konsep AI dalam konteks pekerjaan procurement.",
        "Mengidentifikasi potensi efisiensi dan automasi dalam proses procurement.",
        "Memahami cara memberikan instruksi AI yang efektif",
        "Menggunakan berbagai AI tools untuk proses procurement secara langsung"
      ],
      metodePembelajaran: [
        "Lecturing",
        "Case Study",
        "Diskusi Kelompok",
        "Workshop"
      ]
    },
    {
      shortTitle: "AI for Corporate Communication Excellence",
      title: "AI for Corporate Communication Excellence: Content, Media & Stakeholder Intelligence",
      description: "Pelatihan ini membekali tim komunikasi dengan kemampuan AI untuk manajemen reputasi dan media. Peserta akan mempelajari analisis sentimen dan otomasi komunikasi strategis.",
      programduration: "Program berlangsung selama 2 hari ",
      duration: "2 hari",
      jam: "08.30 - 16.30",
      price: "",
      image: "/img/course/workshop/CorporateComunicationManager.webp",
      targetParticipants: [
        "Corporate Communication Manager",
        "Public Relations Specialist",
        "Media Relations Officer",
        "Digital Communication Executive",
        "Brand Communication Specialist",
        "Crisis Communication Team",
        "Konsultan atau praktisi humas"
      ],
      tags: [
        "AI Trends",
        "AI Content",
        "AI Media Monitoring",
        "AI Sentiment Analysis",
        "AI Stakeholder Mapping",
        "Communication Automation"
      ],
      tujuanProgram: [
        "Memahami konsep AI dalam konteks pekerjaan komunikasi korporat modern.",
        "Mengidentifikasi potensi efisiensi dan automasi dalam proses komunikasi korporat.",
        "Memahami cara memberikan instruksi AI yang efektif",
        "Menggunakan berbagai AI tools untuk proses komunikasi korporat secara langsung"
      ],
      metodePembelajaran: [
        "Lecturing",
        "Case Study",
        "Diskusi Kelompok",
        "Workshop"
      ],
    }
  ],
  "Paket Uji Bersertifikasi BNSP": [
    {
      shortTitle: "AI For Human Resource",
      title: "Uji Sertifikasi BNSP + AI For Human Resource : Talent Management & Intelligent Workforce",
      description: "Program ini menggabungkan pelatihan AI HR dengan uji sertifikasi BNSP resmi. Peserta akan memperoleh kompetensi praktis sekaligus pengakuan nasional.",
      programduration: "Program berlangsung selama 6 hari dengan rincian 2 hari pelatihan + 3 hari persiapan sertifikasi + 1 hari uji sertifikasi kompetensi",
      duration: "6 hari",
      jam: "08.30 - 16.30",
      price: "",
      image: "/img/course/workshop/HumanRecource.jpg",
      targetParticipants: [
        "HR Manager",
        "Talent Acquisition",
        "L&D Specialist",
        "HR Generalist",
        "Konsultan SDM"
      ],
      tags: [
        "AI Trends",
        "AI Mindset",
        "AI Recruitment",
        "AI Learning",
        "AI Performance",
        "HR Automation"
      ],
      tujuanProgram: [
        "Memahami konsep AI dalam konteks pekerjaan HR modern.",
        "Mengidentifikasi potensi efisiensi dan automasi dalam proses HR.",
        "Memahami cara memberikan instruksi AI yang efektif",
        "Menggunakan berbagai AI tools untuk proses HR secara langsung",
      ],
      metodePembelajaran: [
        "Lecturing",
        "Case Study",
        "Diskusi Kelompok",
        "Workshop",
      ],
      unitKompetensi: [
        "J.62AIN00.014.1 - Mengintegrasikan Komponen Solusi Artificial Intelligence (AI)",
        "J.62AIN00.015.1 - Memasang Solusi Artificial Intelligence (AI)",
        "J.62AIN00.016.1 - Merencanakan Perawatan Solusi Artificial Intelligence (AI)",
        "J.62AIN00.017.1 - Merawat Solusi Artificial Intelligence (AI)",
        "J.63OPR00.014.2 - Melakukan pemasukan data",
        "J.63OPR00.015.2 - Melakukan pemasukan data",
      ],
    },
    {
      shortTitle: "AI for Financial Excellence",
      title: "Uji Sertifikasi BNSP + AI for Financial Excellence: Financial Automation & Intelligent Processes",
      description: "Pelatihan ini membantu profesional finance memanfaatkan AI dalam analisis dan pelaporan keuangan. Peserta akan belajar meningkatkan akurasi, efisiensi, dan kecepatan proses keuangan.",
      programduration: "Program berlangsung selama 6 hari dengan rincian 2 hari pelatihan + 3 hari persiapan sertifikasi + 1 hari uji sertifikasi kompetensi",
      duration: "6 hari",
      jam: "08.30 - 16.30",
      price: "",
      image: "/img/course/workshop/FinancialManager.webp",
      targetParticipants: [
        "Finance Manager",
        "Accounting Staff & Supervisor",
        "Financial Analyst",
        "Budgeting & Planning Specialist",
        "Treasury & Cashflow Officer",
        "Internal Audit / Compliance"
      ],
      tags: [
        "AI Trends",
        "AI Mindset",
        "AI Accounting",
        "AI Reporting",
        "AI FP&A",
        "Finance Automation"
      ],
      tujuanProgram: [
        "Memahami konsep AI dalam konteks pekerjaan finance modern.",
        "Mengidentifikasi potensi efisiensi dan automasi dalam proses finance.",
        "Memahami cara memberikan instruksi AI yang efektif",
        "Menggunakan berbagai AI tools untuk proses finance secara langsung"
      ],
      metodePembelajaran: [
        "Lecturing",
        "Case Study",
        "Diskusi Kelompok",
        "Workshop"
      ],
      unitKompetensi: [
        "J.62AIN00.014.1 - Mengintegrasikan Komponen Solusi Artificial Intelligence (AI)",
        "J.62AIN00.015.1 - Memasang Solusi Artificial Intelligence (AI)",
        "J.62AIN00.016.1 - Merencanakan Perawatan Solusi Artificial Intelligence (AI)",
        "J.62AIN00.017.1 - Merawat Solusi Artificial Intelligence (AI)",
        "J.63OPR00.014.2 - Melakukan pemasukan data",
        "J.63OPR00.015.2 - Melakukan pemasukan data",
      ],
    },
    {
      shortTitle: "AI for Marketing Excellence",
      title: "Uji Sertifikasi BNSP + AI for Marketing Excellence: Growth, Content & Customer Automation",
      description: "Program ini membekali tim marketing dengan pemanfaatan AI untuk strategi konten dan kampanye. Peserta akan memahami cara meningkatkan engagement dan efektivitas pemasaran berbasis data.",
      programduration: "Program berlangsung selama 6 hari dengan rincian 2 hari pelatihan + 3 hari persiapan sertifikasi + 1 hari uji sertifikasi kompetensi",
      duration: "6 hari",
      jam: "08.30 - 16.30",
      price: "",
      image: "/img/course/workshop/MarketingManager.jpg",
      targetParticipants: [
        "Marketing Manager",
        "Digital Marketing Specialist",
        "Social Media Specialist",
        "Brand & Communication",
        "Content Creator / Copywriter",
        "CRM & Customer Journey Specialist"
      ],
      tags: [
        "AI Trends",
        "AI Content",
        "AI Digital Ads",
        "AI Campaign",
        "AI Customer Insight",
        "Marketing Automation"
      ],
      tujuanProgram: [
        "Memahami konsep AI dalam konteks pekerjaan marketing.",
        "Mengidentifikasi potensi efisiensi dan automasi dalam proses marketing.",
        "Memahami cara memberikan instruksi AI yang efektif",
        "Menggunakan berbagai AI tools untuk proses marketing secara langsung"
      ],
      metodePembelajaran: [
        "Lecturing",
        "Case Study",
        "Diskusi Kelompok",
        "Workshop"
      ],
      unitKompetensi: [
        "J.62AIN00.014.1 - Mengintegrasikan Komponen Solusi Artificial Intelligence (AI)",
        "J.62AIN00.015.1 - Memasang Solusi Artificial Intelligence (AI)",
        "J.62AIN00.016.1 - Merencanakan Perawatan Solusi Artificial Intelligence (AI)",
        "J.62AIN00.017.1 - Merawat Solusi Artificial Intelligence (AI)",
        "J.63OPR00.014.2 - Melakukan pemasukan data",
        "J.63OPR00.015.2 - Melakukan pemasukan data",
      ],
    },
    {
      shortTitle: "AI for Operational Excellence",
      title: "Uji Sertifikasi BNSP + AI for Operational Excellence: Manufacturing Automation & Intelligent Industry",
      description: "Pelatihan ini fokus pada penerapan AI dalam operasional dan manufaktur modern. Peserta akan mempelajari cara meningkatkan produktivitas, kualitas, dan efisiensi proses industri.",
      programduration: "Program berlangsung selama 6 hari dengan rincian 2 hari pelatihan + 3 hari persiapan sertifikasi + 1 hari uji sertifikasi kompetensi",
      duration: "6 hari",
      jam: "08.30 - 16.30",
      price: "",
      image: "/img/course/workshop/OperationalManager.jpg",
      targetParticipants: [
        "Operation Manager",
        "Production Supervisor / Foreman",
        "Plant Manager",
        "Quality Control & QA Specialist",
        "Industrial Engineer",
        "Supply Chain & Inventory Planner",
        "Continuous Improvement / Lean Specialist"
      ],
      tags: [
        "AI Trends",
        "AI Manufacturing",
        "AI Optimization",
        "AI Quality Control",
        "AI Maintenance",
        "Supply Chain Automation"
      ],
      tujuanProgram: [
        "Memahami konsep AI dalam konteks pekerjaan operasional dan manufaktur.",
        "Mengidentifikasi potensi efisiensi dan automasi dalam proses operasional dan manufaktur.",
        "Memahami cara memberikan instruksi AI yang efektif",
        "Menggunakan berbagai AI tools untuk proses operasional dan manufaktur secara langsung"
      ],
      metodePembelajaran: [
        "Lecturing",
        "Case Study",
        "Diskusi Kelompok",
        "Workshop"
      ],
      unitKompetensi: [
        "J.62AIN00.014.1 - Mengintegrasikan Komponen Solusi Artificial Intelligence (AI)",
        "J.62AIN00.015.1 - Memasang Solusi Artificial Intelligence (AI)",
        "J.62AIN00.016.1 - Merencanakan Perawatan Solusi Artificial Intelligence (AI)",
        "J.62AIN00.017.1 - Merawat Solusi Artificial Intelligence (AI)",
        "J.63OPR00.014.2 - Melakukan pemasukan data",
        "J.63OPR00.015.2 - Melakukan pemasukan data",
      ],
    },
    {
      shortTitle: "AI for Procurement Excellence",
      title: "Uji Sertifikasi BNSP + AI for Procurement Excellence: Sourcing, Spend & Intelligent Assets",
      description: "Program ini membantu tim procurement memanfaatkan AI untuk pengambilan keputusan yang lebih akurat. Peserta akan belajar otomasi pengadaan dan analisis vendor berbasis data.",
      programduration: "Program berlangsung selama 6 hari dengan rincian 2 hari pelatihan + 3 hari persiapan sertifikasi + 1 hari uji sertifikasi kompetensi",
      duration: "6 hari",
      jam: "08.30 - 16.30",
      price: "",
      image: "/img/course/workshop/ProcurementManager.jpg",
      targetParticipants: [
        "Procurement Manager",
        "Purchasing Officer",
        "Supply Chain Specialist",
        "Asset & Facility Manager",
        "Inventory Controller",
        "Vendor Management Specialist",
        "Konsultan Supply Chain / Procurement"
      ],
      tags: [
        "AI Trends",
        "AI Sourcing",
        "AI Vendor Selection",
        "AI Spend Analytics",
        "AI Contract",
        "Procurement Automation"
      ],
      tujuanProgram: [
        "Memahami konsep AI dalam konteks pekerjaan procurement.",
        "Mengidentifikasi potensi efisiensi dan automasi dalam proses procurement.",
        "Memahami cara memberikan instruksi AI yang efektif",
        "Menggunakan berbagai AI tools untuk proses procurement secara langsung"
      ],
      metodePembelajaran: [
        "Lecturing",
        "Case Study",
        "Diskusi Kelompok",
        "Workshop"
      ],
      unitKompetensi: [
        "J.62AIN00.014.1 - Mengintegrasikan Komponen Solusi Artificial Intelligence (AI)",
        "J.62AIN00.015.1 - Memasang Solusi Artificial Intelligence (AI)",
        "J.62AIN00.016.1 - Merencanakan Perawatan Solusi Artificial Intelligence (AI)",
        "J.62AIN00.017.1 - Merawat Solusi Artificial Intelligence (AI)",
        "J.63OPR00.014.2 - Melakukan pemasukan data",
        "J.63OPR00.015.2 - Melakukan pemasukan data",
      ],
    },
    {
      shortTitle: "AI for Corporate Communication Excellence",
      title: "Uji Sertifikasi BNSP +  AI for Corporate Communication Excellence: Content, Media & Stakeholder Intelligence",
      description: "Pelatihan ini membekali tim komunikasi dengan kemampuan AI untuk manajemen reputasi dan media. Peserta akan mempelajari analisis sentimen dan otomasi komunikasi strategis.",
      programduration: "Program berlangsung selama 6 hari dengan rincian 2 hari pelatihan + 3 hari persiapan sertifikasi + 1 hari uji sertifikasi kompetensi",
      duration: "6 hari",
      jam: "08.30 - 16.30",
      price: "",
      image: "/img/course/workshop/CorporateComunicationManager.webp",
      targetParticipants: [
        "Corporate Communication Manager",
        "Public Relations Specialist",
        "Media Relations Officer",
        "Digital Communication Executive",
        "Brand Communication Specialist",
        "Crisis Communication Team",
        "Konsultan atau praktisi humas"
      ],
      tags: [
        "AI Trends",
        "AI Content",
        "AI Media Monitoring",
        "AI Sentiment Analysis",
        "AI Stakeholder Mapping",
        "Communication Automation"
      ],
      tujuanProgram: [
        "Memahami konsep AI dalam konteks pekerjaan komunikasi korporat modern.",
        "Mengidentifikasi potensi efisiensi dan automasi dalam proses komunikasi korporat.",
        "Memahami cara memberikan instruksi AI yang efektif",
        "Menggunakan berbagai AI tools untuk proses komunikasi korporat secara langsung"
      ],
      metodePembelajaran: [
        "Lecturing",
        "Case Study",
        "Diskusi Kelompok",
        "Workshop"
      ],
      unitKompetensi: [
        "J.62AIN00.014.1 - Mengintegrasikan Komponen Solusi Artificial Intelligence (AI)",
        "J.62AIN00.015.1 - Memasang Solusi Artificial Intelligence (AI)",
        "J.62AIN00.016.1 - Merencanakan Perawatan Solusi Artificial Intelligence (AI)",
        "J.62AIN00.017.1 - Merawat Solusi Artificial Intelligence (AI)",
        "J.63OPR00.014.2 - Melakukan pemasukan data",
        "J.63OPR00.015.2 - Melakukan pemasukan data",
      ],
    }
  ],
}


export const Tabs = Object.keys(workshop_programData);

export const procedure_steps: Step[] = [
  {
    number: 1,
    title: "Pilih Program",
    description:
      "Peserta wajib memilih program dan menuju formulir pendaftaran",
  },
  {
    number: 2,
    title: "Isi Formulir",
    description:
      "Peserta wajib melengkapi data diri dan pilihan program",
  },
  {
    number: 3,
    title: "Pembayaran Program",
    description:
      "Di formulir pendaftaran, pilih PAID, transfer ke BCA 8833445888 a.n PT Accelist Edukasi Indonesia dan upload bukti transfer",
  },
  {
    number: 4,
    title: "Tunggu dihubungi oleh panitia",
    description:
      "Setelah itu, cek Email dan WhatsApp kamu secara berkala",
  },
];

export const program_trainer: ProgramTrainer[] = [
  {
    fullName: "Matius Kelvin, S.Kom., M.M., CT",
    trainerImageSrc: "/img/program/trainerBNSP/Matius Kelvin, S.Kom., M.M., CT.png",
    sertificateSrc: "/img/program/trainerBNSP/Sertifikat-Matius.png",
    title: "Trainer Bersertifikasi BNSP Metodologi Penelitian",
    description: [
      "P.854900.011.01 - Menyusun Program Pelatihan",
      "P.854900.013.01 - Mendesain Media Pembelajaran",
      "P.854900.016.01 - Merencanakan Penyajian Materi",
      "P.854900.017.01 - Melaksanakan Pelatihan Tatap Muka",
    ]
  },
  {
    fullName: "Markus Fresnel, S.Kom., M.M., CT",
    trainerImageSrc: "/img/program/trainerBNSP/Markus Fresnel, S.Kom., M.M., CT.png",
    sertificateSrc: "/img/program/trainerBNSP/Sertifikat-Markus.png",
    title: "Trainer Bersertifikasi BNSP Metodologi Penelitian",
    description: [
      "P.854900.011.01 - Menyusun Program Pelatihan",
      "P.854900.013.01 - Mendesain Media Pembelajaran",
      "P.854900.016.01 - Merencanakan Penyajian Materi",
      "P.854900.017.01 - Melaksanakan Pelatihan Tatap Muka",
    ]
  },
  {
    fullName: "Farid Afandy, S.Kom., CI",
    trainerImageSrc: "/img/program/trainerBNSP/Farid Afandy, S.Kom., CI.png",
    sertificateSrc: "/img/program/trainerBNSP/Sertifikat-Farid.png",
    title: "Trainer Bersertifikasi BNSP Instruktur",
    description: [
      "N.78PS02.039.2 – Mengelola Bahan Pelatihan Kerja",
      "N.78PS02.044.1 – Memelihara Fasilitas Pelatihan Kerja", "N.78PS02.039.2 – Mengelola Bahan Pelatihan Kerja",
      "N.78PS02.044.1 – Memelihara Fasilitas Pelatihan Kerja",
      "N.78PS02.041.2 – Mengelola Peralatan Pelatihan Kerja",
      "N.78PS02.028.2 – Melaksanakan Pelatihan Tatap Muka",
      "N.78PS02.061.1 – Melakukan Komunikasi di Tempat Kerja",
      "N.78PS02.019.2 – Merencanakan Penyajian Materi Pelatihan Kerja",
      "N.78PS02.011.1 – Mengidentifikasi Standar Kompetensi dan Kualifikasi Kerja",
      "N.78PS02.075.1 – Menilai Kemajuan Kompetensi Peserta Pelatihan Secara Individu",
      "N.78PS02.035.1 – Menerapkan Kesehatan dan Keselamatan Kerja (K3) di Lembaga Pelatihan Kerja",
    ]
  },
  {
    fullName: "Roberto, S.Kom., CSE",
    trainerImageSrc: "/img/program/trainerBNSP/Roberto,S.Kom., CSE.png",
    sertificateSrc: "/img/program/trainerBNSP/Sertifikat-Roberto.png",
    title: "Trainer Bersertifikasi BNSP Software Engineer",
    description: [
      "J.62SAD00.011.1 – Merancang Struktur Perangkat Lunak",
      "J.62SAD00.012.1 – Merancang Komponen Perangkat Lunak",
      "J.62SAD00.008.1 – Menyusun Spesifikasi Kebutuhan Perangkat Lunak",
      "J.62SAD00.002.1 – Melakukan Identifikasi Sumber Kebutuhan Perangkat Lunak",
      "J.62SAD00.004.1 – Melakukan Klasifikasi dan Alokasi Kebutuhan Perangkat Lunak",
      "J.62SAD00.006.1 – Membuat Kebutuhan Dokumentasi Spesifikasi Perangkat Lunak",
    ]
  },
]